import type { AppLocale } from "@metaadsmanager/tk-master-contracts";

/**
 * Runtime UI message catalog (zh-CN + en-US).
 *
 * Edit here for all `useAppI18n()` / `LocaleProvider` copy.
 * Guide: .cursor/docs/i18n/runtime-messages.md · verify: pnpm exec vitest run src/components/providers/locale-provider.test.tsx
 */

const zhCN = {
  bulkOperations: {
    materialName: "素材", materialBudget: "每个素材预算", noActiveBoost: "没有进行中的加热",
    selectCampaign: "请选择广告系列",
    error_creative_target_ambiguous: "素材的投放关联不唯一，无法安全确定加热目标。",
    error_too_many_targets: "操作项超过 100 个，请减少所选素材后重试。",
    campaignStatus: "状态", currentRoi: "当前目标 ROI", executionResult: "结果", campaignEnabled: "已开启", campaignPaused: "已暂停",
    error_test_campaign_only: "本地测试仅允许操作 9.07豚豚抓取TEST，请返回列表重新选择。",
    creativeActionBar: "素材批量操作",
    loadingTargets: "正在读取可操作的广告系列…",
    loadingSessions: "正在读取可取消的加热记录…",
    error_session_query_failed: "加热记录读取失败，请刷新后重试。",
    error_rate_limited: "操作过于频繁，请稍后重试。",
    error_validation_failed: "操作目标校验失败，请刷新后重新选择。",
    mock: "模拟数据 · 不会修改真实广告", disabled: "批量写操作尚未启用",
    previewOnly: "批量执行服务尚未启用。你可以查看和填写操作参数，但暂时无法提交。",
    enable: "启动", pause: "暂停", set_roi: "修改目标 ROI", create_boost: "加热素材", cancel_boost: "取消加热",
    title: "确认批量操作", selected: "已选择 {count} 项", account: "广告账户", campaign: "广告系列", product: "商品", video: "视频",
    budget: "每个加热项预算", roi: "新的目标 ROI", oldRoi: "原目标 ROI", end: "结束时间（可选，按各账户时区）", clearEnd: "清除结束时间", timezone: "账户时区", currency: "币种", total: "预算合计",
    confirm: "确认提交", submitting: "正在提交", close: "关闭", remove: "移除", clear: "清空选择",
    choose: "选择要操作的关联", chooseSession: "选择要取消的加热 session", noTargets: "没有可用操作项，请检查资源关联或授权。", ineligible: "当前状态不适用此操作",
    readOnly: "当前权限或工作空间状态不允许写操作", limit: "一次最多 100 个操作项", invalidValue: "请输入有效的正数",
    budgetMinimum: "USD 加热预算至少为 10；其他币种最低值尚未核实，真实模式不可启用",
    budgetNote: "同一数值按各账户币种应用；加热预算独立于广告系列预算，不计入 ROI 保护。",
    immediate: "立即开始；结束时间按每个账户时区解释。", results: "批量操作记录", queued: "排队中", running: "执行中", succeeded: "成功", failed: "失败", partial: "部分成功", unknown: "待核实",
    unknownNote: "请求结果不确定，已停止自动重试。请核实上游结果后再处理。", retry: "重试明确失败项", refresh: "刷新结果", requestError: "请求失败：{code}", none: "暂无加热 session", noSelection: "请先选择至少一个操作项",
    scopeNote: "翻页保留选择，切换筛选条件清空。", sessions: "加热 session", active: "加热中", cancelled: "已取消", ended: "已结束",
    mockTitle: "TikTok 批量操作模拟工作台", campaigns: "广告系列", creatives: "素材", previous: "上一页", next: "下一页", selectPage: "选择当前页", search: "搜索", notMock: "此页面仅在本地模拟模式下可用",
    error_forbidden: "无操作权限或工作空间已暂停", error_stale_authorization: "授权已变化，请刷新后重新选择", error_roi_unsupported: "该系列不支持目标 ROI", error_overlapping_session: "存在重叠加热或待处理创建任务", error_campaign_busy: "该系列有正在执行或结果待核实的操作，本次未执行，请核实后重试", error_campaign_capacity: "该系列已达到 100 个加热视频限制", error_invalid_end_time: "结束时间无效、已过期或时区时间不唯一", error_video_required: "只有关联商品的视频可以加热", error_creative_ineligible: "素材当前状态不可加热", error_session_unavailable: "该加热 session 已不可取消", error_budget_below_minimum: "预算低于已知最低值", error_retry_not_allowed: "只能重试明确失败的操作项", error_idempotency_conflict: "该提交标识已用于其他内容", error_upstream_rejected: "上游拒绝该操作", error_outcome_unknown: "上游执行结果待核实", error_lease_expired: "执行租约过期，结果待核实", error_writes_disabled: "真实写操作尚未启用", error_request_failed: "请求未完成", error_unavailable: "资源已不可用",
  },
  meta: {
    description: "面向增长团队的 TikTok Ads 投放工作台",
    title: "TK-Master · TikTok Ads 投放工作台",
  },
  language: {
    label: "切换语言",
    localeLabel: "语言",
    localeZh: "简体中文",
    localeEn: "English",
  },
  common: {
    allTime: "全部时间",
    cancel: "取消",
    clearInput: "清空输入",
    clearOptionSearch: "清空选项搜索",
    close: "关闭",
    exitFullScreen: "退出全屏",
    fullScreen: "全屏",
    noMatchingOptions: "没有匹配的选项",
    noRequestId: "暂无请求 ID",
    notAvailable: "—",
    retry: "重试",
    search: "搜索",
    searchOptions: "搜索选项",
    system: "系统",
    tableEmpty: "暂无数据",
    tableError: "加载失败，请重试。",
    tableLoading: "加载中…",
    tablePageSize: "每页条数",
    tablePageSizeAria: "每页显示条数",
    tablePageSizeOption: "每页{count}条",
    tablePaginationAria: "表格分页",
    tablePaginationNext: "下一页",
    tablePaginationPrevious: "上一页",
    tableResizeColumn: "调整列宽",
    tableRetry: "重试",
    tableSelectAll: "全选",
    tableActions: "操作",
    tableSelectRow: "选择行",
    tableShowing: "显示第 {from}–{to} 条，共 {total} 条",
    tableShowingApproximate: "显示第 {from}–{to} 条，约 {total} 条",
    tableShowingRange: "显示第 {from}–{to} 条",
    export: "导出",
    exportModalTitle: "导出列表",
    exportModalDescription: "将导出已选的 {count} 个列表项为 CSV（UTF-8，可用 Excel 打开）。",
    exportModalClose: "关闭",
    exportConfirm: "导出 CSV",
    exportSuccess: "已导出 {count} 个列表项",
    exportEmptySelection: "请先勾选要导出的列表项。",
    exportFailed: "导出失败，请稍后重试。",
    imageLoadError: "图片加载失败，点击重试",
  },
  errors: {
    networkTitle: "网络连接中断",
    networkDetail: "暂时无法连接服务器。请检查网络后重试，或先返回首页。",
    unauthorizedTitle: "登录状态已失效",
    unauthorizedDetail: "请重新登录以继续访问工作台。",
    forbiddenTitle: "没有访问权限",
    forbiddenDetail: "当前账号无法执行此操作。如需权限，请联系工作空间所有者。",
    notFoundTitle: "找不到请求的内容",
    notFoundDetail: "该内容可能已被删除或链接已过期。",
    unavailableTitle: "服务暂时不可用",
    unavailableDetail: "服务器暂时无法响应，请稍后重试。",
    rateLimitedTitle: "请求过于频繁",
    rateLimitedDetail: "操作触发限流，请稍后再试。",
    workspacePausedTitle: "工作空间已暂停",
    workspacePausedDetail: "此工作空间已被暂停，恢复前无法继续操作。",
    retry: "重试",
    refresh: "刷新",
    signIn: "重新登录",
    goBack: "返回",
    goHome: "回到首页",
    requestIdLabel: "请求 ID",
  },
  validation: {
    invalid: "输入内容无效",
    display_name: {
      min: "显示名称至少需要 2 个字符",
      max: "显示名称不能超过 50 个字符",
    },
    email: { invalid: "请输入有效的邮箱地址", max: "邮箱地址过长" },
    password: {
      required: "请输入密码",
      min: "密码至少需要 8 个字符",
      max: "密码不能超过 32 个字符",
      letter: "密码至少需要包含一个字母",
      number: "密码至少需要包含一个数字",
    },
    confirm_password: { mismatch: "两次输入的密码不一致" },
    current_password: { required: "请输入当前密码" },
    workspace_name: {
      min: "工作空间名称至少需要 2 个字符",
      max: "工作空间名称不能超过 80 个字符",
    },
    workspace_role_name: {
      min: "角色名称至少需要 2 个字符",
      max: "角色名称不能超过 50 个字符",
    },
    workspace_role_description: {
      max: "角色描述不能超过 200 个字符",
    },
    status_reason: {
      min: "操作原因至少需要 5 个字符",
      max: "操作原因不能超过 500 个字符",
    },
    invitation_note: {
      min: "邀请备注至少需要 1 个字符",
      max: "邀请备注不能超过 80 个字符",
    },
    invitation_ref: { invalid: "邀请链接无效" },
  },
  apiErrors: {
    request: {
      validation: "请检查填写内容",
      query_validation: "请检查筛选条件",
      origin_untrusted: "无法验证请求来源，请刷新页面后重试",
      route_not_found: "找不到请求的内容",
    },
    auth: { unauthorized: "登录状态已失效，请重新登录" },
    authorization: {
      admin_forbidden: "当前账号没有平台管理权限",
      workspace_forbidden: "当前账号没有执行该操作的权限",
    },
    workspace: {
      not_found: "工作空间不存在",
      paused: "工作空间已暂停",
      data_unavailable: "工作空间数据暂时不可用，请稍后再试",
      super_admin_forbidden: "平台管理员不能创建或加入工作空间",
    },
    filter_view: {
      not_found: "筛选视图不存在",
      name_conflict: "已存在同名的筛选视图",
      limit_reached: "筛选视图数量已达上限，请先删除不再使用的视图",
      forbidden: "只有创建者可以管理该团队筛选视图",
    },
    profile: { unavailable: "用户资料暂时不可用，请稍后再试" },
    avatar: {
      invalid_image: "请选择有效的 JPEG、PNG 或 WebP 图片",
      too_large: "头像不能超过 2 MiB",
      unavailable: "头像服务暂时不可用，请稍后再试",
    },
    invitation: {
      invalid: "邀请不存在或已失效",
      link_invalid: "邀请链接无效",
      expired: "邀请已过期",
      not_found: "邀请不存在",
      membership_conflict: "该账号已归属其他工作空间",
      accepted_cannot_regenerate: "已接受的邀请不能重新生成",
      state_changed: "邀请状态已发生变化",
      cannot_copy: "邀请当前状态不可复制",
      cannot_revoke: "邀请当前状态不可撤销",
    },
    referral: {
      invalid: "邀请链接无效",
      revoked: "邀请链接已撤销",
      unavailable: "邀请链接暂时不可用",
    },
    member: {
      not_found: "成员不存在",
      owner_cannot_remove: "所有者账号不能被移除",
      owner_permissions_locked: "所有者权限不能修改",
    },
    workspace_role: {
      not_found: "角色不存在",
      system_locked: "内置角色不能修改或删除",
      name_conflict: "已存在同名角色",
      assigned_cannot_delete: "请先改派该角色下的成员",
      owner_cannot_assign: "所有者角色不能改派",
      disabled_cannot_edit: "已停用角色不能编辑，请先启用",
      disabled_cannot_assign: "已停用角色不能分配，请先启用",
    },
    tiktok: {
      not_connected: "当前工作空间尚未连接 TikTok",
      authorization_unavailable: "TikTok 授权暂时不可用，请稍后重试",
      authorization_not_completed: "TikTok 授权未完成，请重新发起连接并确认授权请求",
      permission_missing: "当前 TikTok 授权没有访问该资源的权限，请检查应用和授权账号权限后重新连接",
      manual_sync_capacity: "手动同步任务已满，请稍后重试",
      manual_sync_cooldown: "该资源处于手动同步冷却期，请稍后重试",
      rate_limited: "TikTok 请求过于频繁，请稍后重试",
      response_invalid: "TikTok 返回了无法识别的数据，请重试；如问题持续，请使用请求 ID 排查",
      sync_unavailable: "TikTok 同步暂时不可用，请稍后重试",
      sync_timeout: "TikTok 未在等待时间内响应，请重试",
      upstream_unavailable: "TikTok 暂时不可用，请稍后重试",
      reauthorization_required: "TikTok 授权已失效，请重新连接",
      sync_in_progress: "TikTok 正在同步，请稍后再试",
    },
    user: { not_found: "用户不存在" },
    database: {
      conflict: "数据已发生变化，请刷新后重试",
      retry: "当前操作繁忙，请稍后重试",
    },
    service: { unavailable: "服务暂时不可用，请稍后再试" },
  },
  authErrors: {
    EMAIL_NOT_VERIFIED: "邮箱尚未确认，请先完成邮箱验证",
    FAILED_TO_CREATE_SESSION: "暂时无法登录，请稍后重试",
    FAILED_TO_CREATE_USER: "暂时无法创建账号，请稍后重试",
    INVALID_EMAIL: "邮箱格式不正确",
    INVALID_EMAIL_OR_PASSWORD: "邮箱或密码错误，请重新输入",
    INVALID_PASSWORD: "密码不正确",
    INVALID_TOKEN: "链接无效或已过期，请重新发起请求",
    PASSWORD_TOO_LONG: "密码长度超出限制",
    PASSWORD_TOO_SHORT: "密码长度不足",
    TOKEN_EXPIRED: "链接无效或已过期，请重新发起请求",
    USER_ALREADY_EXISTS: "该邮箱已注册，请直接登录或更换邮箱",
    USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "该邮箱已注册，请直接登录或更换邮箱",
    REFERRAL_INVALID: "邀请链接无效，本次没有创建账号。请向邀请人确认后再试。",
    REFERRAL_REVOKED: "邀请链接已撤销，本次没有创建账号。请向邀请人确认后再试。",
    REFERRAL_UNAVAILABLE: "邀请链接暂时不可用，本次没有创建账号。请稍后再试。",
    REFERRAL_SERVICE_UNAVAILABLE: "暂时无法确认邀请链接，本次没有创建账号。请稍后重试。",
  },
  labels: {
    workspaceRole: { member: "成员", owner: "管理员" },
    workspaceStatus: { active: "正常", paused: "已暂停" },
    adminUserStatus: { active: "正常", banned: "已封禁", unconfirmed: "待确认" },
    platformRole: { super_admin: "平台管理员", tenant: "工作空间用户" },
    invitationStatus: {
      accepted: "已接受",
      expired: "已过期",
      pending: "待接受",
      revoked: "已撤销",
    },
    referralStatus: {
      registered: "已注册",
      workspace_created: "已创建工作空间",
    },
    auditAction: {
      workspace_created: "创建工作空间",
      workspace_invitation_created: "创建邀请",
      workspace_invitation_regenerated: "重新生成邀请",
      workspace_invitation_revealed: "查看邀请链接",
      workspace_invitation_revoked: "撤销邀请",
      workspace_member_joined: "成员加入",
      workspace_member_removed: "移除成员",
      workspace_role_created: "创建角色",
      workspace_role_updated: "更新角色",
      workspace_role_deleted: "删除角色",
      workspace_role_enabled: "启用角色",
      workspace_role_disabled: "停用角色",
      workspace_member_role_changed: "修改成员角色",
      workspace_member_permission_granted: "增授成员权限",
      workspace_member_permission_revoked: "撤销成员增授",
      workspace_paused: "暂停工作空间",
      workspace_resumed: "恢复工作空间",
      workspace_tiktok_authorized: "授权 TikTok",
      workspace_tiktok_business_centers_synced: "同步 Business Center",
      workspace_tiktok_advertiser_accounts_synced: "同步广告账户",
      workspace_tiktok_stores_synced: "同步店铺",
      workspace_tiktok_creative_assets_synced: "同步创意素材",
      workspace_tiktok_campaigns_synced: "同步 Campaign",
      workspace_tiktok_campaign_reports_synced: "同步 Campaign 报表",
    },
    auditResult: { failed: "失败", noop: "无变化", success: "成功" },
  },
  status: {
    defaultTitle: "正在进入工作台",
    defaultDetail: "正在加载你的工作空间…",
  },
  auth: {
    login: {
      eyebrow: "GMV MAX COMMAND CENTER",
      title: "登录 GMV MAX 数据工作台",
      description: "查看 GMV、ROAS、广告花费与订单趋势。",
      mobileSummary: "GMV、ROAS 与订单趋势，集中在一个增长工作台",
      terminalAria: "GMV MAX 演示数据预览",
      demoLabel: "GMV MAX · 演示数据",
      terminalTitle: "全链路成交表现",
      period: "过去 7 天",
      marketUs: "US",
      marketSea: "SEA",
      marketJp: "JP",
      gmv: "GMV",
      gmvTrend: "较前 7 天 +18.6%",
      roas: "ROAS",
      roasTrend: "提升 0.42",
      orders: "订单量",
      ordersTrend: "+12.4%",
      chartTitle: "广告花费与 GMV",
      chartDetail: "柱：花费 · 面积：日 GMV — 投入与成交同向增长",
      chartLegendSpend: "广告花费",
      chartLegendGmv: "日 GMV",
      previewAria:
        "静态演示预览：过去 7 天广告花费与日 GMV，累计 GMV 128,640 美元，ROAS 4.86，订单 3,284",
      dataNote: "合成数据 · 不关联任何广告账户",
      noAccount: "还没有账号？",
      createAccount: "创建账号",
      email: "邮箱",
      password: "密码",
      forgotPassword: "忘记密码？",
      submit: "进入工作台",
      failed: "登录失败，请稍后重试",
    },
    register: {
      requiredHint: "* 为必填项",
      requirementLength: "8–32 个字符",
      requirementLetter: "至少一个字母",
      requirementNumber: "至少一个数字",
      invalidInvitation: "邀请链接无效，请联系所有者重新生成",
      expiredInvitation: "邀请已过期，请联系所有者重新生成",
      unavailableInvitation: "邀请已撤销或已被使用",
      previewFailed: "邀请链接无效，请联系所有者重新生成",
      createFailed: "暂时无法创建账号，请稍后重试",
      invitationCreateFailed: "暂时无法创建账号。请稍后重试，或使用已有账号登录。",
      confirmTitle: "确认你的邮箱",
      invitationTitle: "接受工作空间邀请",
      title: "创建团队账号",
      confirmInvitationDescription: "完成邮箱验证后，将继续把这个账号加入 {workspace}。",
      targetWorkspace: "目标工作空间",
      confirmDescription: "完成邮箱验证后，即可创建第一个工作空间。",
      invitationDescription: "受邀加入 {workspace}。可以注册新账号，也可以使用已确认邮箱登录。",
      invitationFallbackDescription: "你可以注册新账号，或使用已有账号继续处理邀请。",
      description: "创建账号后，即可设置工作空间并邀请团队成员。",
      hasAccount: "已有账号？",
      backToLogin: "返回登录",
      sendingTitle: "正在向 {email} 发送验证邮件",
      sendingDetail: "请稍候，不要重复提交。",
      sentTitle: "验证邮件已发送至 {email}",
      sentInvitationDetail: "完成邮箱验证后，将继续接受工作空间邀请。",
      sentDetail: "请打开邮件中的链接完成验证。如果没有收到，请检查垃圾邮件。",
      changeEmail: "更换邮箱",
      backAndChangeEmail: "返回并更换邮箱",
      resend: "再次发送",
      resending: "发送中",
      resendCooldown: "{seconds} 秒后可重发",
      resentDetail: "验证邮件已重新发送，请检查收件箱和垃圾邮件。",
      sendFailedTitle: "验证邮件暂未发送",
      sendFailedDetail: "请重试发送验证邮件，或更换邮箱。",
      continueAccountTitle: "继续使用当前账号",
      continueAccountDetail: "你可以使用当前账号接受这份邀请。",
      continueAccount: "使用当前账号继续",
      invitationBadge: "{workspace} 邀请",
      invitationExpiry: "此邀请将于 {date} 到期，仅可使用一次",
      referralTitle: "你正在通过邀请链接注册",
      referralDetail: "完成注册后会计入邀请人的记录。确认邮箱后，你将创建自己的工作空间。",
      referralChecking: "正在确认邀请链接",
      referralCheckFailed: "暂时无法确认邀请链接。注册时仍会带上这条链接。",
      referralInvalid: "邀请链接无效。请向邀请人确认，或选择不使用这条链接注册。",
      referralRevoked: "邀请链接已撤销。请向邀请人确认，或选择不使用这条链接注册。",
      referralUnavailable: "邀请链接暂时不可用。请向邀请人确认，或选择不使用这条链接注册。",
      referralContinue: "不使用邀请链接，直接注册",
      referralConflict: "这个链接同时包含团队邀请和个人推荐。请向邀请人确认要用哪一种。",
      referralConflictContinue: "不使用这些链接，直接注册",
      displayName: "显示名称",
      displayNamePlaceholder: "例如：林小满",
      workEmail: "工作邮箱",
      password: "密码",
      confirmPassword: "确认密码",
      createAndJoin: "创建账号并加入",
      createOwner: "创建账号",
      checkInvitation: "检查邀请",
    },
    confirm: {
      title: "请确认邮箱",
      description: "我们已经把确认链接发送到你的收件箱。",
      detail: "请打开邮件中的验证链接完成确认。如果没有收到，请检查垃圾邮件。",
      backToLogin: "返回登录",
    },
    forgot: {
      failed: "暂时无法发送重置邮件，请稍后再试",
      title: "找回访问权限",
      description: "输入注册邮箱，我们会发送一次性密码重置链接。",
      backToLogin: "返回登录",
      sentTitle: "重置邮件已发送",
      sentDetail: "如果该邮箱已注册，你会收到一封密码重置邮件。",
      email: "注册邮箱",
      submit: "发送重置链接",
    },
    updatePassword: {
      invalidLink: "重置链接无效或已过期，请重新发起请求。",
      title: "设置新的密码",
      description: "建议使用未在其他服务使用过的强密码。",
      backToLogin: "返回登录",
      successTitle: "密码更新完成",
      successDetail: "现在可以使用新密码返回工作台。",
      password: "新密码",
      confirmPassword: "确认新密码",
      submit: "更新密码",
    },
    callback: {
      invalidLink: "确认链接无效或已过期，请重新发起请求。",
      readFailed: "暂时无法读取账号状态，请稍后重试。",
      loadingTitle: "正在验证邮箱",
      loadingDetail: "验证完成后将自动继续。",
      failedTitle: "无法验证邮箱",
      failedDescription: "请重新打开邮件中的验证链接。",
    },
    invitation: {
      retryable: "暂时无法加入。邀请仍然有效，请稍后重试。",
      loading: "正在接受邀请",
      terminal: "无法接受邀请",
      failed: "暂时无法加入工作空间",
      description: "我们会确认邀请是否有效，并将你加入工作空间。",
      invalid: "邀请已失效",
      retryLater: "稍后可以重试",
      retry: "重试加入",
      onboarding: "创建自己的工作空间",
      flash: {
        INVITATION_EXPIRED: "邀请已过期。你可以创建自己的工作空间，或使用新的邀请链接。",
        INVITATION_INVALID: "邀请已撤销、已被其他账号使用或不存在。你可以创建自己的工作空间，或使用新的邀请链接。",
        MEMBERSHIP_CONFLICT: "此账号已加入其他工作空间，无法接受当前邀请。",
        SERVICE_UNAVAILABLE: "服务暂时不可用。邀请仍然有效，请稍后重试。",
        WORKSPACE_PAUSED: "工作空间当前已暂停。恢复后可以使用同一邀请重试。",
      },
    },
    form: {
      show: "显示{field}",
      hide: "隐藏{field}",
      passwordRequirements: "密码要求",
      requirementMet: "已满足：{requirement}",
      requirementUnmet: "未满足：{requirement}",
      actionFailed: "操作未完成",
      invitationNotAccepted: "邀请未接受",
    },
  },
  shell: {
    workspaceNavigation: {
      overview: "首页",
      campaigns: "广告系列",
      audiences: "受众",
      businessCenters: "商务中心",
      advertiserAccounts: "广告账户",
      stores: "店铺列表",
      creativeAssets: "广告创意",
      tools: "工具",
      profitCalculator: "利润计算器",
      roiCalculator: "ROI 计算系统",
      teamManagement: "团队管理",
      members: "成员管理",
      roles: "角色管理",
      audit: "审计",
      integrations: "账户授权",
      referrals: "邀请新用户",
      settings: "用户设置",
    },
    adminNavigation: { workspaces: "工作空间", users: "用户", audit: "操作记录" },
    platformManagement: "平台管理",
    campaignOperations: "投放运营",
    mainNavigation: "主导航",
    workspace: "工作空间",
    workspaceNavigationLabel: "工作空间导航",
    platformNavigationLabel: "平台管理导航",
    platformAdmin: "平台管理员",
    signOutFailed: "退出失败，请重试",
    collapseSidebar: "收起侧边栏",
    openNavigation: "打开导航",
    toggleSidebar: "切换侧边栏",
    brandTagline: "投放工作台",
    help: "帮助",
    notifications: "通知",
    toggleTheme: "切换主题",
    accountSettings: "账户设置",
    accountMenu: "账户菜单",
    accountRole: "{workspace} · {role}",
    signOut: "退出登录",
    switchWorkspace: "切换工作空间",
  },
  routeGuard: {
    unavailableTitle: "暂时无法加载工作空间",
    unavailableDetail: "请检查网络连接后重试。如果问题持续，请联系管理员。",
    reconnect: "重试",
    switching: "正在打开工作空间",
    deniedTitle: "需要申请权限才能访问",
    deniedDetail:
      "当前账户没有打开此页面所需的权限。请向工作空间管理员申请对应权限后再打开。",
    goToSettings: "账户设置",
  },
  paused: {
    eyebrow: "工作空间已暂停",
    title: "此工作空间已暂停",
    blockedTitle: "平台管理员已暂停此工作空间",
    detail: "恢复后，尚未过期的邀请仍可继续使用。",
    audit: "查看审计记录",
    accountSettings: "账户设置",
    signOut: "退出登录",
  },
  onboarding: {
    progress: "工作空间设置进度",
    stepTitle: "工作空间",
    stepDescription: "命名与创建",
    eyebrow: "创建工作空间",
    title: "设置你的工作空间",
    description: "在这里集中管理广告数据、团队成员和权限。创建后，你将成为所有者。",
    isolationTitle: "仅成员可访问",
    isolationDetail: "不同工作空间的数据相互隔离",
    collaborationTitle: "团队协作就绪",
    collaborationDetail: "所有者可按团队职责创建并分配自定义角色",
    accountSettings: "账户设置",
    cardTitle: "命名工作空间",
    cardDescription: "推荐使用品牌、业务线或地区名称。",
    createFailed: "创建工作空间失败，请稍后重试",
    field: "工作空间名称",
    placeholder: "例如：北极星增长团队",
    submit: "创建并进入概览",
  },
  settings: {
    title: "账户设置",
    subtitle: "管理您的个人资料、登录凭证、安全验证",
    modify: "修改",
    saved: "已保存",
    avatar: {
      title: "头像",
      description: "头像会显示在应用导航中，并通过公开 HTTPS 地址读取。",
      summary:
        "支持 JPEG、PNG 或 WebP，建议至少 256×256，不超过 2MB。用于导航和成员识别。",
      fallbackBadge: "默认字符头像",
      change: "更换头像",
      current: "当前头像",
      currentAlt: "当前头像",
      editAria: "修改头像",
      editTitle: "修改头像",
      chooseTitle: "选择新的头像",
      requirements: "JPEG、PNG 或 WebP，最大 2 MiB",
      choose: "选择图片",
      inputLabel: "选择头像图片",
      previewAlt: "头像预览",
      submit: "上传头像",
      success: "头像已更新",
      invalidType: "请选择 JPEG、PNG 或 WebP 图片",
      tooLarge: "头像不能超过 2 MiB",
      failed: "暂时无法上传头像，请稍后重试",
    },
    profile: {
      sectionTitle: "个人资料",
      publicHint: "公开展示信息",
      title: "显示名称",
      description: "用于导航和成员列表中的账号识别。",
      editAria: "修改显示名称",
      editTitle: "修改显示名称",
      displayName: "显示名称",
      placeholder: "例如：林小满",
      submit: "保存显示名称",
      success: "显示名称已更新",
      failed: "暂时无法更新显示名称，请稍后重试",
    },
    email: {
      title: "登录邮箱",
      change: "更换邮箱",
      description: "修改需要先由当前邮箱批准，再确认新邮箱。",
      editAria: "修改登录邮箱",
      editTitle: "修改登录邮箱",
      current: "当前邮箱",
      newEmail: "新邮箱",
      submit: "发送确认邮件",
      success: "请先在当前邮箱批准，再到新邮箱完成确认",
      same: "新邮箱不能与当前邮箱相同",
      failed: "暂时无法发起邮箱修改，请稍后重试",
    },
    password: {
      sectionTitle: "安全性与密码",
      change: "修改密码",
      title: "登录密码",
      description: "更新后保留当前设备，并撤销其他设备上的会话。",
      editAria: "修改登录密码",
      editTitle: "修改登录密码",
      statusLabel: "密码状态",
      status: "已设置",
      current: "当前密码",
      new: "新密码",
      confirm: "确认新密码",
      submit: "更新密码",
      success: "密码已更新，其他设备已退出",
      failed: "暂时无法更新密码，请检查当前密码后重试",
      sessionHint: "保存后，当前设备保持登录。",
    },
  },
  referrals: {
    title: "邀请新用户",
    description: "生成一条固定邀请链接。同一条链接可以邀请多人，对方注册后会自己创建工作空间。",
    linkLabel: "邀请链接",
    copy: "复制链接",
    copied: "邀请链接已复制",
    copyFailed: "暂时无法复制，请手动选择链接。",
    generate: "生成邀请链接",
    generating: "正在生成",
    loading: "正在读取邀请记录",
    loadFailed: "邀请记录暂时无法加载",
    linkLoadFailed: "邀请链接暂时无法读取",
    createFailed: "暂时无法生成邀请链接，请稍后重试",
    retry: "重试",
    emptyTitle: "还没有人通过你的链接注册",
    emptyDescription: "对方完成注册后，会出现在这里。",
    recordsAria: "邀请记录",
    noWorkspace: "尚未创建工作空间",
  },
  dashboard: {
    title: "广告投放概览",
    subtitle: "数据每小时更新 · 时区 GMT+8",
    greetingMorning: "早上好",
    greetingAfternoon: "下午好",
    greetingEvening: "晚上好",
    greetingNight: "夜深了",
    greetingWithName: "{greeting}，{name}👋",
    greetingNameFallback: "你好",
    reportPeriod: "报表周期",
    reportPeriodAria: "报表周期：{range}",
    dateCapCampaign: "系列与 KPI 最长加载最近 90 天。",
    dateCapCreatives: "广告素材榜单展示该周期内最近 30 天。",
    kpiAria: "概览关键指标",
    spend: "总花费",
    revenue: "总收入",
    orders: "总订单",
    roas: "投资回报率",
    cpa: "每单成本",
    avgCpa: "单均成本",
    spendDesc: "所选报表周期内实际划出的广告金额。",
    revenueDesc: "该周期内由广告归因的成交金额。",
    roasDesc: "总收入 ÷ 总花费。",
    ordersDesc: "该周期内由广告归因成交的 SKU 数量合计，不是订单笔数。",
    cpaDesc: "总花费 ÷ 总订单。总订单为 0 时不计算。",
    metricDescAria: "{label}指标说明",
    spendFooter: "当前报表周期合计",
    revenueFooter: "当前报表周期合计",
    ordersFooter: "归因订单合计",
    roasFooter: "归因收入 ÷ 花费",
    avgCpaFooter: "花费 ÷ 订单",
    chartTitle: "指标对比趋势",
    chartTitlePair: "{left} vs {right}",
    chartTitleSingle: "{name}",
    chartDescription: "勾选上方 KPI（最多 2 个）按日对比；再点已选可取消",
    chartMockBadge: "演示数据",
    chartTrendVsDays: "近 {days} 天",
    chartTrendUnavailable: "—",
    chartEmptySelect: "请至少勾选一个 KPI 以显示趋势",
    chartLegendAria: "趋势图图例",
    chartTypeAria: "趋势图类型",
    chartTypeLine: "折线",
    chartTypeBar: "柱状",
    chartUnitAria: "时间聚合单位",
    chartUnitDay: "日",
    chartUnitWeek: "周",
    chartUnitMonth: "月",
    chartBrushAria: "图表时间范围",
    chartUnavailableTitle: "趋势图暂不可用",
    chartUnavailableDescription: "当前报表周期没有可展示的日序列。",
    chartLoading: "正在加载趋势",
    chartSeriesFailedTitle: "趋势图加载失败",
    chartSeriesFailedDescription: "日序列暂时无法读取，请稍后重试。",
    loadFailedTitle: "概览数据加载失败",
    loadFailed: "广告系列汇总加载失败，请稍后重试",
    creativesLoadFailedTitle: "广告素材榜单加载失败",
    creativesLoadFailed: "广告素材榜单加载失败，请稍后重试",
    hotCreatives: "广告素材榜单",
    hotCreativesDescription: "本周期按花费领先的素材",
    hotCreativesDescriptionBy: "本周期按 {metric} 领先的素材",
    hotCreativesAria: "广告素材榜单",
    hotCreativesViewAll: "查看全部素材",
    hotCreativesEmptyTitle: "暂无广告素材",
    hotCreativesEmptyDescription: "当前报表周期内没有可展示的素材表现。",
    hotCreativesRank: "第 {rank} 名",
    campaigns: "广告系列榜单",
    campaignsAria: "广告系列榜单",
    campaignsDescription: "本周期按 ROI 领先的广告系列",
    leaderboardByPrefix: "本周期按",
    leaderboardSuffix: {
      campaigns: "领先排行",
      creatives: "领先排行",
    },
    leaderboardSortAria: "排序指标：{metric}",
    leaderboardMetric: {
      spend: "花费",
      revenue: "收入",
      roas: "ROI",
      orders: "订单",
      cpa: "CPA",
    },
    campaignsViewAll: "查看全部系列",
    leaderboardBackToStart: "回到顶部",
    campaignsEmptyTitle: "暂无广告系列",
    campaignsEmptyDescription: "当前报表周期内没有可展示的广告系列。",
    campaignCount: "{count} 个广告系列",
    campaignCountFiltered: "{filtered} / {total} 个广告系列",
    campaignSearchClear: "清除搜索",
    campaignSearchEmptyTitle: "没有匹配的广告系列",
    campaignSearchEmptyDescription: "请尝试其他搜索词，或清除筛选条件。",
    search: "搜索广告系列",
    searchSubmit: "搜索",
    tableAria: "广告系列投放数据",
    status: { active: "投放中", paused: "已暂停" },
    columns: {
      campaign: "广告系列",
      status: "状态",
      orders: "订单",
      spend: "花费",
      roi: "ROAS",
    },
    exportData: "导出数据",
    exportSuccess: "已导出广告系列概览",
    exportFailed: "导出失败，请稍后重试",
    exportSheetOverview: "Sheet1",
    exportColByDay: "按天",
    exportColByWeek: "按周",
    exportColByMonth: "按月",
    exportColCost: "成本",
    exportColSkuOrders: "SKU 订单数（当前店铺）",
    exportColAvgCpa: "平均下单成本（当前店铺）",
    exportColTotalRevenue: "总收入（当前店铺）",
    exportColRoi: "投资回报率 (ROI)（当前店铺）",
    exportColCurrency: "币种",
  },
  workspaceComingSoon: {
    campaigns: {
      title: "广告系列页面正在建设中",
      description: "此页面当前不提供广告系列操作。",
    },
    audiences: {
      title: "受众页面正在建设中",
      description: "此页面当前不提供受众操作。",
    },
  },
  governance: {
    title: "成员管理",
    lead: "管理组织内团队成员、角色权限，并实时追踪生成的邀请激活记录。",
    loadFailedTitle: "成员数据加载失败",
    loadFailed: "成员数据加载失败，请稍后重试",
    actionFailed: "操作未完成",
    invitationCreateFailed: "邀请生成失败，请稍后重试",
    invitationCopyFailed: "邀请链接复制失败，请手动选择并复制。",
    invitationRevealFailed: "邀请链接获取失败，请稍后重试",
    invitationRegenerateFailed: "邀请重新生成失败，请稍后重试",
    invitationRevokeFailed: "邀请撤销失败，请稍后重试",
    memberRemoveFailed: "成员移除失败，请稍后重试",
    roles: {
      manage: "管理角色",
      title: "角色管理",
      lead: "配置当前工作空间可分配的角色。新成员加入后，由所有者指定角色。",
      listAria: "工作空间角色",
      loading: "正在加载角色",
      loadFailedTitle: "角色加载失败",
      loadFailed: "角色加载失败，请稍后重试",
      emptyTitle: "还没有角色",
      emptyDescription: "创建的自定义角色会显示在这里。",
      create: "创建角色",
      builtInBadge: "内置",
      disabledBadge: "已停用",
      columnName: "角色名称",
      columnDescription: "角色描述",
      columnAdvertiserAccounts: "广告账号",
      allAdvertiserAccounts: "全部广告账号",
      noAdvertiserAccounts: "未分配",
      advertiserAccountsTitle: "广告账号",
      advertiserAccountsHint: "打开后，该角色可以使用对应广告账号。没有已同步账号时，保存表示未分配。",
      advertiserAccountsEmpty: "还没有已同步的广告账号",
      advertiserAccountOverflow: "{names}，另外 {count} 个",
      addedAccounts: "新增：{items}",
      removedAccounts: "移除：{items}",
      ownerDescription: "可使用全部广告账号",
      memberDescription: "加入团队后的默认角色，默认未分配广告账号",
      memberCount: "{count} 名成员",
      editAria: "编辑 {name}",
      disabledEditHint: "请先启用该角色再进行编辑",
      disableAria: "停用 {name}",
      enableAria: "启用 {name}",
      deleteAria: "删除 {name}",
      editorTriggerAria: "打开角色编辑",
      statusTriggerAria: "打开角色状态确认弹窗",
      deleteTriggerAria: "打开删除角色弹窗",
      createTitle: "创建自定义角色",
      editTitle: "编辑角色：{name}",
      name: "角色名称",
      descriptionField: "角色描述（可选）",
      descriptionPlaceholder: "说明该角色负责的工作",
      permissionsTitle: "权限",
      menuAccessTitle: "页面访问",
      menuAccessDescription:
        "按菜单分组开关。打开后，侧栏会出现对应入口。概览始终包含；投放页面目前随成员身份开放。",
      menuAccess: {
        overview: "概览",
        operations: "投放与资产",
        menuAccessLabel: "菜单访问",
        resourcePermissionLabel: "资源权限",
        membershipHint:
          "当前无独立菜单权限码：凡工作空间成员即可访问（契约扩展后可单独配置）。",
      },
      groupBasic: "基础",
      groupMembers: "成员",
      groupAudit: "审计",
      expandGroup: "展开{group}权限",
      collapseGroup: "收起{group}权限",
      required: "必选",
      permissionDetail: {
        dashboardView: "工作空间成员都会看到概览。",
        membersView: "打开后，侧栏显示成员入口。",
        auditView: "打开后，侧栏显示审计入口。",
      },
      permission: {
        dashboardView: "查看概览",
        membersView: "查看成员",
        membersRemove: "移除成员",
        invitationsView: "查看邀请",
        invitationsCreate: "创建邀请",
        invitationsReveal: "查看邀请链接",
        invitationsRegenerate: "重新生成邀请",
        invitationsRevoke: "撤销邀请",
        auditView: "查看审计日志",
      },
      save: "保存角色",
      cancel: "取消",
      impactTitle: "变更影响",
      affectedMembers: "将影响 {count} 名成员",
      added: "新增：{permissions}",
      removed: "移除：{permissions}",
      noPermissionChanges: "权限无变化",
      confirmUpdateTitle: "确认更新角色",
      backToEdit: "返回编辑",
      confirmUpdate: "确认更新",
      disableTitle: "停用角色？",
      enableTitle: "启用角色？",
      disableDescription: "停用后，{count} 名成员将自动改派为系统“成员”角色。该角色将不可编辑或分配。",
      enableDescription: "启用后，该角色可以编辑和重新分配给成员。",
      confirmDisable: "确认停用",
      confirmEnable: "确认启用",
      deleteTitle: "删除角色？",
      deleteDescription: "仅未分配给成员的自定义角色可以删除。",
      confirmDelete: "确认删除",
      createFailed: "角色创建失败，请稍后重试",
      updateFailed: "角色更新失败，请稍后重试",
      disableFailed: "角色停用失败，请稍后重试",
      enableFailed: "角色启用失败，请稍后重试",
      deleteFailed: "角色删除失败，请稍后重试",
      disabledResultTitle: "角色已停用",
      disabledResult: "{count} 名成员已改派为系统“成员”角色。",
      enabledResultTitle: "角色已启用",
      enabledResult: "该角色现在可以编辑并重新分配给成员。",
    },
    assignment: {
      open: "修改角色",
      openAria: "修改 {email} 的角色",
      selectAria: "为 {email} 选择角色",
      title: "修改角色",
      description: "选择该成员的新角色，保存后立即生效。",
      noAlternativeTitle: "暂无其他可选角色",
      noAlternativeDescription: "请先创建并启用一个自定义角色，再回来修改成员角色。",
      createRole: "前往创建角色",
      cancel: "取消",
      confirm: "保存修改",
      failed: "成员角色修改失败，请稍后重试",
    },
    permissions: {
      open: "修改权限",
      openAria: "修改 {email} 的权限",
      title: "修改成员权限",
      description: "账号层只能增授只读权限；最终权限为角色权限与账号增授的并集。",
      roleProvidedAria: "{permission}由角色提供，无法在此修改",
      roleProvidedHint: "此权限由角色提供，无法在此修改。",
      cancel: "取消",
      save: "保存权限",
      failed: "成员权限修改失败，请稍后重试",
    },
    dialog: {
      linkTitle: "邀请链接",
      createTitle: "生成邀请链接",
      open: "生成邀请链接",
      openAria: "打开邀请弹窗",
      closeAria: "关闭邀请弹窗",
      description: "每条链接有效 7 天，仅可由一名成员使用。",
      actionFailed: "操作未完成",
      note: "邀请备注（可选）",
      notePlaceholder: "例如：财务同事",
      loading: "正在获取邀请链接",
      copied: "已复制邀请链接",
      copy: "复制邀请链接",
      close: "关闭",
      create: "生成邀请链接",
      regenerate: "重新生成邀请链接",
    },
    invitations: {
      title: "邀请记录",
      description: "有效邀请可按需查看、复制或重新生成",
      aria: "邀请记录",
      emptyTitle: "还没有邀请记录",
      emptyDescription:
        "新生成的邀请会显示在这里。您可以随时取消已发送的邀请或重新复制链接。",
      createNow: "立即创建邀请链接",
      noNote: "未填写备注",
      noNoteTarget: "未备注邀请 {index}",
      reveal: "查看并复制",
      revealAria: "查看并复制邀请链接 {target}",
      revokeAria: "撤销 {target}",
    },
    members: {
      title: "当前成员",
      count: "{count} 名成员",
      aria: "当前成员",
      emptyTitle: "还没有成员",
      emptyDescription: "对方接受邀请后，会显示在这里。",
      joined: "加入于 {date}",
      removeAria: "移除 {email}",
      inviteHint: "需要添加更多协作者？点击右上角邀请。",
      inviteHintReadOnly: "了解各角色可以执行的操作。",
      permissionGuide: "查看权限说明",
      permissionGuideTitle: "权限说明",
    },
    removal: {
      open: "打开成员移除确认",
      closeAria: "关闭成员移除弹窗",
      title: "确认移除成员",
      description: "此操作会立即收回工作空间访问权限。",
      failed: "成员移除失败",
      warning:
        "移除后，该成员在这个工作空间中的身份会被停用，按该身份归属的数据会标记删除。",
      cancel: "取消",
      confirm: "确认移除",
    },
  },
  authorizeAccount: {
    button: "授权账户",
    reauthorize: "重新授权",
    emptyTitle: "尚未授权 TikTok 账户",
    emptyDescription:
      "授权 TikTok for Business 后，即可同步并管理广告系列、广告账户、店铺与素材。",
    modal: {
      close: "关闭",
      checkingTitle: "正在检测网络",
      checkingDescription: "确认当前环境能否访问 TikTok 授权服务。",
      checkingHint: "正在连接 ads.tiktok.com…",
      blockedTitle: "无法访问 TikTok",
      blockedDescription: "当前网络无法连接 TikTok 授权服务。",
      vpnHint: "请开启 VPN 或切换可访问外网的网络后重试。",
      readyTitle: "可以开始授权",
      readyDescription: "网络正常，将跳转到 TikTok 完成授权。",
      readyHint: "点击继续后，浏览器会打开 TikTok for Business 授权页。",
      retry: "重新检测",
      continue: "继续授权",
      ownerOnly: "只有工作空间所有者可以管理 TikTok 授权。",
      paused: "工作空间已暂停，暂时无法发起授权。",
    },
  },
  tiktokIntegration: {
    title: "TikTok 授权",
    productTitle: "TikTok for Business",
    description: "连接 TikTok for Business 后，投放资源会在各自页面独立同步。",
    loading: "正在加载 TikTok 授权",
    loadFailedTitle: "TikTok 授权加载失败",
    loadFailed: "暂时无法加载 TikTok 授权，请稍后重试",
    actionFailedTitle: "TikTok 授权未完成",
    actionFailed: "TikTok 授权暂时无法完成，请稍后重试",
    status: {
      disconnected: "未连接",
      connected: "已连接",
      reauth_required: "需要重新授权",
    },
    connectionStatus: "授权状态",
    connectedAt: "连接时间",
    connect: "连接 TikTok for Business",
    reauthorize: "重新授权",
    connectedTitle: "TikTok 已连接",
    connectedDescription:
      "授权已完成。可在 Business Center 等页面开始同步 TikTok 资源。",
    timeoutTitle: "授权等待超时",
    timeoutDescription:
      "服务器在 60 秒内未返回结果。连接可能仍在后台完成，您可以刷新状态查看，或重新发起授权。",
    timeoutRetry: "重新发起授权",
    timeoutRefresh: "刷新状态",
    ownerOnly: "只有工作空间所有者可以管理 TikTok 授权。",
    reauthTitle: "需要重新授权",
    reauth: "TikTok 授权已失效，请重新授权。",
    addAccount: "添加授权广告账户",
    table: {
      title: "授权账户列表",
      description: "当前工作空间的 TikTok for Business 授权（目前支持 1 个账户）。",
      ariaLabel: "TikTok 授权账户列表",
      columnAccount: "账户",
      columnStatus: "状态",
      columnConnectedAt: "连接时间",
      columnActions: "操作",
      accountName: "TikTok for Business",
      emptyTitle: "还没有授权账户",
      emptyDescription: "授权后即可在各资源页同步广告账户、店铺、素材与系列。",
      reauthorizeAria: "重新授权 TikTok for Business",
      disconnect: "解除授权",
      disconnectAria: "解除 TikTok for Business 授权",
    },
    disconnect: {
      title: "解除 TikTok 授权？",
      description: "解除后，本工作空间将无法继续同步 TikTok 投放资源。",
      warning: "已同步的历史快照仍可查看，但无法发起新的同步，直到重新完成授权。",
      cancel: "取消",
      confirm: "解除授权",
      failedTitle: "解除授权失败",
      failed: "暂时无法解除 TikTok 授权，请稍后重试。",
    },
  },
  tiktokResources: {
    syncTime: {
      lastSuccess: "上次成功：",
      campaignsUpdated: "系列更新：",
      insightsUpdated: "Insights 更新：",
      never: "尚未成功同步",
      scopeHint: "当前范围内最近一次成功更新，不代表全部账户完成同一轮同步。",
    },
    readOnlyTitle: "当前为只读模式",
    readOnly: "工作空间已暂停，当前页面仅可查看。",
    errorCode: "错误码：{code}",
    httpStatus: "HTTP 状态：{status}",
    messageKey: "消息键：{messageKey}",
    requestId: "请求 ID：{requestId}",
    retryAfterMinutes: "{minutes} 分钟后可重试",
    retryAfterSeconds: "{seconds} 秒后可重试",
    retryWithDetail: "{message}（{retryAfter}）",
    selectBusinessCenter: "选择 Business Center",
    selectAdvertiserAccount: "选择广告账户",
    sync: "同步",
    syncing: "正在同步…",
    unavailable: "不可用",
    syncStatus: {
      never_synced: "尚未同步",
      synced: "已同步",
      sync_failed: "同步失败",
      syncing: "正在同步…",
      partial: "部分同步",
    },
  },
  tiktokBusinessCenters: {
    title: "Business Center",
    description: "最近一次完整同步返回的 Business Center 及其投放基础信息。",
    loading: "正在加载 Business Center",
    loadFailedTitle: "Business Center 加载失败",
    loadFailed: "暂时无法加载 Business Center，请稍后重试",
    actionFailedTitle: "Business Center 同步未完成",
    actionFailed: "暂时无法同步 Business Center，请稍后重试",
    sync: "同步 Business Center",
    syncing: "正在同步 Business Center…",
    syncFailedTitle: "Business Center 同步失败",
    syncFailed: "已保留上一次成功快照，可以稍后重试。",
    listTitle: "Business Center 清单",
    listAria: "Business Center 列表",
    count: "{count} 个",
    lastSync: "最近同步：{time}",
    notSynced: "尚无成功同步记录",
    columnName: "名称 / ID",
    columnStatus: "状态",
    columnVerification: "验证状态",
    columnRole: "角色",
    columnCurrency: "币种",
    columnTimezone: "时区",
    columnAvailability: "可用性",
    available: "可用",
    unavailable: "本次未返回",
    disconnectedTitle: "请先连接 TikTok",
    disconnectedDescription: "完成 TikTok 授权后，才能同步 Business Center。",
    reauthEmptyTitle: "需要重新授权",
    reauthEmptyDescription: "TikTok 授权已失效，重新授权后可继续同步。",
    openAuthorization: "前往 TikTok 授权",
    neverSyncedTitle: "尚未同步 Business Center",
    neverSyncedDescription: "由工作空间所有者发起首次完整同步。",
    emptyTitle: "没有可用的 Business Center",
    emptyDescription: "最近一次完整同步已成功，但 TikTok 没有返回 Business Center。",
  },
  tiktokAdvertiserAccounts: {
    title: "广告账户",
    description: "所选 Business Center 最近一次完整同步返回的广告账户。",
    loading: "正在加载广告账户",
    loadFailedTitle: "广告账户加载失败",
    loadFailed: "暂时无法加载广告账户，请稍后重试",
    actionFailedTitle: "广告账户同步未完成",
    actionFailed: "暂时无法同步广告账户，请稍后重试",
    selectBusinessCenter: "选择 Business Center",
    sync: "同步广告账户",
    syncing: "同步广告账户…",
    syncFailedTitle: "广告账户同步失败",
    syncFailed: "已保留该 Business Center 上一次成功快照，可以稍后重试。",
    listTitle: "广告账户清单",
    listAria: "广告账户列表",
    count: "{count} 个",
    lastSync: "最近同步：{time}",
    notSynced: "尚无成功同步记录",
    columnName: "名称 / ID",
    columnAccountType: "账户类型",
    columnRole: "BC 角色",
    columnAdCreation: "广告创建资格",
    columnOwner: "归属 Business Center",
    columnAvailability: "可用性",
    eligible: "可创建广告",
    ineligible: "不可创建广告",
    available: "可用",
    unavailable: "本次未返回",
    unavailableTitle: "该 Business Center 已不可用",
    unavailableDescription: "仍可查看历史快照；请在 Business Center 页面同步最新资源后重新选择。",
    noBusinessCenterTitle: "还没有可选择的 Business Center",
    noBusinessCenterDescription: "请先连接 TikTok 并在 Business Center 页面完成同步。",
    openBusinessCenters: "前往 Business Center",
    neverSyncedTitle: "尚未同步广告账户",
    neverSyncedDescription: "由工作空间所有者同步当前 Business Center 的广告账户。",
    emptyTitle: "没有广告账户",
    emptyDescription: "最近一次完整同步已成功，但 TikTok 没有返回广告账户。",
  },
  tiktokStores: {
    title: "店铺列表",
    description: "工作空间最近一次完整同步返回的可投放 TikTok Shop。",
    loading: "正在加载店铺",
    loadFailedTitle: "店铺加载失败",
    loadFailed: "暂时无法加载店铺，请稍后重试",
    actionFailedTitle: "店铺同步未完成",
    actionFailed: "暂时无法同步店铺，请稍后重试",
    selectBusinessCenter: "选择 Business Center",
    selectAdvertiserAccount: "选择广告账户",
    sync: "同步店铺列表",
    syncing: "同步店铺列表…",
    syncFailedTitle: "店铺同步失败",
    syncFailed: "已保留上一次成功快照，可以稍后重试。",
    listTitle: "店铺列表",
    listAria: "店铺列表",
    count: "{count} 个",
    lastSync: "最近同步：{time}",
    notSynced: "尚无成功同步记录",
    columnName: "名称 / ID",
    columnCatalog: "Catalog ID",
    columnAuthorizedBc: "授权 Business Center",
    columnAvailability: "可用性",
    available: "可用",
    unavailable: "本次未返回",
    filterBar: {
      ariaLabel: "店铺筛选",
      allBusinessCenters: "全部 Business Center",
      allAdvAccounts: "全部广告账户",
    },
    businessCenterUnavailableTitle: "该 Business Center 已不可用",
    businessCenterUnavailableDescription: "仍可查看历史快照；请先同步最新 Business Center。",
    noBusinessCenterTitle: "还没有可选择的 Business Center",
    noBusinessCenterDescription: "请先连接 TikTok 并完成 Business Center 同步。",
    openBusinessCenters: "前往 Business Center",
    noAdvertiserTitle: "还没有可选择的广告账户",
    noAdvertiserDescription: "请先同步当前 Business Center 的广告账户。",
    openAdvertisers: "前往广告账户",
    advertiserUnavailableTitle: "该广告账户已不可用",
    advertiserUnavailableDescription: "仍可查看历史快照；请同步广告账户后重新选择。",
    neverSyncedTitle: "尚未同步店铺",
    neverSyncedDescription: "由工作空间所有者同步工作空间的店铺列表。",
    emptyTitle: "没有店铺",
    emptyDescription: "最近一次完整同步已成功，但 TikTok 没有返回可投放店铺。",
  },
  profitCalculator: {
    title: "产品利润对比计算器",
    subtitle: "跨境电商产品利润分析与成本核算",
    lead: "对比不同产品的成本结构与利润表现，辅助选品决策，提升运营效率。",
    productA: "产品 A 参数配置",
    productB: "产品 B 参数配置",
    copyToB: "产品 A 配置复制到产品 B",
    copiedToB: "已复制到产品 B",
    resetAll: "恢复默认",
    tabA: "产品 A",
    tabB: "产品 B",
    tabsLabel: "选择对比产品",
    sectionBasics: "基础参数",
    sectionShipping: "运费与物流参数",
    sectionFees: "运营与佣金费用",
    sectionReturns: "退货与损耗测算",
    productName: "产品名称",
    cost: "采购成本",
    price: "销售价格",
    salesVolume: "预估销量",
    shippingTotal: "头程运费",
    perContainer: "每柜装量",
    lastMile: "尾程运费",
    warehouseFee: "仓库操作费",
    adCost: "广告费",
    platformFee: "店铺佣金",
    influencerFee: "达人佣金",
    influencerRatio: "达人所占销量比例",
    returnRate: "退货率",
    returnFee: "退货处理费",
    unitPerPiece: "元/件",
    unitPerContainer: "元/柜",
    unitPieces: "件",
    unitPercent: "%",
    currencyMark: "¥",
    analysisTitle: "{name} 实时利润看板",
    formulaHint: "鼠标悬停各项指标可查看计算公式",
    formulaHintTitle: "计算公式",
    firstMilePerUnit: "头程分摊",
    preTaxProfit: "税前利润",
    returnLoss: "退货损失",
    actualProfit: "实际单件利润",
    profitMargin: "利润率",
    totalProfit: "预估总利润",
    breakEvenRoi: "保本 ROI",
    unitCost: "单件总成本",
    totalCost: "总成本 (整柜)",
    roiStatus: "ROI",
    roiSafe: "安全",
    roiCaution: "注意",
    roiDanger: "危险",
    comparisonTitle: "产品选品决策综合对比分析",
    comparisonLead:
      "系统基于单件毛利敏感度、整柜分摊效率以及盈亏平衡销量比进行动态评估",
    modelRecommendA: "智能模型推荐: 优先选择产品 A",
    modelRecommendB: "智能模型推荐: 优先选择产品 B",
    modelRecommendTie: "智能模型推荐: 两边持平",
    volumeRatioLabel: "当前 B/A 销量比:",
    balanceThresholdLabel: "平衡点阈值:",
    balanceTimes: "{ratio} 倍",
    decisionTitle: "{name} 决策结论",
    chooseAWhenBelow:
      "当产品 B 的销量低于产品 A 的 {ratio} 倍时，优先选择产品 A。其单件利润更高、抵抗广告投流成本波动的韧性更强，总利润占优。",
    chooseAWhenBelowBefore: "当产品 B 的销量 ",
    chooseAWhenBelowEmphasis: "低于产品 A 的 {ratio} 倍",
    chooseAWhenBelowAfter: " 时，优先选择 ",
    chooseAWhenBelowName: "产品 A",
    chooseAWhenBelowTail:
      "。其单件利润更高、抵抗广告投流成本波动的韧性更强，总利润占优。",
    chooseBWhenAtOrAbove:
      "当产品 B 的销量达到产品 A 的 {ratio} 倍及以上时（需达 {units} 件以上），方可选择产品 B，以走量规模摊平单件利润差并放大整柜效益。",
    chooseBWhenAtOrAboveBefore: "当产品 B 的销量 ",
    chooseBWhenAtOrAboveEmphasis: "达到产品 A 的 {ratio} 倍及以上",
    chooseBWhenAtOrAboveAfter: " 时（需达 {units} 件以上），方可选择 ",
    chooseBWhenAtOrAboveName: "产品 B",
    chooseBWhenAtOrAboveTail: "，以走量规模摊平单件利润差并放大整柜效益。",
    barNetTag: "{percent} 净利",
    chooseAWhenHigherTotal: "当产品 A 的预估总利润更高时，选择产品 A",
    chooseBWhenHigherTotal: "当产品 B 的预估总利润更高时，选择产品 B",
    chooseWhenTie: "当前预估总利润持平，可按单件利润、供应链或投放策略择优",
    verdictRecommended: "当前推荐",
    verdictFeatured: "★ 当前综合推荐",
    verdictNotRecommended: "当前不推荐",
    verdictTie: "持平",
    currentVolumeRatio: "当前 B/A 销量比：{ratio}。",
    balanceUnavailable: "当两边实际利润均为正时，可计算销量平衡点。",
    timesSuffix: "倍",
    profitDeltaALead: "产品 A 总利润高出 {amount} 元",
    profitDeltaBLead: "产品 B 总利润高出 {amount} 元",
    profitDeltaTie: "两边预估总利润持平",
    unitProfit: "单件实际利润",
    totalProfitShort: "总利润",
    totalProfitWithVolume: "预估总利润 ({count}件)",
    yuan: "元",
    yuanPerUnit: "元/件",
    unitAdvantage: "+{amount} 优势",
    totalAhead: "+{amount} 高出",
    totalGap: "-{amount} 差距",
    breakdownTitle: "两款产品单件成本构成与利润留存透视",
    barPurchase: "采购成本",
    barLogistics: "头程+尾程",
    barMarketing: "营销与平台费",
    barNet: "纯净利润",
    barSeries: "品{side} ({price})",
    tipsTitle: "跨境核算逻辑与核心计算公式参考 (Formula Reference)",
    coreFormulasTitle: "核心收益与利润公式",
    costFormulasTitle: "成本、保本点与决策平衡公式",
    formulaFirstMile: "头程分摊 = 头程运费 ÷ 每柜装量",
    formulaPlatformCommission: "店铺佣金 = 售价 × 店铺佣金%",
    formulaInfluencerCommission:
      "达人佣金 = 售价 × 达人佣金% × 达人销量占比%",
    formulaPreTax:
      "税前利润 = 售价 − 采购成本 − 头程分摊 − 尾程运费 − 仓库操作费 − 店铺佣金 − 达人佣金 − 广告费",
    formulaReturnLoss:
      "退货损失 = (尾程运费 + 仓库操作费 + 退货处理费) × 退货率%",
    formulaActual: "实际利润 = 税前利润 − 退货损失",
    formulaMargin: "利润率 = 实际利润 ÷ 售价 × 100%",
    formulaUnitCost: "每件成本 = 采购成本 + 头程分摊",
    formulaTotalCost: "总成本(柜) = (采购成本 × 每柜装量) + 头程运费",
    formulaBreakEven: "广告保本 ROI = 售价 ÷ 实际利润",
    formulaTotalProfit: "预估总利润 = 实际利润 × 预估销量",
    formulaBalance: "平衡点 = 产品 A 单件利润 ÷ 产品 B 单件利润",
    formulaNameFirstMile: "头程分摊 (元/件) =",
    formulaExprFirstMile: "头程运费 ÷ 每柜装量",
    formulaNamePlatform: "店铺佣金 (元/件) =",
    formulaExprPlatform: "售价 × 店铺佣金%",
    formulaNameInfluencer: "达人佣金 (元/件) =",
    formulaExprInfluencer: "售价 × 达人佣金% × 达人销量占比%",
    formulaNameReturnLoss: "退货损失 (元/件) =",
    formulaExprReturnLoss: "(尾程运费 + 仓库操作费 + 退货处理费) × 退货率%",
    formulaNamePreTax: "税前利润 (元/件) =",
    formulaExprPreTax: "售价 - 采购 - 头程 - 尾程 - 仓储 - 店铺佣金 - 达人佣金 - 广告费",
    formulaNameActual: "实际利润 =",
    formulaExprActual: "税前利润 - 退货损失",
    formulaNameMargin: "实际利润率 =",
    formulaExprMargin: "实际利润 ÷ 销售价格 × 100%",
    formulaNameUnitCost: "单件固定货本 =",
    formulaExprUnitCost: "采购成本 + 头程分摊",
    formulaNameTotalCost: "整柜总垫资成本 =",
    formulaExprTotalCost: "(采购成本 × 每柜装量) + 头程运费",
    formulaNameBreakEven: "广告保本 ROI =",
    formulaExprBreakEven: "销售价格 ÷ (销售价格 - 各项固定成本)",
    formulaNameTotalProfit: "预估周期总利润 =",
    formulaExprTotalProfit: "实际利润 × 预估总销量",
    formulaNameBalance: "决策销量平衡比 =",
    formulaExprBalance: "产品 A 单件利润 ÷ 产品 B 单件利润",
  },
  roiCalculator: {
    title: "ROI 计算系统",
    subtitle: "跨境电商广告投产比与保本点速算",
    definition: "投产比 ROI = 销售额 ÷ 广告费",
    calculate: "立即计算",
    resetAll: "重置",
    dirtyHint: "参数已修改，点击「立即计算」刷新结果",
    staleResults: "待重新计算",
    inputsTitle: "计算参数",
    resultsTitle: "计算结果",
    sectionBasics: "基础参数",
    price: "售价",
    cost: "成本",
    returnRate: "退货率",
    shopFee: "店铺佣金率",
    influencerFee: "达人广告佣金率",
    targetRoi: "预期投产比 ROI（可选）",
    quickPresets: "快捷预设",
    breakEvenBaseline: "盈亏基准线",
    unitPerPiece: "元/件",
    unitPercent: "%",
    unitRatio: "倍",
    yuan: "元",
    yuanPerUnit: "元 / 每件",
    grossProfit: "广告前单件毛利",
    grossProfitDesc: "扣除退货、佣金、成本后的毛利",
    grossMargin: "广告前毛利率",
    grossMarginDesc: "广告前毛利 ÷ 售价",
    breakEvenRoi: "保本投产比 ROI",
    breakEvenRoiDesc: "广告 ROI 高于此值才有利润",
    breakEvenPrice: "盈亏平衡卖价",
    breakEvenPriceDesc: "不计广告时利润为 0 的售价",
    adCap: "基于预期 ROI 的广告费上限",
    adCapDesc: "按预期投产比反推的单件广告费上限",
    profitAfterAdCap: "按该上限投放后单件利润约 {amount} 元",
    footerFormulas: "广告费上限 = 售价 ÷ 预期 ROI　|　保本 ROI = 售价 ÷ 毛利",
    insight: {
      none: "填写预期 ROI 后，可查看广告费上限与盈亏空间。",
      unprofitable: "当前参数下广告前毛利为负或为零，无法通过广告投产比实现盈利，请先提高售价或降低成本/费率。",
      invalid_fees: "退货率或佣金合计无效（留存率为 0，或佣金率合计 ≥ 100%），请调整后再计算。",
      target_profitable: "预期 ROI 高于保本点，广告费上限低于广告前毛利，按此投放仍有利润空间。",
      target_breakeven: "预期 ROI 接近保本点，按广告费上限投放后利润接近为零。",
      target_loss: "预期 ROI 低于保本点，广告费上限高于广告前毛利，按此投放会亏损。",
    },
    insightLabel: {
      unprofitable: "结构亏损",
      invalid_fees: "参数无效",
      target_profitable: "有利润空间",
      target_breakeven: "接近保本",
      target_loss: "投放亏损",
    },
    tipsTitle: "计算公式参考",
    coreFormulasTitle: "毛利公式",
    roiFormulasTitle: "投产比公式",
    formulaNameNetRevenue: "净销售额 =",
    formulaExprNetRevenue: "售价 × (1 − 退货率%)",
    formulaNameCommissions: "佣金合计 =",
    formulaExprCommissions: "净销售额 × (店铺佣金% + 达人广告佣金%)",
    formulaNameGrossProfit: "广告前单件毛利 =",
    formulaExprGrossProfit: "净销售额 − 佣金合计 − 成本",
    formulaNameGrossMargin: "广告前毛利率 =",
    formulaExprGrossMargin: "广告前单件毛利 ÷ 售价 × 100%",
    formulaNameBreakEvenRoi: "保本投产比 ROI =",
    formulaExprBreakEvenRoi: "售价 ÷ 广告前单件毛利",
    formulaNameBreakEvenPrice: "盈亏平衡卖价 =",
    formulaExprBreakEvenPrice: "成本 ÷ [(1 − 退货率%) × (1 − 合计佣金%)]",
    formulaNameAdCap: "广告费上限 =",
    formulaExprAdCap: "售价 ÷ 预期 ROI",
  },
  tiktokCreativeAssets: {
    mediaRetry: "刷新图片/封面链接",
    mediaProgress: "图片/封面补齐进度",
    reportUpdated: "报表最近更新时间：{time}",
    mediaScope: "仅重新获取当前工作空间及所选 BC/账户范围内的店铺官方账号视频封面和商品卡主图，不受报表日期或授权类型筛选限制；不重新拉取报表，暂不查询联盟及其他授权视频。链接可能过期，图片加载失败时可手动刷新。",
    mediaCounts: "唯一媒体 {total} 个：成功 {succeeded}、待处理 {queued}、处理中 {running}、等待重试 {waiting}、未完成 {failed}",
    mediaResult: "新增 {added} 个，已排队 {queued} 个，无需处理 {skipped} 个。",
    mediaFailedTitle: "补图操作或进度查询失败",
    mediaFailed: "已有报表不受影响，请刷新进度或稍后重试补图。",
    mediaRefresh: "刷新补图进度",
    mediaStates: { queued: "待处理", running: "补图处理中", waiting: "等待重试", succeeded: "补图完成", failed: "部分素材尚未补齐" },
    mediaErrors: {
      metadata_not_found: "未找到作品元数据，类型待确认；可在下次同步或人工补图时重查",
      metadata_upstream_failed: "元数据查询或解析失败，请稍后重试",
      product_not_found: "未找到商品主图，请核对商品授权",
      oss_upload_failed: "图片保存失败，请稍后重试",
      source_download_failed: "图片下载失败，请稍后重试",
      source_download_timeout: "图片下载超时或来源地址过期，请重试",
      source_format_unsupported: "来源不是支持的图片格式，需要人工核对",
      source_too_large: "来源图片超过大小限制，需要人工核对",
      source_url_missing: "来源未返回图片地址，需要核对素材",
      source_url_rejected: "来源未通过安全校验，需要人工核对",
      tiktok_rate_limited: "上游请求受限，等待重试",
      tiktok_upstream_unavailable: "上游暂不可用，请稍后重试",
      tiktok_response_invalid: "上游返回格式不符合预期，需要核对",
      tiktok_token_invalid: "授权已失效，请重新授权",
      tiktok_sync_timeout: "补图任务超时，请重试",
      tiktok_permission_missing: "接口明确返回权限不足，请核对授权",
    },
    title: "素材列表",
    description: "所选广告账户最近一次完整同步返回的图片与视频素材。",
    loading: "正在加载素材",
    loadFailedTitle: "素材加载失败",
    loadFailed: "暂时无法加载素材，请稍后重试",
    actionFailedTitle: "素材同步未完成",
    actionFailed: "暂时无法同步素材，请稍后重试",
    previewFailedTitle: "素材预览失败",
    previewFailed: "临时预览地址获取失败，请重试",
    selectBusinessCenter: "选择 Business Center",
    selectAdvertiserAccount: "选择广告账户",
    sync: "同步创意素材",
    syncing: "同步创意素材…",
    resumeReport: "继续现有同步",
    syncRequestFailed: "本次同步请求未受理",
    reportRetryAt: "最早重试时间：{time}。",
    reportActivity: {
      queued: "素材报表已排队，等待处理；可点击“继续现有同步”唤醒任务，不会重复创建批次。",
      running: "正在拉取素材报表；图片与视频封面另行补齐。",
      waiting: "素材报表等待重试；可点击“继续现有同步”唤醒任务，不会重复创建批次。",
    },
    syncFailedTitle: "素材同步失败",
    syncFailed: "已保留该广告账户上一次成功快照，可以稍后重试。",
    listTitle: "素材列表",
    listAria: "素材列表",
    count: "{count} 个",
    lastSync: "最近同步：{time}",
    notSynced: "尚无成功同步记录",
    columnType: "类型",
    columnName: "名称 / ID",
    columnDimensions: "尺寸 / 时长",
    columnFormat: "格式",
    columnSize: "大小",
    columnModified: "更新时间",
    columnAvailability: "可用性",
    image: "图片",
    video: "视频",
    duration: "{seconds} 秒",
    available: "可用",
    unavailable: "本次未返回",
    preview: "预览",
    previewing: "正在获取…",
    previewTitle: "素材预览",
    closePreview: "关闭素材预览",
    businessCenterUnavailableTitle: "该 Business Center 已不可用",
    businessCenterUnavailableDescription: "仍可查看历史快照；请先同步最新 Business Center。",
    noBusinessCenterTitle: "还没有可选择的 Business Center",
    noBusinessCenterDescription: "请先连接 TikTok 并完成 Business Center 同步。",
    openBusinessCenters: "前往 Business Center",
    noAdvertiserTitle: "还没有可选择的广告账户",
    noAdvertiserDescription: "请先同步当前 Business Center 的广告账户。",
    openAdvertisers: "前往广告账户",
    advertiserUnavailableTitle: "该广告账户已不可用",
    advertiserUnavailableDescription: "仍可查看历史快照；请同步广告账户后重新选择。",
    neverSyncedTitle: "尚未同步素材",
    neverSyncedDescription: "由工作空间所有者同步当前广告账户的图片与视频素材。",
    emptyTitle: "没有素材",
    emptyDescription: "最近一次完整同步已成功，但 TikTok 没有返回图片或视频素材。",
  },
  tiktokCallback: {
    processingTitle: "正在连接 TikTok for Business",
    processingDescription: "正在安全完成授权，请勿关闭此页面。",
    processingStatus: "正在验证并保存连接…",
    processingHint: "完成后会自动返回授权页面；若超过 60 秒仍未完成，将提示超时。",
    stepsAria: "授权进度",
    stepVerify: "正在验证 TikTok 授权",
    stepSave: "正在保存连接信息",
    stepFinish: "正在完成最后一步",
  },

  tiktokCampaigns: {
    title: "广告系列",
    description: "普通、Smart+ 与 GMV Max 的只读配置和所选日期指标。",
    loading: "正在加载广告系列",
    loadFailedTitle: "广告系列加载失败",
    loadFailed: "暂时无法加载广告系列，请稍后重试。",
    actionFailedTitle: "广告系列刷新未完成",
    actionFailed: "暂时无法刷新广告系列，请稍后重试。",
    selectBusinessCenter: "选择 Business Center",
    selectAdvertiserAccount: "选择广告账户",
    openAssets: "账户素材库",
    sync: "同步广告系列",
    syncingCampaigns: "同步广告系列…",
    syncingReports: "正在刷新报表…",
    syncFailedTitle: "最近一次刷新失败",
    syncFailed: "已保留上一次成功的完整数据，可以稍后重试。",
    disconnectedTitle: "请先连接 TikTok",
    disconnectedDescription: "完成 TikTok 授权后，才能同步并查看广告系列。",
    businessCenterUnavailableTitle: "该 Business Center 已不可用",
    businessCenterUnavailableDescription: "当前显示历史快照；同步最新父资源后再选择可用项。",
    advertiserUnavailableTitle: "该广告账户已不可用",
    advertiserUnavailableDescription: "当前显示历史快照，不能发起新的系列或报表刷新。",
    reportsNeverSyncedTitle: "系列已同步，报表尚未同步",
    reportsNeverSyncedDescription: "刷新报表后才会出现所选日期的指标与数据截止时间。",
    noGmvStoresTitle: "没有可用的 GMV Max 店铺",
    noGmvStoresDescription: "当前广告账户没有返回 GMV Max 店铺；普通与 Smart+ 系列不受影响。",
    summaryAria: "广告系列汇总指标",
    spend: "花费",
    orders: "订单",
    revenue: "转化收入",
    roi: "综合 ROI",
    cpa: "每单成本",
    impressions: "展示",
    clicks: "点击",
    search: "搜索系列",
    searchPlaceholder: "系列名称 / ID",
    filtersAria: "广告系列筛选",
    apply: "应用筛选",
    kindLabel: "系列来源",
    allKinds: "全部来源",
    kind: { regular: "普通", smart_plus: "Smart+", gmv_max: "GMV Max" },
    storeLabel: "选择 GMV Max 店铺",
    allStores: "全部 GMV Max 店铺",
    selectedStores: "已选 {count} 个店铺",
    gmvTypeLabel: "GMV Max 子类型",
    allGmvTypes: "全部 GMV Max 类型",
    gmvType: { product: "Product", live: "LIVE" },
    statusLabel: "投放状态",
    allStatuses: "全部状态",
    status: { active: "投放中", paused: "已暂停", other: "其他" },
    datePreset: "日期范围",
    today: "今天",
    yesterday: "昨天",
    last7Days: "近 7 天",
    last30Days: "近 30 天",
    custom: "自定义",
    startDate: "开始日期",
    endDate: "结束日期",
    coveragePending: "历史数据回填中",
    coverageRange: "回填中 · {start}–{end}",
    dataThrough: "数据截至 {time}",
    metricDefinitionAria: "查看指标口径",
    revenueDefinition: "口径：普通与 Smart+ 使用归因购买价值，GMV Max 使用 gross revenue；ROI 和每单成本由汇总基础指标计算。",
    listTitle: "系列列表",
    listAria: "TikTok 广告系列运营数据",
    count: "{count} 个系列",
    accountMetadataPending: "账户币种与时区待首次同步",
    columnCampaign: "系列 / ID",
    columnKind: "来源",
    columnObjective: "目标 / 子类型",
    columnStore: "店铺",
    columnBudget: "预算 / 模式",
    columnTargetRoi: "目标 ROI",
    columnStatus: "状态",
    columnModified: "修改时间",
    unavailable: "历史快照 · 当前不可用",
    pageSize: "每页行数",
    sortLabel: "排序字段",
    sort: {
      spend: "按花费", orders: "按订单", attributed_revenue: "按转化收入",
      cost_per_order: "按每单成本", roas: "按 ROAS", budget: "按预算", target_roi: "按目标 ROI",
      modified_at: "按修改时间", name: "按名称",
    },
    desc: "降序",
    asc: "升序",
    paginationAria: "广告系列分页",
    paginationSummary: "第 {page} / {totalPages} 页",
    previousPage: "上一页",
    nextPage: "下一页",
    noBusinessCenterTitle: "还没有可选择的 Business Center",
    noBusinessCenterDescription: "请先连接 TikTok 并完成 Business Center 同步。",
    noAdvertiserTitle: "还没有可选择的广告账户",
    noAdvertiserDescription: "请先同步当前 Business Center 的广告账户。",
    neverSyncedTitle: "尚未同步广告系列",
    neverSyncedDescription: "工作空间所有者可先刷新系列配置，再刷新日报。",
    emptyTitle: "没有广告系列",
    emptyDescription: "最新完整同步成功，但 TikTok 没有返回广告系列。",
    noResultsTitle: "没有符合筛选的系列",
    noResultsDescription: "调整来源、店铺、日期或搜索条件后重试。",
  },
  audit: {
    title: "审计日志",
    total: "共 {count} 条记录",
    filtersAria: "审计日志筛选",
    query: "人员",
    queryPlaceholder: "姓名、邮箱或 UUID",
    actionAria: "动作",
    resultAria: "结果",
    allActions: "全部动作",
    allResults: "全部结果",
    startTime: "开始时间",
    endTime: "结束时间",
    dateRange: "时间范围",
    clearDateRange: "清除时间范围",
    today: "今天",
    yesterday: "昨天",
    days3: "近 3 天",
    days7: "近 7 天",
    days30: "近 30 天",
    customDate: "自定义",
    apply: "应用筛选",
    columnTime: "时间",
    columnActor: "操作者",
    columnAction: "动作",
    columnTarget: "目标",
    columnResult: "结果",
    columnDetails: "详情",
    details: "查看事件详情",
    tableAria: "工作空间审计日志",
    loading: "正在加载审计日志",
    loadFailedTitle: "无法加载审计日志",
    loadFailed: "审计日志加载失败，请稍后重试",
    emptyTitle: "没有匹配的审计事件",
    emptyDescription: "调整筛选条件后重试。",
    paginationAria: "审计日志分页",
    paginationSummary: "第 {page} / {totalPages} 页",
    previousPage: "上一页",
    nextPage: "下一页",
    pageSize: "每页条数",
    drawerTitle: "审计事件详情",
    closeDetail: "关闭详情",
    eventId: "事件 ID",
    actorId: "操作者 UUID",
    targetType: "目标类型",
    targetId: "目标 UUID",
    requestId: "请求 ID",
    reason: "原因",
    permission: "权限变化",
  },
  advertiserAccounts: {
    title: "广告账户管理",
    description: "管理您的TikTok广告账户，打开开关启用数据同步",
    authorizeFirst: "请先进行授权",
    syncAllAccounts: "同步广告账户",
    guide: {
      title: "操作指南",
      summary: "开启账户自动同步广告系列，关联店铺可获取完整收益报表",
      expand: "展开说明",
      collapse: "收起说明",
      syncTitle: "同步说明：",
      syncPrefix: "开启广告账户将会自动同步广告系列列表和详情；如需同步完整收益报表（如花费、订单数、CPA、ROI等），请移步",
      storesManagement: "店铺管理",
      syncSuffix: "开启关联店铺。关闭广告账户开关将立即停止同步。",
      occupancyTitle: "广告户占用提示：",
      occupancyPrefix: "如果广告户显示红色状态提示",
      occupiedBy: "已被 XXX 占用",
      occupancySuffix: "，表示该广告户已被其他团队成员或用户先注册使用。点击提示可以查看占用详情与注册时间。",
    },
    metrics: {
      ariaLabel: "广告账户关键指标",
      total: "广告账户总数",
      enabled: "已启用同步",
      realtime: "实时同步",
      active: "已开启",
      paused: "已暂停",
      autoTrigger: "自动触发",
      authStatus: "授权状态",
      authorized: "已授权",
      unauthorized: "未授权",
      activeConnection: "有效连接",
      actionNeeded: "需去授权",
    },
    filters: {
      ariaLabel: "广告账户筛选与搜索",
      searchAria: "搜索广告账户名称或ID",
      searchPlaceholder: "搜索账户名称或ID...",
      searchSubmit: "搜索",
      businessCenter: "Business Center",
      allBusinessCenters: "全部 Business Center",
      dateRange: "时间范围",
      today: "今天",
      yesterday: "昨天",
      days3: "近 3 天",
      days7: "近 7 天",
      days15: "近 15 天",
      days30: "近 30 天",
      customDate: "自定义",
      clearDateRange: "清除日期范围",
    },
    table: {
      title: "广告账户列表",
      description: "管理您的 TikTok 广告账户，开启开关即可启用广告系列数据同步。",
      emptyTitle: "暂无广告账户数据",
      emptyDescSearch: "没有匹配当前搜索条件的广告账户。",
      ariaLabel: "广告账户列表",
      colSyncStatus: "同步状态",
      colAccountInfo: "账户信息",
      colAccountId: "账户ID",
      colRelatedCampaigns: "关联系列",
      viewRelatedCampaigns: "查看系列 ({count})",
      relatedCampaignsAria: "查看 {name} 的关联广告系列（{count}）",
      colBalance: "余额",
      colSpend: "花费",
      colCurrency: "货币",
      colTimezone: "时区",
      colLastSyncUtc: "最后同步UTC时间",
      occupied: "已被占用",
      toggleSyncAria: "切换 {name} 同步状态",
      syncEnabled: "已启用",
      syncDisabled: "未启用",
      copyId: "复制ID",
      notSynced: "未同步",
      syncAccountAria: "同步 {name}",
    },
    mobile: {
      occupied: "已被占用",
      enabled: "启用",
      disabled: "停用",
      accountId: "账户ID",
      relatedCampaigns: "关联系列",
      balanceCurrency: "余额 / 货币",
      spend: "花费",
      timezone: "时区",
      lastSyncUtc: "最后同步UTC",
      notSynced: "未同步",
      syncNow: "立即同步",
    },
    modals: {
      occupancy: {
        close: "关闭",
        title: "广告账户已被占用",
        idLabel: "ID: {id}",
        occupiedUser: "占用用户",
        unknownUser: "未知账号",
        boundTime: "绑定时间",
        unknownTime: "未知时间",
        description: "当前广告户已被最早绑定的账号占用。如需管理此账户，请使用该占用者的账号登录，或联系管理员协助解除占用。",
        acknowledge: "知道了",
        switchAccount: "切换账号登录",
      },
      confirmSync: {
        close: "关闭",
        titleEnable: "开启同步确认",
        titleDisable: "停止同步确认",
        bodyEnable: "开启同步后，系统将定时自动同步该广告账户下的全部广告系列与投放详情数据。",
        bodyDisable: "关闭同步后，该广告账户下的所有广告系列将暂停拉取最新数据，历史报表仍会保留。",
        cancel: "取消",
        confirmEnable: "确认开启",
        confirmDisable: "确认停止",
      },
      serviceExpired: {
        close: "关闭",
        title: "服务期已结束",
        subtitle: "无法启用广告账户同步",
        description: "您的平台会员服务期已结束，暂停广告户数据同步功能。请续费套餐以恢复全部权益。",
        notNow: "暂不购买",
        renewPackage: "前往续费套餐",
      },
    },
  },
  advancedFilter: {
    trigger: "高级筛选",
    panelTitle: "设置筛选条件",
    addCondition: "添加条件",
    clearAppliedView: "取消视图「{name}」",
    removeCondition: "删除条件",
    timeRangeLabel: "时间范围",
    fieldLabel: "字段",
    operatorLabel: "运算符",
    valueLabel: "值",
    textPlaceholder: "输入筛选值",
    numberPlaceholder: "输入数值",
    incompleteHint: "有 {count, plural, other {# 个条件}}未填写完整，尚未生效",
    unknownField: "未知字段，请删除该条件",
    operators: {
      eq: "等于",
      neq: "不等于",
      gt: "大于",
      gte: "大于等于",
      lt: "小于",
      lte: "小于等于",
    },
    timeRanges: {
      today: "今天",
      last3Days: "近 3 天",
      last7Days: "近 7 天",
      last15Days: "近 15 天",
      last30Days: "近 30 天",
    },
    saveAsNewView: "另存为新视图",
    saveViewTitle: "保存视图",
    renameViewTitle: "重命名视图",
    viewNameLabel: "视图名称",
    viewNamePlaceholder: "输入视图名称",
    viewNameRequired: "请输入视图名称",
    visibilityLabel: "可见范围",
    visibilityPrivate: "仅自己可见",
    visibilityShared: "团队共享",
    save: "保存",
    saveFailed: "保存失败，请重试",
    dirtyHint: "你调整了筛选",
    clear: "清除",
    viewsMenuLabel: "保存的视图",
    myViews: "我的视图",
    teamViews: "团队视图",
    viewsEmpty: "还没有保存的视图",
    noSavedViews: "暂无保存视图",
    moreViews: "更多视图",
    currentView: "当前视图",
    applyView: "应用视图",
    renameView: "重命名视图",
    deleteView: "删除视图",
    confirmDelete: "删除",
    activeViewLabel: "当前视图：{name}",
    ownerSuffix: "来自 {name}",
    viewMoreMenu: "视图「{name}」更多操作",
    appliedConditions: "已应用 {count, plural, other {# 个}}条件",
  },
  campaigns: {
    header: {
      enableAccountsFirst: "请先启用广告账户",
    },
    actionBar: {
      ariaLabel: "批量操作工具栏",
      selectedCount: "已选 {count} 项",
      enable: "批量开启",
      pause: "批量暂停",
      edit: "编辑系列",
      creatives: "创意素材",
      deliveryPlan: "投放方案",
      copy: "复制系列",
      bindRuleGroup: "绑定规则组",
      unbindRuleGroup: "解绑规则组",
      clearSelection: "取消选择",
    },
    filters: {
      ariaLabel: "广告系列筛选",
      searchAria: "搜索广告系列",
      clearSearchAria: "清空搜索",
      searchPlaceholder: "系列名称/ID/店铺/商品ID",
      searchSubmit: "搜索",
      advAccount: "广告账户",
      allAdvAccounts: "全部广告账户",
      businessCenter: "Business Center",
      allBusinessCenters: "全部 Business Center",
      store: "店铺",
      allStores: "全部店铺",
      dateRange: "时间范围",
      reportPeriod: "报表周期",
      today: "今天",
      todayWithDate: "今天 ({date})",
      yesterday: "昨天",
      days3: "近 3 天",
      days7: "近 7 天",
      days15: "近 15 天",
      days30: "近 30 天",
      months3: "近3个月",
      months6: "近6个月",
      months12: "近12个月",
      customDate: "自定义日期",
      campaignType: "系列类型",
      allTypes: "全部类型",
      productType: "商品带货",
      liveType: "直播带货",
      statusLabel: "投放状态",
      allStatuses: "全部状态",
      statusActive: "投放中",
      statusPaused: "已暂停",
      startDate: "开始日期",
      endDate: "结束日期",
      clearDateRange: "清除日期范围",
      reset: "重新筛选",
    },
    advancedFilterFields: {
      bc: "业务中心",
      advertiser: "广告账户",
      store: "店铺",
      date: "报表日期",
      type: "系列类型",
      status: "投放状态",
      budget: "预算",
      roiTarget: "目标 ROI",
      spend: "花费",
      orders: "订单数",
      revenue: "收入",
      roi: "ROI",
      cpa: "CPA",
      typeProduct: "商品带货",
      typeLive: "直播带货",
      statusEnable: "投放中",
      statusDisable: "已暂停",
    },
    table: {
      title: "TK-Master 广告系列列表",
      description: "查看与管理店铺绑定的 TK-Master 广告系列投放状态、预算及归因指标。",
      metaCount: "共 {count} 个系列",
      metaAttribution: "USD · 实时归因",
      emptyTitle: "暂无系列数据",
      emptyDescription: "当前筛选条件下没有匹配的 GMVMAX 广告系列。",
      selectAll: "全选",
      selectRow: "选择 {name}",
      colCampaign: "系列信息",
      colStore: "店铺",
      colRuleGroup: "规则组",
      colStatus: "开关状态",
      colBudget: "预算",
      colRoiTarget: "目标ROI",
      colSpend: "花费",
      colOrders: "订单",
      colCpa: "CPA",
      colRevenue: "转化收入",
      colRoi: "实时ROI",
      colImpressions: "展现量",
      colClicks: "点击量",
      badgeProduct: "商品",
      badgeLive: "直播",
      unbindRuleGroup: "解绑规则组",
      toggleStatusAria: "切换 {name} 状态",
      statusActive: "投放中",
      statusPaused: "已暂停",
      toastStatusEnabled: "系列已开启",
      toastStatusPaused: "系列已暂停",
      rowMenuAria: "{name} 操作菜单",
      menuEdit: "编辑系列",
      menuCreatives: "创意素材",
      menuPlan: "投放方案",
      menuCopy: "复制系列",
      menuUnbind: "解绑规则组",
      totalsRowLabel: "合计",
      totalsRowAria: "当前筛选范围内广告系列汇总指标",
      refreshing: "正在更新数据…",
    },
    mobile: {
      emptyTitle: "暂无系列数据",
      badgeProduct: "商品",
      badgeLive: "直播",
      labelSpend: "花费",
      labelOrders: "订单",
      labelRevenue: "转化收入",
      labelRoi: "实时ROI",
      labelCpa: "CPA",
      labelRoiTarget: "目标ROI",
      labelBudget: "日预算",
      labelImpressions: "展现量",
      labelClicks: "点击量",
      statusActive: "投放中",
      statusPaused: "已暂停",
      editCampaign: "编辑系列",
      creatives: "创意",
      plans: "方案",
      copy: "复制",
    },
    pauseConfirm: {
      title: "暂停此广告系列？",
      body: "确定要执行此操作吗？暂停后，该广告系列将无法享受 ROI 保护。",
      cancel: "取消",
      confirm: "确认",
      close: "关闭",
    },
    modals: {
      editCampaign: {
        close: "关闭",
        title: "编辑广告系列",
        subtitle: "系列 ID: {id} · 店铺: {store}",
        nameLabel: "系列名称",
        namePlaceholder: "请输入广告系列名称",
        budgetLabel: "日预算 (USD)",
        budgetAria: "日预算",
        roiTargetLabel: "目标 ROI",
        roiTargetAria: "目标 ROI",
        associatedProducts: "关联推广商品 ({count})",
        batchRemove: "批量移除已选 ({count})",
        selectAllProducts: "全选商品",
        emptyProductsTitle: "暂无关联商品",
        emptyProductsDesc: "此系列尚未关联具体推广商品",
        selectProductAria: "选择商品",
        priceLabel: "价格",
        salesLabel: "销量",
        cancel: "取消",
        saveChanges: "保存修改",
      },
      ruleGroup: {
        close: "关闭",
        title: "批量绑定规则组",
        subtitle: "已选中 {count} 个广告系列",
        selectLabel: "选择规则组",
        selectAria: "选择规则组",
        infoTitle: "规则说明",
        infoDesc: "绑定后，所选系列将自动应用该规则组的监控与调控逻辑。",
        cancel: "取消",
        confirmBind: "确认绑定",
      },
      creativeDetail: {
        close: "关闭",
        title: "素材详情与表现",
        subtitle: "系列: {name} ({id})",
        metaCount: "共 {count} 个创意素材",
        emptyTitle: "暂无创意素材",
        emptyDesc: "此广告系列尚未配置任何投放创意素材。",
        colCreative: "素材信息",
        colType: "类型",
        colStatus: "状态",
        colSpend: "花费",
        colOrders: "订单",
        colRevenue: "转化收入",
        colRoi: "实时ROI",
        colCpa: "CPA",
        typeVideo: "视频",
        typeAffiliate: "达人",
        typeProductCard: "商品卡",
        statusBoosted: "加热中",
        statusDelivering: "投放中",
        statusInQueue: "队列中",
        statusInactive: "未投放",
        configBoost: "配置加热",
      },
      deliverySession: {
        close: "关闭",
        title: "分时投放方案管理",
        subtitle: "系列: {name} ({id})",
        description: "配置推广商品的专属投放周期与定向预算计划：",
        emptyTitle: "暂无商品投放方案",
        emptyDesc: "请先在系列中关联商品，再配置分时投放方案。",
        dateRangeLabel: "投放周期",
        targetedBudgetLabel: "定向预算 (USD)",
        targetedBudgetAria: "定向预算",
        enablePlanAria: "开启方案",
        planActive: "已启用",
        planPaused: "已暂停",
        cancel: "取消",
        savePlan: "保存方案",
      },
      boostConfig: {
        close: "关闭",
        title: "配置创意加热",
        subtitle: "素材: {name} ({id})",
        budgetLabel: "加热预算 (USD)",
        budgetAria: "加热预算",
        durationLabel: "加热持续时长",
        durationAria: "加热持续时长",
        hours6: "6 小时",
        hours12: "12 小时",
        hours24: "24 小时 (推荐)",
        hours48: "48 小时",
        warningTitle: "加热说明",
        warningDesc: "启动加热后，TikTok 算法将在设定时间内为该素材分配更多探索流量。",
        cancel: "取消",
        startBoost: "立即加热",
      },
      copyCampaign: {
        close: "关闭",
        title: "复制广告系列",
        subtitle: "源系列: {name}",
        copyCountLabel: "复制份数",
        copyCountAria: "复制份数",
        warningTitle: "复制说明",
        warningDesc: "复制出的新系列将默认处于“暂停”状态，且包含与源系列相同的商品及出价目标配置。",
        cancel: "取消",
        confirmCopy: "确认复制",
      },
    },
  },
  creativeAssets: {
    boostStatus: { unknown: "加热状态未知", pending: "加热状态待更新" },
    authorization: {
      all: "全部授权类型", TTS_TT: "店铺官方账号", AFFILIATE: "联盟批量授权",
      AUTH_CODE: "视频码授权", TT_USER: "Business Account 授权", BC_AUTH_TT: "Business Center 授权",
      UNSET: "未指定", pending: "待同步", CONFLICT: "待核实", other: "其他授权",
    },
    boost: {
      active: "加热中",
      inactive: "未加热",
      unknown: "未知",
      stale: "快照可能过期",
      syncedAt: "同步于 {time}",
    },
    header: {
      title: "素材分析",
      subtitle: "洞察每个素材的投放表现",
      disclaimer: "· 数据仅供参考",
      dateBadgeLabel: "周期:",
      howToAddAccount: "如何添加账号",
    },
    metrics: {
      ariaLabel: "素材分析关键指标汇总",
      totalSpend: "总花费",
      totalSpendDesc: "选定时间范围内素材的广告花费总额，仅汇总相同且已知币种。",
      mixedCurrencies: "素材币种不同或未知，花费、收入和 ROI 不合计。请选择具体广告账户查看。",
      totalOrders: "总订单",
      totalOrdersDesc: "通过推广素材直接或间接归因成交的商品订单总数。",
      totalRevenue: "总收入",
      totalRevenueDesc: "通过推广素材转化产生的成交 GMV，仅汇总相同且已知币种。",
      avgCpa: "平均 CPA",
      avgCpaDesc: "平均获客成本（总花费 ÷ 总订单数）。",
      avgRoi: "综合 ROI",
      avgRoiDesc: "综合投入产出比（总收入 ÷ 总花费）。",
      metricDescAria: "{label} 口径说明",
    },
    datePresets: {
      today: "今天",
      yesterday: "昨天",
      "7days": "近7天",
      "30days": "近30天",
      custom: "自定义",
    },
    filterBar: {
      ariaLabel: "素材库筛选",
      campaign: "广告系列",
      allCampaigns: "全部广告系列",
      campaignMetricsHint: "按关联筛选素材；指标为所选日期内素材在全部广告系列中的合计。",
      dateLabel: "时间",
      statusLabel: "状态",
      businessCenter: "Business Center",
      allBusinessCenters: "全部 Business Center",
      advAccount: "广告账户",
      allAdvAccounts: "全部广告账户",
      allStatuses: "全部状态",
      creativeTypeLabel: "素材类型",
      typeAll: "全部素材类型",
      typeSelf: "自营",
      typeAffiliate: "联盟",
      typeUnknown: "其他",
      typeProductCard: "商品卡",
      statusActive: "投放中",
      statusInactive: "未投放",
      searchPlaceholder: "搜索身份 / 创意ID…",
      searchAria: "搜索身份或创意ID",
      searchSubmit: "搜索",
      clearSearchAria: "清空搜索",
      clearDateRange: "清除日期范围",
      clear: "清除",
      reset: "重新筛选",
    },
    advancedFilterFields: {
      spend: "创意花费",
      orders: "创意订单数",
      revenue: "创意收入",
      cpa: "创意 CPA",
      roi: "创意 ROI",
      status: "创意状态",
      impressions: "创意曝光量",
      clicks: "创意点击量",
      ctr: "商品广告点击率 (%)",
      adConversionRate: "创意转化率",
      videoView2s: "创意 2s 播放率",
      videoView6s: "创意 6s 播放率",
      videoViewP25: "创意 25% 播放率",
      videoViewP50: "创意 50% 播放率",
      videoViewP75: "创意 75% 播放率",
      videoViewP100: "创意完播率",
    },
    table: {
      title: "素材列表",
      notice: "请确保自营TikTok素材账号已添加到BC商务中心，包括官方号",
      searchResult: "🔍 搜索 \"{query}\" 找到 {count} 个结果",
      colThumb: "图",
      colId: "素材ID",
      colIdStatus: "素材ID",
      colCampaign: "广告系列",
      colStore: "店铺",
      campaignNameWithExtra: "{name} +{count}",
      colTrend: "趋势",
      colDeliveryStatus: "投放状态",
      colCreativeName: "素材名称",
      colAuthorName: "作者名称",
      colAuthorUsername: "作者账号",
      colPostUrl: "帖子链接",
      colPreviewUrl: "视频预览",
      colVideoCdnUrl: "视频源链接",
      colVideoId: "视频ID",
      colDuration: "视频时长",
      colMetadataError: "元数据状态",
      colCurrency: "币种",
      colIdentity: "身份",
      colType: "类型",
      colBoost: "加热状态",
      colAuthorizationType: "授权类型",
      colProductImpressions: "商品曝光",
      colProductClicks: "商品点击",
      colSpend: "花费",
      colOrders: "订单",
      colRevenue: "收入",
      colRoi: "ROI",
      colCpa: "CPA",
      colCtr: "商品广告点击率",
      colConversionRate: "广告转化率",
      colP2: "2秒播放率",
      colP6: "6秒播放率",
      colP25: "25%播放率",
      colP50: "50%播放率",
      colP75: "75%播放率",
      colP100: "完整播放率",
      columnsButton: "配置列",
      columnsTitle: "显示字段",
      columnsDescription: "按业务需要选择表格字段",
      columnsReset: "恢复默认列",
      columnGroupBasic: "基础信息",
      columnGroupProduct: "商品互动",
      columnGroupAdvertising: "广告转化",
      columnGroupVideo: "视频播放",
      openLink: "打开链接",
      noCover: "暂无封面",
      copyFailed: "复制失败，请手动复制",
      moreMetrics: "更多指标",
      lessMetrics: "收起指标",
      rowMenuAria: "素材操作：{name}",
      btnTrend: "趋势",
      btnPlay: "播放",
      statusDelivering: "投放中",
      statusDeliveringCount: "投放中 · {count}",
      statusInactive: "未投放",
      productCardNoVideo: "商品卡暂无视频",
      activeCampaignsTitle: "投放中系列",
      activeCampaignsCount: "{count} 个",
      activeCampaignsHint: "今日正在投放该素材的广告系列",
      inactiveCampaignsTitle: "投放状态",
      noCampaignsToday: "今日无投放系列",
      copyId: "复制系列 ID",
      copiedId: "已复制",
      copiedToast: "已复制系列 ID：{id}",
      emptyTitle: "暂无数据",
      emptyDescription: "还没有投放数据",
      emptySearchDescription: "尝试修改搜索条件",
      loading: "正在加载素材…",
      refreshing: "正在更新数据…",
    },
    modals: {
      trend: {
        title: "素材趋势",
        subtitle: "{name} · {type} · {id}",
        close: "关闭",
      },
      video: {
        title: "视频播放",
        loading: "加载视频…",
        unsupported: "您的浏览器不支持视频播放",
        noPreviewUrl: "暂无播放地址",
        loadFailed: "加载视频失败",
        close: "关闭",
      },
      guide: {
        title: "如何添加 TikTok 账号到商务中心 (BC)",
        subtitle: "按以下三步完成官方号与自营达人号的 BC 授权，即可同步素材与表现数据。",
        stepsAria: "添加账号步骤",
        close: "关闭",
        gotIt: "我知道了",
        step1Title: "登录 TikTok Business Center",
        step1Desc: "进入 TikTok for Business 商务中心，在左侧导航栏点击「资产」→「TikTok 账号」。",
        step2Title: "申请绑定或授权官方号 / 达人号",
        step2Desc: "点击「添加 TikTok 账号」，选择授权模式生成二维码或授权链接，发给达人 / 账号管理员在 TikTok App 内确认。",
        step3Title: "分配资产管理权限至当前应用",
        step3Desc: "在 TikTok 账号资产详情页，将该账号的投放与素材读取权限指派给当前系统绑定的授权成员或应用。",
        tipTitle: "重要提示",
        tipDesc: "官方号与自营达人号必须在同一个 Business Center 下授权，才能在 GMVMAX 系列与素材分析中实时同步视频与表现数据。",
      },
    },
  },
  admin: {
    common: {
      closeDetail: "关闭详情",
      query: "查询",
      filter: "筛选",
      platformLevel: "平台操作",
      paginationAria: "分页",
      paginationSummary: "第 {page} / {totalPages} 页",
      previousPage: "上一页",
      nextPage: "下一页",
    },
    workspaces: {
      allStatuses: "全部状态",
      columnWorkspace: "工作空间",
      columnOwner: "所有者",
      columnStatus: "状态",
      columnMembers: "成员",
      columnPending: "待接受邀请",
      title: "工作空间",
      total: "共 {count} 个工作空间",
      filtersAria: "工作空间筛选",
      searchAria: "名称或工作空间 ID",
      statusAria: "工作空间状态",
      loadFailedTitle: "无法加载工作空间",
      loadFailed: "暂时无法加载工作空间，请稍后重试",
      updateFailedTitle: "工作空间状态更新失败",
      updateFailed: "工作空间状态更新失败，请稍后重试",
      loading: "正在加载工作空间",
      tableAria: "工作空间管理列表",
      emptyTitle: "没有匹配的工作空间",
      emptyDescription: "调整筛选条件后重试。",
      detailFallback: "工作空间详情",
      detailLoading: "正在加载工作空间详情",
      detailFailedTitle: "无法加载工作空间详情",
      detailFailed: "暂时无法加载工作空间详情，请稍后重试",
      acceptedInvitations: "已接受邀请",
      expiredInvitations: "已过期邀请",
      revokedInvitations: "已撤销邀请",
      reason: "操作原因（5–500 字）",
      pause: "暂停工作空间",
      resume: "恢复工作空间",
      membersTitle: "成员",
      membersAria: "工作空间成员",
      noMembers: "暂无成员",
      historyTitle: "状态历史",
      historyAria: "工作空间状态历史",
      noHistory: "暂无暂停或恢复记录",
      historyItem: "{date} · {actor}",
    },
    users: {
      unnamed: "未命名用户",
      allStatuses: "全部账号状态",
      allPlatformRoles: "全部平台权限",
      noPlatformRole: "无平台权限",
      allMemberships: "全部工作空间归属",
      joinedMembership: "已加入工作空间",
      unassignedMembership: "未分配工作空间",
      columnUser: "用户",
      columnAuthStatus: "账号状态",
      columnPlatformRole: "平台权限",
      columnLastSignIn: "最近登录",
      never: "从未",
      title: "用户",
      total: "共 {count} 位用户",
      filtersAria: "用户筛选",
      searchAria: "姓名、邮箱或 UUID",
      statusAria: "账号状态",
      platformRoleAria: "平台权限",
      membershipAria: "工作空间归属",
      loadFailedTitle: "无法加载用户",
      loadFailed: "暂时无法加载用户，请稍后重试",
      loading: "正在加载用户",
      tableAria: "用户管理列表",
      emptyTitle: "没有匹配的用户",
      emptyDescription: "调整筛选条件后重试。",
      detailFallback: "用户详情",
      detailLoading: "正在加载用户详情",
      detailFailedTitle: "无法加载用户详情",
      detailFailed: "暂时无法加载用户详情，请稍后重试",
      authStatus: "账号状态：{status}",
      membershipsTitle: "所属工作空间",
      membershipsAria: "用户所属工作空间",
      noMemberships: "暂无所属工作空间",
    },
    audit: {
      allActions: "全部动作",
      allResults: "全部结果",
      columnTime: "时间",
      columnWorkspace: "工作空间",
      columnAction: "动作",
      columnResult: "结果",
      columnActor: "操作人 / 请求 ID",
      title: "平台操作记录",
      total: "共 {count} 条记录",
      filtersAria: "操作记录筛选",
      workspaceId: "工作空间 ID",
      workspacePlaceholder: "输入工作空间 ID",
      actionAria: "操作类型",
      resultAria: "操作结果",
      startTime: "开始时间",
      endTime: "结束时间",
      loadFailedTitle: "无法加载操作记录",
      loadFailed: "暂时无法加载操作记录，请稍后重试",
      loading: "正在加载操作记录",
      tableAria: "平台操作记录",
      emptyTitle: "没有匹配的操作记录",
      emptyDescription: "调整筛选条件后重试。",
    },
  },
  system: {
    storesFilterTeam: "团队",
    storesFilterAll: "全部",
    storesFilterAllTeams: "全部团队",
    storesFilterTeamUnassigned: "未分组",
    notificationGroupLabel: "团队 / 组",
    notificationGroupPlaceholder: "全部团队",
  },
  assets: {
    filterAll: "全部",
  },
  reports: {
    filterDate: "日期范围",
    filterSelectedCount: "已选 {count} 项",
    clearDate: "清除日期",
    datePresetLast7Days: "近 7 天",
    datePresetLast30Days: "近 30 天",
    datePresetLastWeek: "上周",
    datePresetLastMonth: "上月",
    dashboardPresetToday: "今天",
    dashboardPresetYesterday: "昨天",
    siteStatusFilterAll: "全部状态",
    siteStatusFilterActive: "正常",
    siteStatusFilterInactive: "未激活",
    siteStatusFilterError: "异常",
    siteStatusFilterPartial: "部分异常",
    siteMediaFilterAll: "全部媒体",
    siteMediaFilterApplovin: "AppLovin",
    siteMediaFilterMeta: "Meta",
    siteMediaFilterGoogle: "Google",
    siteMediaFilterTiktok: "TikTok",
    channelFilterAll: "全部渠道",
    channelFilter: "渠道",
    siteStatusFilter: "状态",
    siteMediaFilter: "媒体",
    siteFilterAll: "全部站点",
    siteFilter: "站点",
    accountFilter: "广告账户",
    accountFilterAll: "全部账户",
    adAccountDataSearchAria: "搜索广告账户",
    adAccountDataSearchPlaceholder: "搜索账户名称或 ID",
    adAccountDataSearchSubmit: "搜索",
    teamSummaryGrainByDay: "按日",
    teamSummaryGrainByWeek: "按周",
    teamSummaryGrainByMonth: "按月",
    teamSummaryGrainByYear: "按年",
    teamSummaryGrainAria: "时间粒度",
  },
  products: {
    categoryAll: "全部类目",
    filterCategory: "类目",
    filterCreatedDate: "创建时间",
    clearCreatedDate: "清除创建时间",
    filterCollapse: "收起筛选",
    filterExpand: "展开筛选",
    activeFiltersCount: "{count} 项筛选",
    columns: "列配置",
    columnVisibility: "自定义显示列",
    imagePreviewAria: "查看大图：{title}",
    videoPreviewAria: "播放视频：{title}",
  },
  media: {
    filterSearch: "搜索素材",
    filterSize: "尺寸",
    filterType: "类型",
    filterTags: "标签",
  },
  orders: {
    filterShop: "店铺",
    filterTeam: "团队",
    filterStatus: "状态",
    allShops: "全部店铺",
    allTeams: "全部团队",
    allStatuses: "全部状态",
  },
} as const;

type MessageShape<T> = {
  readonly [Key in keyof T]: T[Key] extends string ? string : MessageShape<T[Key]>;
};

const enUS = {
  bulkOperations: {
    materialName: "Creative", materialBudget: "Budget per creative", noActiveBoost: "No active boost",
    selectCampaign: "Select a campaign",
    error_creative_target_ambiguous: "This creative has multiple placements; the boost target cannot be determined safely.",
    error_too_many_targets: "More than 100 operation targets. Select fewer creatives and try again.",
    campaignStatus: "Status", currentRoi: "Current target ROI", executionResult: "Result", campaignEnabled: "Enabled", campaignPaused: "Paused",
    error_test_campaign_only: "Local testing only allows campaign 9.07豚豚抓取TEST. Return to the list and select it.",
    creativeActionBar: "Creative bulk actions",
    loadingTargets: "Loading available campaigns…",
    loadingSessions: "Loading cancellable boost sessions…",
    error_session_query_failed: "Could not load boost sessions. Refresh and try again.",
    error_rate_limited: "Too many operations. Please try again later.",
    error_validation_failed: "Could not validate the targets. Refresh and select again.",
    mock: "Mock data · Real ads are unchanged", disabled: "Bulk writes are not enabled",
    previewOnly: "Bulk execution is not enabled. You can review and enter operation settings, but cannot submit yet.",
    enable: "Enable", pause: "Pause", set_roi: "Set target ROI", create_boost: "Boost creatives", cancel_boost: "Cancel boosts",
    title: "Confirm bulk operation", selected: "{count} items selected", account: "Advertiser", campaign: "Campaign", product: "Product", video: "Video",
    budget: "Budget per boost", roi: "New target ROI", oldRoi: "Previous target ROI", end: "End time (optional, in each account timezone)", clearEnd: "Clear end time", timezone: "Account timezone", currency: "Currency", total: "Total budget",
    confirm: "Confirm submission", submitting: "Submitting", close: "Close", remove: "Remove", clear: "Clear selection",
    choose: "Choose the associations to operate on", chooseSession: "Choose the exact boost sessions to cancel", noTargets: "No operation targets available. Check associations or authorization.", ineligible: "This operation is unavailable in the current state",
    readOnly: "Your role or workspace state does not allow writes", limit: "Maximum 100 operation items per submission", invalidValue: "Enter a valid positive number",
    budgetMinimum: "USD boost budget must be at least 10. Other currency minimums are unverified and block live mode.",
    budgetNote: "The same amount applies in each account currency. Boost budgets are separate from campaign budgets and excluded from ROI protection.",
    immediate: "Starts immediately. End time is interpreted in each account timezone.", results: "Bulk operation history", queued: "Queued", running: "Running", succeeded: "Succeeded", failed: "Failed", partial: "Partially succeeded", unknown: "Needs verification",
    unknownNote: "The outcome is uncertain. Automatic retry is stopped; verify the upstream result before taking further action.", retry: "Retry confirmed failures", refresh: "Refresh results", requestError: "Request failed: {code}", none: "No boost sessions", noSelection: "Select at least one operation item",
    scopeNote: "Selection persists across pages and clears when filters change.", sessions: "Boost sessions", active: "Active", cancelled: "Cancelled", ended: "Ended",
    mockTitle: "TikTok bulk operation mock workspace", campaigns: "Campaigns", creatives: "Creatives", previous: "Previous", next: "Next", selectPage: "Select current page", search: "Search", notMock: "This page is only available in local mock mode",
    error_forbidden: "Permission denied or workspace paused", error_stale_authorization: "Authorization changed. Refresh and select again.", error_roi_unsupported: "This campaign does not support target ROI", error_overlapping_session: "An overlapping boost or pending creation already exists", error_campaign_busy: "This campaign has an ongoing or unconfirmed operation. This request was not executed; verify the earlier result before retrying.", error_campaign_capacity: "The campaign has reached its 100 boosted video limit", error_invalid_end_time: "End time is invalid, expired, or ambiguous in the account timezone", error_video_required: "Only videos associated with a product can be boosted", error_creative_ineligible: "This creative cannot currently be boosted", error_session_unavailable: "This boost session cannot be cancelled", error_budget_below_minimum: "Budget is below the known minimum", error_retry_not_allowed: "Only confirmed failed items can be retried", error_idempotency_conflict: "This submission identifier was used for different input", error_upstream_rejected: "The upstream service rejected the operation", error_outcome_unknown: "The upstream outcome needs verification", error_lease_expired: "The execution lease expired; the outcome needs verification", error_writes_disabled: "Live writes are not enabled", error_request_failed: "The request did not complete", error_unavailable: "The resource is no longer available",
  },
  meta: {
    description: "A TikTok Ads workspace for growth teams",
    title: "TK-Master · TikTok Ads workspace",
  },
  language: {
    label: "Switch language",
    localeLabel: "Language",
    localeZh: "简体中文",
    localeEn: "English",
  },
  common: {
    allTime: "All time",
    cancel: "Cancel",
    clearInput: "Clear input",
    clearOptionSearch: "Clear option search",
    close: "Close",
    exitFullScreen: "Exit full screen",
    fullScreen: "Full screen",
    noMatchingOptions: "No matching options",
    noRequestId: "Request ID unavailable",
    notAvailable: "—",
    retry: "Retry",
    search: "Search",
    searchOptions: "Search options",
    system: "System",
    tableEmpty: "No data",
    tableError: "Could not load data. Please try again.",
    tableLoading: "Loading…",
    tablePageSize: "Per page",
    tablePageSizeAria: "Rows per page",
    tablePageSizeOption: "Per page {count}",
    tablePaginationAria: "Table pagination",
    tablePaginationNext: "Next",
    tablePaginationPrevious: "Previous",
    tableResizeColumn: "Resize column",
    tableRetry: "Retry",
    tableSelectAll: "Select all",
    tableActions: "Actions",
    tableSelectRow: "Select row",
    tableShowing: "Showing {from}–{to} of {total}",
    tableShowingApproximate: "Showing {from}–{to} of about {total}",
    tableShowingRange: "Showing {from}–{to}",
    export: "Export",
    exportModalTitle: "Export list",
    exportModalDescription: "Export the {count} selected list item(s) as a CSV (UTF-8, opens in Excel).",
    exportModalClose: "Close",
    exportConfirm: "Export CSV",
    exportSuccess: "Exported {count} list item(s)",
    exportEmptySelection: "Select at least one list item to export.",
    exportFailed: "Export failed. Try again in a moment.",
    imageLoadError: "Failed to load image, click to retry",
  },
  errors: {
    networkTitle: "Network connection lost",
    networkDetail:
      "We couldn't reach the server. Check your connection and try again, or return home for now.",
    unauthorizedTitle: "Your session expired",
    unauthorizedDetail: "Sign in again to continue using your workspace.",
    forbiddenTitle: "You don't have access",
    forbiddenDetail:
      "This account can't perform that action. Contact your workspace owner if you need permission.",
    notFoundTitle: "We couldn't find that",
    notFoundDetail: "It may have been removed or the link may have expired.",
    unavailableTitle: "Service temporarily unavailable",
    unavailableDetail: "The server isn't responding right now. Please try again shortly.",
    rateLimitedTitle: "Too many requests",
    rateLimitedDetail: "This action was rate-limited. Wait a moment and try again.",
    workspacePausedTitle: "Workspace paused",
    workspacePausedDetail:
      "This workspace is paused and can't be used until it is resumed.",
    retry: "Retry",
    refresh: "Refresh",
    signIn: "Sign in",
    goBack: "Go back",
    goHome: "Back to home",
    requestIdLabel: "Request ID",
  },
  validation: {
    invalid: "The submitted value is invalid.",
    display_name: { min: "Display name must be at least 2 characters.", max: "Display name cannot exceed 50 characters." },
    email: { invalid: "Enter a valid email address.", max: "Email address is too long." },
    password: { required: "Enter your password.", min: "Password must be at least 8 characters.", max: "Password cannot exceed 32 characters.", letter: "Password must contain at least one letter.", number: "Password must contain at least one number." },
    confirm_password: { mismatch: "The passwords do not match." },
    current_password: { required: "Enter your current password." },
    workspace_name: { min: "Workspace name must be at least 2 characters.", max: "Workspace name cannot exceed 80 characters." },
    workspace_role_name: { min: "Role name must be at least 2 characters.", max: "Role name cannot exceed 50 characters." },
    workspace_role_description: { max: "Role description cannot exceed 200 characters." },
    status_reason: { min: "Reason must be at least 5 characters.", max: "Reason cannot exceed 500 characters." },
    invitation_note: { min: "Invitation note must be at least 1 character.", max: "Invitation note cannot exceed 80 characters." },
    invitation_ref: { invalid: "The invitation link is invalid." },
  },
  apiErrors: {
    request: { validation: "Check the form and try again.", query_validation: "Check the filters and try again.", origin_untrusted: "We couldn't verify where this request came from. Refresh the page and try again.", route_not_found: "We couldn't find what you requested." },
    auth: { unauthorized: "Your session has expired. Please sign in again." },
    authorization: { admin_forbidden: "This account does not have platform administration access.", workspace_forbidden: "This account is not allowed to perform this action." },
    workspace: { not_found: "Workspace not found.", paused: "The Workspace is paused.", data_unavailable: "Workspace data is temporarily unavailable. Please try again later.", super_admin_forbidden: "Platform administrators cannot create or join a Workspace." },
    filter_view: {
      not_found: "Filter view not found.",
      name_conflict: "A filter view with the same name already exists.",
      limit_reached: "Filter view limit reached. Remove unused views first.",
      forbidden: "Only the creator can manage this shared filter view.",
    },
    profile: { unavailable: "The user profile is temporarily unavailable. Please try again later." },
    avatar: { invalid_image: "Choose a valid JPEG, PNG, or WebP image.", too_large: "The avatar must be 2 MiB or smaller.", unavailable: "The avatar service is temporarily unavailable. Try again later." },
    invitation: { invalid: "The invitation does not exist or is no longer valid.", link_invalid: "The invitation link is invalid.", expired: "The invitation has expired.", not_found: "Invitation not found.", membership_conflict: "This account already belongs to another Workspace.", accepted_cannot_regenerate: "An accepted invitation cannot be regenerated.", state_changed: "The invitation status has changed.", cannot_copy: "This invitation cannot be copied in its current state.", cannot_revoke: "This invitation cannot be revoked in its current state." },
    referral: { invalid: "The invite link is invalid.", revoked: "The invite link was revoked.", unavailable: "The invite link is unavailable." },
    member: { not_found: "Member not found.", owner_cannot_remove: "The owner account cannot be removed.", owner_permissions_locked: "Owner permissions cannot be changed." },
    workspace_role: { not_found: "Role not found.", system_locked: "Built-in roles cannot be changed or deleted.", name_conflict: "A role with this name already exists.", assigned_cannot_delete: "Reassign this role's members before deleting it.", owner_cannot_assign: "The owner role cannot be reassigned.", disabled_cannot_edit: "Enable this role before editing it.", disabled_cannot_assign: "Enable this role before assigning it." },
    tiktok: { not_connected: "This Workspace is not connected to TikTok.", authorization_unavailable: "TikTok authorization is temporarily unavailable. Try again later.", authorization_not_completed: "TikTok authorization was not completed. Start the connection again and confirm the authorization request.", permission_missing: "This TikTok authorization cannot access the requested resource. Check the app and authorized account permissions, then reconnect.", manual_sync_capacity: "Manual sync capacity is currently full. Try again later.", manual_sync_cooldown: "This resource is in its manual sync cooldown. Try again later.", rate_limited: "TikTok is receiving too many requests. Try again later.", response_invalid: "TikTok returned data that could not be recognized. Try again; if the problem continues, use the request ID for support.", sync_unavailable: "TikTok sync is temporarily unavailable. Try again later.", sync_timeout: "TikTok did not respond in time. Try again.", upstream_unavailable: "TikTok is temporarily unavailable. Try again later.", reauthorization_required: "TikTok authorization has expired. Reconnect to continue.", sync_in_progress: "TikTok sync is already in progress. Try again shortly." },
    user: { not_found: "User not found." },
    database: { conflict: "The data changed while you were working. Refresh the page and try again.", retry: "This action is temporarily busy. Try again in a moment." },
    service: { unavailable: "The service is temporarily unavailable. Please try again later." },
  },
  authErrors: {
    EMAIL_NOT_VERIFIED: "Verify your email before signing in.", FAILED_TO_CREATE_SESSION: "Unable to sign in right now. Please try again later.", FAILED_TO_CREATE_USER: "Unable to create the account right now. Please try again later.", INVALID_EMAIL: "Enter a valid email address.", INVALID_EMAIL_OR_PASSWORD: "The email or password is incorrect.", INVALID_PASSWORD: "The password is incorrect.", INVALID_TOKEN: "This link is invalid or expired. Request a new one.", PASSWORD_TOO_LONG: "The password is too long.", PASSWORD_TOO_SHORT: "The password is too short.", TOKEN_EXPIRED: "This link is invalid or expired. Request a new one.", USER_ALREADY_EXISTS: "This email is already registered. Sign in or use another email.", USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "This email is already registered. Sign in or use another email.", REFERRAL_INVALID: "The invite link is invalid, so the account was not created. Check with the person who invited you and try again.", REFERRAL_REVOKED: "The invite link was revoked, so the account was not created. Check with the person who invited you and try again.", REFERRAL_UNAVAILABLE: "The invite link is unavailable, so the account was not created. Try again later.", REFERRAL_SERVICE_UNAVAILABLE: "The invite link could not be checked, so the account was not created. Try again later.",
  },
  labels: {
    workspaceRole: { member: "Member", owner: "Administrator" },
    workspaceStatus: { active: "Active", paused: "Paused" },
    adminUserStatus: { active: "Active", banned: "Banned", unconfirmed: "Unconfirmed" },
    platformRole: { super_admin: "Platform administrator", tenant: "Workspace user" },
    invitationStatus: { accepted: "Accepted", expired: "Expired", pending: "Pending", revoked: "Revoked" },
    referralStatus: { registered: "Registered", workspace_created: "Workspace created" },
    auditAction: { workspace_created: "Create Workspace", workspace_invitation_created: "Create invitation", workspace_invitation_regenerated: "Regenerate invitation", workspace_invitation_revealed: "View invitation link", workspace_invitation_revoked: "Revoke invitation", workspace_member_joined: "Member joined", workspace_member_removed: "Remove member", workspace_role_created: "Create role", workspace_role_updated: "Update role", workspace_role_deleted: "Delete role", workspace_role_enabled: "Enable role", workspace_role_disabled: "Disable role", workspace_member_role_changed: "Change member role", workspace_member_permission_granted: "Grant member permission", workspace_member_permission_revoked: "Revoke member grant", workspace_paused: "Pause Workspace", workspace_resumed: "Resume Workspace", workspace_tiktok_authorized: "Authorize TikTok", workspace_tiktok_business_centers_synced: "Sync Business Centers", workspace_tiktok_advertiser_accounts_synced: "Sync advertiser accounts", workspace_tiktok_stores_synced: "Sync stores", workspace_tiktok_creative_assets_synced: "Sync creative assets", workspace_tiktok_campaigns_synced: "Sync campaigns", workspace_tiktok_campaign_reports_synced: "Sync campaign reports" },
    auditResult: { failed: "Failed", noop: "No change", success: "Success" },
  },
  status: { defaultTitle: "Opening your workspace", defaultDetail: "Loading your Workspace…" },
  auth: {
    login: {
      eyebrow: "GMV MAX COMMAND CENTER",
      title: "Sign in to the GMV MAX workspace",
      description: "Monitor GMV, ROAS, ad spend, and order trends.",
      mobileSummary: "GMV, ROAS, and order trends in one growth workspace",
      terminalAria: "GMV MAX demo data preview",
      demoLabel: "GMV MAX · DEMO DATA",
      terminalTitle: "Full-funnel commerce performance",
      period: "Last 7 days",
      marketUs: "US",
      marketSea: "SEA",
      marketJp: "JP",
      gmv: "GMV",
      gmvTrend: "+18.6% vs prior 7 days",
      roas: "ROAS",
      roasTrend: "Up 0.42",
      orders: "Orders",
      ordersTrend: "+12.4%",
      chartTitle: "Ad spend & GMV",
      chartDetail: "Bars: spend · Area: daily GMV — investment and commerce rising together",
      chartLegendSpend: "Ad spend",
      chartLegendGmv: "Daily GMV",
      previewAria:
        "Static demo preview: ad spend and daily GMV over the last 7 days, totaling 128,640 US dollars in GMV, ROAS 4.86, and 3,284 orders",
      dataNote: "Synthetic data · Not linked to any ad account",
      noAccount: "New to TK-Master?",
      createAccount: "Create an account",
      email: "Email",
      password: "Password",
      forgotPassword: "Forgot password?",
      submit: "Open workspace",
      failed: "Sign-in failed. Please try again later.",
    },
    register: { requiredHint: "* Required fields", requirementLength: "8–32 characters", requirementLetter: "At least one letter", requirementNumber: "At least one number", invalidInvitation: "The invitation link is invalid. Ask the owner for a new one.", expiredInvitation: "The invitation has expired. Ask the owner for a new one.", unavailableInvitation: "The invitation was revoked or has already been used.", previewFailed: "The invitation link is invalid. Ask the owner for a new one.", createFailed: "The account could not be created. Please try again later.", invitationCreateFailed: "The account could not be created. Try again later or sign in with an existing account.", confirmTitle: "Verify your email", invitationTitle: "Accept Workspace invitation", title: "Create team account", confirmInvitationDescription: "After you verify your email, we'll continue adding this account to {workspace}.", targetWorkspace: "the target Workspace", confirmDescription: "Verify your email to create your first Workspace.", invitationDescription: "You were invited to {workspace}. Create an account or sign in with a verified email.", invitationFallbackDescription: "Create an account or use an existing account to continue with the invitation.", description: "Create an account, then set up a Workspace and invite your team.", hasAccount: "Already have an account?", backToLogin: "Back to sign in", sendingTitle: "Sending a verification email to {email}", sendingDetail: "Please wait and do not submit again.", sentTitle: "Verification email sent to {email}", sentInvitationDetail: "After you verify your email, we'll continue accepting the Workspace invitation.", sentDetail: "Open the link in the email to verify your account. If it isn't there, check your spam folder.", changeEmail: "Change email", backAndChangeEmail: "Go back and change email", resend: "Resend email", resending: "Sending", resendCooldown: "Resend in {seconds}s", resentDetail: "Verification email resent. Check your inbox and spam folder.", sendFailedTitle: "Verification email not sent", sendFailedDetail: "Retry sending the verification email or change the email address.", continueAccountTitle: "Continue with this account", continueAccountDetail: "You can use this account to accept the invitation.", continueAccount: "Continue with this account", invitationBadge: "Invitation to {workspace}", invitationExpiry: "Expires {date} · Can be used once", referralTitle: "You are registering with an invite link", referralDetail: "This registration is recorded for the person who invited you. After you verify your email, you will create your own Workspace.", referralChecking: "Checking the invite link", referralCheckFailed: "The invite link could not be checked. Registration will still include it.", referralInvalid: "This invite link is invalid. Check with the person who invited you, or register without the link.", referralRevoked: "This invite link was revoked. Check with the person who invited you, or register without the link.", referralUnavailable: "This invite link is unavailable. Check with the person who invited you, or register without the link.", referralContinue: "Register without this invite link", referralConflict: "This link includes both a team invitation and a personal invite. Ask the sender which one to use.", referralConflictContinue: "Register without these links", displayName: "Display name", displayNamePlaceholder: "e.g. Lin Morgan", workEmail: "Work email", password: "Password", confirmPassword: "Confirm password", createAndJoin: "Create account and join", createOwner: "Create account", checkInvitation: "Check invitation" },
    confirm: { title: "Verify your email", description: "We sent a verification link to your inbox.", detail: "Open the link in the email to verify your account. If it isn't there, check your spam folder.", backToLogin: "Back to sign in" },
    forgot: { failed: "The reset email could not be sent. Please try again later.", title: "Recover access", description: "Enter your registered email and we'll send a one-time password reset link.", backToLogin: "Back to sign in", sentTitle: "Reset email sent", sentDetail: "If the email is registered, you will receive a password reset message.", email: "Registered email", submit: "Send reset link" },
    updatePassword: { invalidLink: "The reset link is invalid or expired. Request a new one.", title: "Set a new password", description: "Use a strong password that you do not use on another service.", backToLogin: "Back to sign in", successTitle: "Password updated", successDetail: "You can now sign in and return to your workspace.", password: "New password", confirmPassword: "Confirm new password", submit: "Update password" },
    callback: { invalidLink: "The verification link is invalid or expired. Request a new one.", readFailed: "The account status is temporarily unavailable. Please try again later.", loadingTitle: "Verifying your email", loadingDetail: "We'll continue automatically when verification is complete.", failedTitle: "Unable to verify email", failedDescription: "Open the verification link in your email again." },
    invitation: { retryable: "We couldn't add you right now. The invitation is still valid, so try again later.", loading: "Accepting invitation", terminal: "Unable to accept invitation", failed: "Unable to join Workspace", description: "We'll confirm the invitation is valid and add you to the Workspace.", invalid: "Invitation no longer valid", retryLater: "Try again later", retry: "Retry joining", onboarding: "Create your own Workspace", flash: { INVITATION_EXPIRED: "The invitation expired. You can create your own Workspace or use a new invitation link.", INVITATION_INVALID: "The invitation was revoked, used by another account, or does not exist. You can create your own Workspace or use a new invitation link.", MEMBERSHIP_CONFLICT: "This account already belongs to another Workspace and cannot accept this invitation.", SERVICE_UNAVAILABLE: "The service is temporarily unavailable. The invitation is still valid, so try again later.", WORKSPACE_PAUSED: "The Workspace is paused. The same invitation can be retried after it resumes." } },
    form: { show: "Show {field}", hide: "Hide {field}", passwordRequirements: "Password requirements", requirementMet: "Met: {requirement}", requirementUnmet: "Not met: {requirement}", actionFailed: "Action not completed", invitationNotAccepted: "Invitation not accepted" },
  },
  shell: { workspaceNavigation: { overview: "Home", campaigns: "Campaigns", audiences: "Audiences", businessCenters: "Business Center", advertiserAccounts: "Advertiser accounts", stores: "Store list", creativeAssets: "Ad creatives", tools: "Tools", profitCalculator: "Profit calculator", roiCalculator: "ROI calculator", teamManagement: "Team Management", members: "Member management", roles: "Role management", audit: "Audit", integrations: "Account authorization", referrals: "Invite new users", settings: "User settings" }, adminNavigation: { workspaces: "Workspaces", users: "Users", audit: "Activity" }, platformManagement: "Platform admin", campaignOperations: "Campaign operations", mainNavigation: "Main navigation", workspace: "Workspace", workspaceNavigationLabel: "Workspace navigation", platformNavigationLabel: "Platform administration navigation", platformAdmin: "Platform administrator", signOutFailed: "Sign-out failed. Please try again.", collapseSidebar: "Collapse sidebar", openNavigation: "Open navigation", toggleSidebar: "Toggle sidebar", brandTagline: "Ad workbench", help: "Help", notifications: "Notifications", toggleTheme: "Toggle theme", accountSettings: "Account settings", accountMenu: "Account menu", accountRole: "{workspace} · {role}", signOut: "Sign out", switchWorkspace: "Switch Workspace" },
  routeGuard: {
    unavailableTitle: "Unable to load Workspace",
    unavailableDetail:
      "Check your network connection and try again. If the problem continues, contact an administrator.",
    reconnect: "Retry",
    switching: "Opening Workspace",
    deniedTitle: "Ask an administrator for access",
    deniedDetail:
      "Your account does not have the permission required for this page. Ask a Workspace administrator to grant access, then open this page again.",
    goToSettings: "Account settings",
  },
  paused: { eyebrow: "Workspace paused", title: "This Workspace is paused", blockedTitle: "A platform administrator paused this Workspace", detail: "Unexpired invitations can be used after the Workspace is resumed.", audit: "View audit activity", accountSettings: "Account settings", signOut: "Sign out" },
  onboarding: { progress: "Workspace setup progress", stepTitle: "Workspace", stepDescription: "Name and create", eyebrow: "Create Workspace", title: "Set up your Workspace", description: "Manage ads data, team members, and permissions in one place. You'll become the owner when it's created.", isolationTitle: "Members only", isolationDetail: "Data stays separate between Workspaces", collaborationTitle: "Ready for team collaboration", collaborationDetail: "Owners can create and assign custom roles around team responsibilities", accountSettings: "Account settings", cardTitle: "Name your Workspace", cardDescription: "Use a brand, business line, or region name.", createFailed: "Workspace creation failed. Please try again later.", field: "Workspace name", placeholder: "e.g. Polaris Growth Team", submit: "Create and open overview" },
  settings: {
    title: "Account settings",
    subtitle: "Manage your profile, sign-in details, and security.",
    modify: "Edit",
    saved: "Saved",
    avatar: { title: "Avatar", description: "Shown in app navigation and read from a public HTTPS address.", summary: "JPEG, PNG, or WebP. Use at least 256×256 and keep it under 2 MB. Shown in navigation and member lists.", fallbackBadge: "Letter avatar", change: "Change avatar", current: "Current avatar", currentAlt: "Current avatar", editAria: "Edit avatar", editTitle: "Edit avatar", chooseTitle: "Choose a new avatar", requirements: "JPEG, PNG, or WebP · 2 MiB maximum", choose: "Choose image", inputLabel: "Choose avatar image", previewAlt: "Avatar preview", submit: "Upload avatar", success: "Avatar updated", invalidType: "Choose a JPEG, PNG, or WebP image.", tooLarge: "The avatar must be 2 MiB or smaller.", failed: "The avatar could not be uploaded. Try again later." },
    profile: { sectionTitle: "Profile", publicHint: "Public profile", title: "Display name", description: "Used to identify your account in navigation and member lists.", editAria: "Edit display name", editTitle: "Edit display name", displayName: "Display name", placeholder: "e.g. Lin Morgan", submit: "Save display name", success: "Display name updated", failed: "Your display name could not be updated. Try again later." },
    email: { title: "Sign-in email", change: "Change email", description: "Your current email must approve the change before you verify the new address.", editAria: "Edit sign-in email", editTitle: "Edit sign-in email", current: "Current email", newEmail: "New email", submit: "Send confirmation email", success: "Approve the request from your current email, then verify the new address", same: "The new email must be different from your current email", failed: "The email change could not be started. Try again later." },
    password: { sectionTitle: "Security and password", change: "Change password", title: "Sign-in password", description: "Updating it keeps this device signed in and revokes sessions on other devices.", editAria: "Edit sign-in password", editTitle: "Edit sign-in password", statusLabel: "Password status", status: "Set", current: "Current password", new: "New password", confirm: "Confirm new password", submit: "Update password", success: "Password updated and other devices signed out", failed: "The password could not be updated. Check your current password and try again.", sessionHint: "This device stays signed in after saving." },
  },
  referrals: { title: "Invite new users", description: "Create one invite link and share it. The same link can invite more than one person. Each person creates their own Workspace after they register.", linkLabel: "Invite link", copy: "Copy link", copied: "Invite link copied", copyFailed: "The link could not be copied. Select it and copy it manually.", generate: "Create invite link", generating: "Creating invite link", loading: "Loading invite records", loadFailed: "Invite records could not be loaded", linkLoadFailed: "The invite link could not be loaded", createFailed: "The invite link could not be created. Try again later.", retry: "Retry", emptyTitle: "No one has registered with your link yet", emptyDescription: "They will appear here after they register.", recordsAria: "Invite records", noWorkspace: "No Workspace yet" },
  dashboard: {
    title: "Ads overview",
    subtitle: "Data updates hourly · Time zone GMT+8",
    greetingMorning: "Good morning",
    greetingAfternoon: "Good afternoon",
    greetingEvening: "Good evening",
    greetingNight: "Working late",
    greetingWithName: "{greeting}, {name}👋",
    greetingNameFallback: "there",
    reportPeriod: "Reporting period",
    reportPeriodAria: "Reporting period: {range}",
    dateCapCampaign: "Campaigns and KPIs load at most the last 90 days.",
    dateCapCreatives: "The creative leaderboard shows the last 30 days within that period.",
    kpiAria: "Overview key metrics",
    spend: "Total Spend",
    revenue: "Total Revenue",
    orders: "Total Orders",
    cpa: "CPA",
    roas: "ROI",
    avgCpa: "Avg. CPA",
    spendDesc: "Ad spend charged during the selected reporting period.",
    revenueDesc: "Ad-attributed sales amount in that period.",
    roasDesc: "Total revenue ÷ total spend.",
    ordersDesc: "Total SKU quantity attributed to ads in that period, not the number of orders.",
    cpaDesc: "Total spend ÷ total orders. Not calculated when total orders are 0.",
    metricDescAria: "Definition for {label}",
    spendFooter: "Total for the reporting period",
    revenueFooter: "Total for the reporting period",
    ordersFooter: "Attributed orders",
    roasFooter: "Attributed revenue ÷ spend",
    avgCpaFooter: "Spend ÷ orders",
    chartTitle: "Metric comparison",
    chartTitlePair: "{left} vs {right}",
    chartTitleSingle: "{name}",
    chartDescription:
      "Check up to two KPIs above to compare by day; click again to uncheck",
    chartMockBadge: "Demo data",
    chartTrendVsDays: "last {days} days",
    chartTrendUnavailable: "—",
    chartEmptySelect: "Select at least one KPI to show the trend",
    chartLegendAria: "Trend chart legend",
    chartTypeAria: "Trend chart type",
    chartTypeLine: "Line",
    chartTypeBar: "Bar",
    chartUnitAria: "Time aggregation unit",
    chartUnitDay: "Day",
    chartUnitWeek: "Week",
    chartUnitMonth: "Month",
    chartBrushAria: "Chart time range",
    chartUnavailableTitle: "Trend chart unavailable",
    chartUnavailableDescription: "No daily series for this reporting period.",
    chartLoading: "Loading trend",
    chartSeriesFailedTitle: "Trend chart could not be loaded",
    chartSeriesFailedDescription:
      "The daily series could not be read. Try again later.",
    loadFailedTitle: "Overview data could not be loaded",
    loadFailed: "Campaign summary could not be loaded. Please try again later.",
    creativesLoadFailedTitle: "Creative leaderboard could not be loaded",
    creativesLoadFailed: "Creative leaderboard could not be loaded. Please try again later.",
    hotCreatives: "Creative leaderboard",
    hotCreativesDescription: "Creatives leading by spend in this period",
    hotCreativesDescriptionBy: "Creatives leading by {metric} in this period",
    hotCreativesAria: "Creative leaderboard",
    hotCreativesViewAll: "View all creatives",
    hotCreativesEmptyTitle: "No creatives yet",
    hotCreativesEmptyDescription: "No creative performance to show for this reporting period.",
    hotCreativesRank: "Rank {rank}",
    campaigns: "Campaign leaderboard",
    campaignsAria: "Campaign leaderboard",
    campaignsDescription: "Campaigns leading by ROI in this period",
    leaderboardByPrefix: "Leading by",
    leaderboardSuffix: {
      campaigns: "this period",
      creatives: "this period",
    },
    leaderboardSortAria: "Sort metric: {metric}",
    leaderboardMetric: {
      spend: "Spend",
      revenue: "Revenue",
      roas: "ROI",
      orders: "Orders",
      cpa: "CPA",
    },
    campaignsViewAll: "View all campaigns",
    leaderboardBackToStart: "Back to top",
    campaignsEmptyTitle: "No campaigns yet",
    campaignsEmptyDescription: "No campaigns to show for this reporting period.",
    campaignCount: "{count} campaigns",
    campaignCountFiltered: "{filtered} / {total} campaigns",
    campaignSearchClear: "Clear search",
    campaignSearchEmptyTitle: "No matching campaigns",
    campaignSearchEmptyDescription: "Try a different search term or clear the filter.",
    search: "Search campaigns",
    searchSubmit: "Search",
    tableAria: "Campaign delivery data",
    status: { active: "Active", paused: "Paused" },
    columns: {
      campaign: "Campaign",
      status: "Status",
      orders: "Orders",
      spend: "Spend",
      roi: "ROAS",
    },
    exportData: "Export data",
    exportSuccess: "Exported campaign overview",
    exportFailed: "Export failed. Try again in a moment.",
    exportSheetOverview: "Sheet1",
    exportColByDay: "By day",
    exportColByWeek: "By week",
    exportColByMonth: "By month",
    exportColCost: "Cost",
    exportColSkuOrders: "SKU orders (current store)",
    exportColAvgCpa: "Avg. cost per order (current store)",
    exportColTotalRevenue: "Gross revenue (current store)",
    exportColRoi: "Return on ad spend (ROI) (current store)",
    exportColCurrency: "Currency",
  },
  workspaceComingSoon: {
    campaigns: {
      title: "Campaigns page is under construction",
      description: "Campaign operations are not available on this page.",
    },
    audiences: {
      title: "Audiences page is under construction",
      description: "Audience operations are not available on this page.",
    },
  },
  governance: {
    title: "Member management",
    lead: "Manage Workspace members and role permissions, and track invitation activity.",
    loadFailedTitle: "Member data could not be loaded",
    loadFailed: "Member data could not be loaded. Please try again later.",
    actionFailed: "Action not completed",
    invitationCreateFailed: "Invitation creation failed. Please try again later.",
    invitationCopyFailed: "The invitation link could not be copied. Select and copy it manually.",
    invitationRevealFailed: "Invitation link could not be retrieved. Please try again later.",
    invitationRegenerateFailed: "Invitation regeneration failed. Please try again later.",
    invitationRevokeFailed: "Invitation revocation failed. Please try again later.",
    memberRemoveFailed: "Member removal failed. Please try again later.",
    roles: {
      manage: "Manage roles",
      title: "Role management",
      lead: "Configure the roles this Workspace can assign. After a member joins, the owner chooses their role.",
      listAria: "Workspace roles",
      loading: "Loading roles",
      loadFailedTitle: "Roles could not be loaded",
      loadFailed: "Roles could not be loaded. Please try again later.",
      emptyTitle: "No roles yet",
      emptyDescription: "Custom roles will appear here after they are created.",
      create: "Create role",
      builtInBadge: "Built-in",
      disabledBadge: "Disabled",
      columnName: "Role name",
      columnDescription: "Description",
      columnAdvertiserAccounts: "Advertiser accounts",
      allAdvertiserAccounts: "All advertiser accounts",
      noAdvertiserAccounts: "Unassigned",
      advertiserAccountsTitle: "Advertiser accounts",
      advertiserAccountsHint: "Turn an account on to let this role use it. Saving with no synced accounts leaves the role unassigned.",
      advertiserAccountsEmpty: "No advertiser accounts have been synced yet",
      advertiserAccountOverflow: "{names}, and {count} more",
      addedAccounts: "Added: {items}",
      removedAccounts: "Removed: {items}",
      ownerDescription: "Can use every advertiser account",
      memberDescription: "Default role after someone joins. No advertiser accounts are assigned.",
      memberCount: "{count, plural, one {# member} other {# members}}",
      editAria: "Edit {name}",
      disabledEditHint: "Enable this role before editing it",
      disableAria: "Disable {name}",
      enableAria: "Enable {name}",
      deleteAria: "Delete {name}",
      editorTriggerAria: "Open role editor",
      statusTriggerAria: "Open role status confirmation",
      deleteTriggerAria: "Open role deletion dialog",
      createTitle: "Create custom role",
      editTitle: "Edit role: {name}",
      name: "Role name",
      descriptionField: "Role description (optional)",
      descriptionPlaceholder: "Describe the work this role owns",
      permissionsTitle: "Permissions",
      menuAccessTitle: "Page access",
      menuAccessDescription:
        "Turn access on by menu group. The matching sidebar entry appears when a switch is on. Overview stays included. Campaign pages follow the membership until they can be granted separately.",
      menuAccess: {
        overview: "Overview",
        operations: "Ads & assets",
        menuAccessLabel: "Menu access",
        resourcePermissionLabel: "Resource permission",
        membershipHint:
          "No separate menu key yet: any workspace member can open this surface (configurable after contracts expand).",
      },
      groupBasic: "Basic",
      groupMembers: "Members",
      groupAudit: "Audit",
      expandGroup: "Expand {group} permissions",
      collapseGroup: "Collapse {group} permissions",
      required: "Required",
      permissionDetail: {
        dashboardView: "Every workspace member can open the overview.",
        membersView: "Shows the members entry in the sidebar.",
        auditView: "Shows the audit entry in the sidebar.",
      },
      permission: {
        dashboardView: "View overview",
        membersView: "View members",
        membersRemove: "Remove members",
        invitationsView: "View invitations",
        invitationsCreate: "Create invitations",
        invitationsReveal: "View invitation links",
        invitationsRegenerate: "Regenerate invitations",
        invitationsRevoke: "Revoke invitations",
        auditView: "View audit log",
      },
      save: "Save role",
      cancel: "Cancel",
      impactTitle: "Change impact",
      affectedMembers: "Affects {count, plural, one {# member} other {# members}}",
      added: "Added: {permissions}",
      removed: "Removed: {permissions}",
      noPermissionChanges: "No permission changes",
      confirmUpdateTitle: "Confirm role update",
      backToEdit: "Back to editing",
      confirmUpdate: "Confirm update",
      disableTitle: "Disable role?",
      enableTitle: "Enable role?",
      disableDescription: "Disabling this role moves {count, plural, one {# member} other {# members}} to the built-in Member role. This role can no longer be edited or assigned.",
      enableDescription: "After this role is enabled, it can be edited and assigned to members again.",
      confirmDisable: "Disable role",
      confirmEnable: "Enable role",
      deleteTitle: "Delete role?",
      deleteDescription: "Only unassigned custom roles can be deleted.",
      confirmDelete: "Delete role",
      createFailed: "Role creation failed. Please try again later.",
      updateFailed: "Role update failed. Please try again later.",
      disableFailed: "Role could not be disabled. Please try again later.",
      enableFailed: "Role could not be enabled. Please try again later.",
      deleteFailed: "Role deletion failed. Please try again later.",
      disabledResultTitle: "Role disabled",
      disabledResult: "{count, plural, one {# member was} other {# members were}} moved to the built-in Member role.",
      enabledResultTitle: "Role enabled",
      enabledResult: "This role can now be edited and assigned to members again.",
    },
    assignment: {
      open: "Change role",
      openAria: "Change role for {email}",
      selectAria: "Choose a role for {email}",
      title: "Change role",
      description: "Choose a new role for this member. Changes apply immediately after saving.",
      noAlternativeTitle: "No other roles are available",
      noAlternativeDescription: "Create and enable a custom role before changing this member's role.",
      createRole: "Create a role",
      cancel: "Cancel",
      confirm: "Save changes",
      failed: "Member role change failed. Please try again later.",
    },
    permissions: {
      open: "Change permissions",
      openAria: "Change permissions for {email}",
      title: "Change member permissions",
      description: "Account-level access can only add read permissions. Effective access is the union of role and account grants.",
      roleProvidedAria: "{permission} is provided by the role and cannot be changed here",
      roleProvidedHint: "This permission is provided by the role and cannot be changed here.",
      cancel: "Cancel",
      save: "Save permissions",
      failed: "Member permissions could not be changed. Please try again later.",
    },
    dialog: { linkTitle: "Invitation link", createTitle: "Create invitation link", open: "Create invitation link", openAria: "Open invitation dialog", closeAria: "Close invitation dialog", description: "Each link is valid for 7 days and can be used by one member.", actionFailed: "Action not completed", note: "Invitation note (optional)", notePlaceholder: "e.g. Finance teammate", loading: "Retrieving invitation link", copied: "Invitation link copied", copy: "Copy invitation link", close: "Close", create: "Create invitation link", regenerate: "Regenerate invitation link" },
    invitations: { title: "Invitation history", description: "Active invitations can be viewed, copied, or regenerated", aria: "Invitation history", emptyTitle: "No invitations yet", emptyDescription: "New invitations appear here. You can cancel a sent invitation or copy the link again at any time.", createNow: "Create invitation link now", noNote: "No note", noNoteTarget: "Invitation without a note {index}", reveal: "View and copy", revealAria: "View and copy invitation link {target}", revokeAria: "Revoke {target}" },
    members: { title: "Current members", count: "{count, plural, one {# member} other {# members}}", aria: "Current members", emptyTitle: "No members yet", emptyDescription: "Members will appear here after they accept an invitation.", joined: "Joined {date}", removeAria: "Remove {email}", inviteHint: "Need more collaborators? Create an invitation from the top right.", inviteHintReadOnly: "See what each role is allowed to do.", permissionGuide: "View permission guide", permissionGuideTitle: "Permission guide" },
    removal: { open: "Open member removal confirmation", closeAria: "Close member removal dialog", title: "Remove member?", description: "This action immediately revokes Workspace access.", failed: "Member removal failed", warning: "Removal deactivates this member's identity in this Workspace and marks data tied to that identity for deletion.", cancel: "Cancel", confirm: "Remove member" },
  },
  authorizeAccount: {
    button: "Authorize Account",
    reauthorize: "Reauthorize",
    emptyTitle: "No TikTok account authorized",
    emptyDescription:
      "Authorize TikTok for Business to sync and manage campaigns, advertiser accounts, stores, and creative assets.",
    modal: {
      close: "Close",
      checkingTitle: "Checking network",
      checkingDescription: "Confirming that this environment can reach TikTok authorization.",
      checkingHint: "Connecting to ads.tiktok.com…",
      blockedTitle: "Cannot reach TikTok",
      blockedDescription: "This network cannot reach TikTok authorization services.",
      vpnHint: "Turn on a VPN or switch to a network with external access, then try again.",
      readyTitle: "Ready to authorize",
      readyDescription: "Network looks good. You will continue to TikTok to finish authorization.",
      readyHint: "Continue opens the TikTok for Business authorization page in this browser.",
      retry: "Check again",
      continue: "Continue",
      ownerOnly: "Only the Workspace owner can manage TikTok authorization.",
      paused: "The Workspace is paused. Authorization cannot start right now.",
    },
  },
  tiktokIntegration: {
    title: "TikTok authorization",
    productTitle: "TikTok for Business",
    description: "Connect TikTok for Business, then sync each advertising resource from its own page.",
    loading: "Loading TikTok authorization",
    loadFailedTitle: "TikTok authorization could not be loaded",
    loadFailed: "TikTok authorization is temporarily unavailable. Try again later.",
    actionFailedTitle: "TikTok authorization not completed",
    actionFailed: "TikTok authorization could not be completed. Try again later.",
    status: { disconnected: "Not connected", connected: "Connected", reauth_required: "Reauthorization required" },
    connectionStatus: "Authorization status",
    connectedAt: "Connected",
    connect: "Connect TikTok for Business",
    reauthorize: "Reauthorize",
    connectedTitle: "TikTok connected",
    connectedDescription:
      "Authorization is complete. You can sync TikTok resources from Business Centers and other pages.",
    timeoutTitle: "Authorization timed out",
    timeoutDescription:
      "The server did not respond within 60 seconds. The connection may still complete in the background. Refresh the status or start authorization again.",
    timeoutRetry: "Start authorization again",
    timeoutRefresh: "Refresh status",
    ownerOnly: "Only the Workspace owner can manage TikTok authorization.",
    reauthTitle: "Reauthorization required",
    reauth: "TikTok authorization is no longer valid. Reauthorize to continue.",
    addAccount: "Add Authorized Ad Account",
    table: {
      title: "Authorized Account List",
      description: "TikTok for Business authorization for this Workspace (one account supported today).",
      ariaLabel: "TikTok authorized accounts",
      columnAccount: "Account",
      columnStatus: "Status",
      columnConnectedAt: "Connected",
      columnActions: "Actions",
      accountName: "TikTok for Business",
      emptyTitle: "No authorized account yet",
      emptyDescription: "Authorize to sync advertiser accounts, stores, creatives, and campaigns on their pages.",
      reauthorizeAria: "Reauthorize TikTok for Business",
      disconnect: "Revoke authorization",
      disconnectAria: "Revoke TikTok for Business authorization",
    },
    disconnect: {
      title: "Revoke TikTok authorization?",
      description: "After revoke, this Workspace can no longer sync TikTok advertising resources.",
      warning: "Existing synced snapshots remain visible, but new syncs stay blocked until you authorize again.",
      cancel: "Cancel",
      confirm: "Revoke authorization",
      failedTitle: "Could not revoke authorization",
      failed: "TikTok authorization could not be revoked. Try again later.",
    },
  },
  tiktokResources: {
    syncTime: {
      lastSuccess: "Last success:",
      campaignsUpdated: "Campaigns updated:",
      insightsUpdated: "Insights updated:",
      never: "No successful sync yet",
      scopeHint: "Latest successful update in the current scope; not all accounts necessarily completed the same cycle.",
    },
    readOnlyTitle: "Read-only mode",
    readOnly: "The Workspace is paused. This page is currently read-only.",
    errorCode: "Error code: {code}",
    httpStatus: "HTTP status: {status}",
    messageKey: "Message key: {messageKey}",
    requestId: "Request ID: {requestId}",
    retryAfterMinutes:
      "{minutes, plural, one {Retry in # minute} other {Retry in # minutes}}",
    retryAfterSeconds:
      "{seconds, plural, one {Retry in # second} other {Retry in # seconds}}",
    retryWithDetail: "{message} ({retryAfter})",
    selectBusinessCenter: "Select Business Center",
    selectAdvertiserAccount: "Select advertiser account",
    sync: "Sync",
    syncing: "Syncing…",
    unavailable: "Unavailable",
    syncStatus: {
      never_synced: "Not synced",
      synced: "Synced",
      sync_failed: "Sync failed",
      syncing: "Syncing…",
      partial: "Partially synced",
    },
  },
  tiktokBusinessCenters: {
    title: "Business Center",
    description: "Business Centers and advertising basics from the latest complete snapshot.",
    loading: "Loading Business Centers",
    loadFailedTitle: "Business Centers could not be loaded",
    loadFailed: "Business Centers are temporarily unavailable. Try again later.",
    actionFailedTitle: "Business Center sync not completed",
    actionFailed: "Business Centers could not be synchronized. Try again later.",
    sync: "Sync Business Centers",
    syncing: "Syncing Business Centers…",
    syncFailedTitle: "Business Center sync failed",
    syncFailed: "The last successful snapshot is still available. Try again later.",
    listTitle: "Business Center directory",
    listAria: "Business Center list",
    count: "{count, plural, one {# center} other {# centers}}",
    lastSync: "Last synced: {time}",
    notSynced: "No successful sync yet",
    columnName: "Name / ID",
    columnStatus: "Status",
    columnVerification: "Verification",
    columnRole: "Role",
    columnCurrency: "Currency",
    columnTimezone: "Timezone",
    columnAvailability: "Availability",
    available: "Available",
    unavailable: "Missing from latest sync",
    disconnectedTitle: "Connect TikTok first",
    disconnectedDescription: "Authorize TikTok before synchronizing Business Centers.",
    reauthEmptyTitle: "Reauthorization required",
    reauthEmptyDescription: "TikTok authorization is no longer valid. Reauthorize to continue syncing.",
    openAuthorization: "Open TikTok authorization",
    neverSyncedTitle: "Business Centers have not been synced",
    neverSyncedDescription: "The Workspace owner can start the first complete sync.",
    emptyTitle: "No available Business Centers",
    emptyDescription: "The latest complete sync succeeded, but TikTok returned no Business Centers.",
  },
  tiktokAdvertiserAccounts: {
    title: "Advertiser accounts",
    description: "Advertiser accounts returned by the latest complete sync for the selected Business Center.",
    loading: "Loading advertiser accounts",
    loadFailedTitle: "Advertiser accounts could not be loaded",
    loadFailed: "Advertiser accounts are temporarily unavailable. Try again later.",
    actionFailedTitle: "Advertiser account sync not completed",
    actionFailed: "Advertiser accounts could not be synchronized. Try again later.",
    selectBusinessCenter: "Select Business Center",
    sync: "Sync advertiser accounts",
    syncing: "Syncing advertiser accounts…",
    syncFailedTitle: "Advertiser account sync failed",
    syncFailed: "The last successful snapshot for this Business Center is still available. Try again later.",
    listTitle: "Advertiser account directory",
    listAria: "Advertiser account list",
    count: "{count, plural, one {# account} other {# accounts}}",
    lastSync: "Last synced: {time}",
    notSynced: "No successful sync yet",
    columnName: "Name / ID",
    columnAccountType: "Account type",
    columnRole: "BC role",
    columnAdCreation: "Ad creation",
    columnOwner: "Owner Business Center",
    columnAvailability: "Availability",
    eligible: "Can create ads",
    ineligible: "Cannot create ads",
    available: "Available",
    unavailable: "Missing from latest sync",
    unavailableTitle: "This Business Center is unavailable",
    unavailableDescription: "Its previous snapshot remains visible. Sync Business Centers, then select an available one.",
    noBusinessCenterTitle: "No Business Center to select",
    noBusinessCenterDescription: "Connect TikTok and complete a sync from the Business Center page first.",
    openBusinessCenters: "Open Business Centers",
    neverSyncedTitle: "Advertiser accounts have not been synced",
    neverSyncedDescription: "The Workspace owner can synchronize accounts for this Business Center.",
    emptyTitle: "No advertiser accounts",
    emptyDescription: "The latest complete sync succeeded, but TikTok returned no advertiser accounts.",
  },
  tiktokStores: {
    title: "Store list",
    description: "TikTok Shops available for advertising from the latest complete workspace sync.",
    loading: "Loading stores",
    loadFailedTitle: "Stores could not be loaded",
    loadFailed: "Stores are temporarily unavailable. Try again later.",
    actionFailedTitle: "Store sync not completed",
    actionFailed: "Stores could not be synchronized. Try again later.",
    selectBusinessCenter: "Select Business Center",
    selectAdvertiserAccount: "Select advertiser account",
    sync: "Sync store list",
    syncing: "Syncing store list…",
    syncFailedTitle: "Store sync failed",
    syncFailed: "The last successful snapshot is still available. Try again later.",
    listTitle: "Store list",
    listAria: "Store list",
    count: "{count, plural, one {# store} other {# stores}}",
    lastSync: "Last synced: {time}",
    notSynced: "No successful sync yet",
    columnName: "Name / ID",
    columnCatalog: "Catalog ID",
    columnAuthorizedBc: "Authorized Business Center",
    columnAvailability: "Availability",
    available: "Available",
    unavailable: "Missing from latest sync",
    filterBar: {
      ariaLabel: "Store filters",
      allBusinessCenters: "All Business Centers",
      allAdvAccounts: "All Advertiser Accounts",
    },
    businessCenterUnavailableTitle: "This Business Center is unavailable",
    businessCenterUnavailableDescription: "Its previous snapshot remains visible. Sync Business Centers before continuing.",
    noBusinessCenterTitle: "No Business Center to select",
    noBusinessCenterDescription: "Connect TikTok and complete a Business Center sync first.",
    openBusinessCenters: "Open Business Centers",
    noAdvertiserTitle: "No advertiser account to select",
    noAdvertiserDescription: "Synchronize advertiser accounts for this Business Center first.",
    openAdvertisers: "Open advertiser accounts",
    advertiserUnavailableTitle: "This advertiser account is unavailable",
    advertiserUnavailableDescription: "Its previous snapshot remains visible. Sync advertiser accounts, then select an available one.",
    neverSyncedTitle: "Stores have not been synced",
    neverSyncedDescription: "The Workspace owner can synchronize the workspace store list.",
    emptyTitle: "No stores",
    emptyDescription: "The latest complete sync succeeded, but TikTok returned no stores available for advertising.",
  },
  profitCalculator: {
    title: "Product profit comparison calculator",
    subtitle: "Cross-border product margin analysis and cost accounting",
    lead: "Compare cost structure and profit so you can choose products with a clearer margin.",
    productA: "Product A parameters",
    productB: "Product B parameters",
    copyToB: "Copy Product A setup to Product B",
    copiedToB: "Copied to Product B",
    resetAll: "Reset to defaults",
    tabA: "Product A",
    tabB: "Product B",
    tabsLabel: "Select product to compare",
    sectionBasics: "Basics",
    sectionShipping: "Freight and logistics",
    sectionFees: "Operating and commission fees",
    sectionReturns: "Returns and loss",
    productName: "Product name",
    cost: "Procurement cost",
    price: "Selling price",
    salesVolume: "Estimated units",
    shippingTotal: "First-mile freight",
    perContainer: "Units per container",
    lastMile: "Last-mile freight",
    warehouseFee: "Warehouse fee",
    adCost: "Ad cost",
    platformFee: "Store commission",
    influencerFee: "Creator commission",
    influencerRatio: "Creator sales share",
    returnRate: "Return rate",
    returnFee: "Return handling fee",
    unitPerPiece: "CNY / unit",
    unitPerContainer: "CNY / container",
    unitPieces: "units",
    unitPercent: "%",
    currencyMark: "¥",
    analysisTitle: "{name} live profit board",
    formulaHint: "Hover each metric to see its formula",
    formulaHintTitle: "Formula",
    firstMilePerUnit: "First-mile per unit",
    preTaxProfit: "Pre-tax profit",
    returnLoss: "Return loss",
    actualProfit: "Actual unit profit",
    profitMargin: "Margin",
    totalProfit: "Estimated total profit",
    breakEvenRoi: "Break-even ROI",
    unitCost: "Total unit cost",
    totalCost: "Total cost (container)",
    roiStatus: "ROI",
    roiSafe: "Safe",
    roiCaution: "Caution",
    roiDanger: "Risk",
    comparisonTitle: "Product selection comparison",
    comparisonLead:
      "Ranked from unit-margin sensitivity, container allocation, and the break-even volume ratio.",
    modelRecommendA: "Model pick: choose Product A",
    modelRecommendB: "Model pick: choose Product B",
    modelRecommendTie: "Model pick: tied",
    volumeRatioLabel: "Current B/A volume ratio:",
    balanceThresholdLabel: "Break-even threshold:",
    balanceTimes: "{ratio}×",
    decisionTitle: "{name} decision",
    chooseAWhenBelow:
      "When Product B volume stays below {ratio}× Product A, choose Product A. Its unit profit is higher and holds up better against ad-cost swings.",
    chooseAWhenBelowBefore: "When Product B volume stays ",
    chooseAWhenBelowEmphasis: "below {ratio}× Product A",
    chooseAWhenBelowAfter: ", choose ",
    chooseAWhenBelowName: "Product A",
    chooseAWhenBelowTail:
      ". Its unit profit is higher and holds up better against ad-cost swings.",
    chooseBWhenAtOrAbove:
      "Choose Product B only when its volume reaches {ratio}× Product A or more (at least {units} units), so scale offsets the unit-profit gap.",
    chooseBWhenAtOrAboveBefore: "When volume ",
    chooseBWhenAtOrAboveEmphasis: "reaches {ratio}× Product A or more",
    chooseBWhenAtOrAboveAfter: " (at least {units} units), choose ",
    chooseBWhenAtOrAboveName: "Product B",
    chooseBWhenAtOrAboveTail: ", so scale offsets the unit-profit gap.",
    barNetTag: "{percent} net",
    chooseAWhenHigherTotal:
      "Choose Product A when its estimated total profit is higher",
    chooseBWhenHigherTotal:
      "Choose Product B when its estimated total profit is higher",
    chooseWhenTie:
      "Estimated total profits are tied; decide by unit profit, supply chain, or ads strategy",
    verdictRecommended: "Recommended now",
    verdictFeatured: "★ Best overall now",
    verdictNotRecommended: "Not recommended now",
    verdictTie: "Tied",
    currentVolumeRatio: "Current B/A volume ratio: {ratio}.",
    balanceUnavailable:
      "Break-even volume is available when both actual profits are positive.",
    timesSuffix: "×",
    profitDeltaALead: "Product A total profit leads by {amount} CNY",
    profitDeltaBLead: "Product B total profit leads by {amount} CNY",
    profitDeltaTie: "Estimated total profits are tied",
    unitProfit: "Actual unit profit",
    totalProfitShort: "Total profit",
    totalProfitWithVolume: "Estimated total profit ({count} units)",
    yuan: "CNY",
    yuanPerUnit: "CNY / unit",
    unitAdvantage: "+{amount} ahead",
    totalAhead: "+{amount} higher",
    totalGap: "-{amount} gap",
    breakdownTitle: "Unit cost mix and profit retained",
    barPurchase: "Procurement",
    barLogistics: "First + last mile",
    barMarketing: "Marketing and platform",
    barNet: "Net profit",
    barSeries: "{side} ({price})",
    tipsTitle: "Cross-border accounting logic and core formula reference",
    coreFormulasTitle: "Core profit formulas",
    costFormulasTitle: "Cost, break-even, and decision formulas",
    formulaFirstMile: "First-mile per unit = first-mile freight ÷ units per container",
    formulaPlatformCommission: "Store commission = price × store commission%",
    formulaInfluencerCommission:
      "Creator commission = price × creator commission% × creator sales share%",
    formulaPreTax:
      "Pre-tax profit = price − cost − first-mile − last-mile − warehouse − store commission − creator commission − ads",
    formulaReturnLoss:
      "Return loss = (last-mile + warehouse + return fee) × return rate%",
    formulaActual: "Actual profit = pre-tax profit − return loss",
    formulaMargin: "Margin = actual profit ÷ price × 100%",
    formulaUnitCost: "Unit cost = procurement cost + first-mile per unit",
    formulaTotalCost:
      "Container total cost = (procurement cost × units per container) + first-mile freight",
    formulaBreakEven: "Ad break-even ROI = price ÷ actual profit",
    formulaTotalProfit: "Estimated total profit = actual profit × estimated units",
    formulaBalance: "Break-even ratio = Product A unit profit ÷ Product B unit profit",
    formulaNameFirstMile: "First-mile allocation (CNY/unit) =",
    formulaExprFirstMile: "First-mile freight ÷ units per container",
    formulaNamePlatform: "Store commission (CNY/unit) =",
    formulaExprPlatform: "Price × store commission%",
    formulaNameInfluencer: "Creator commission (CNY/unit) =",
    formulaExprInfluencer: "Price × creator commission% × creator sales share%",
    formulaNameReturnLoss: "Return loss (CNY/unit) =",
    formulaExprReturnLoss: "(Last-mile freight + warehouse handling fee + return processing fee) × return rate%",
    formulaNamePreTax: "Pre-tax profit (CNY/unit) =",
    formulaExprPreTax: "Price − procurement − first-mile − last-mile − warehouse − store commission − creator commission − ad spend",
    formulaNameActual: "Actual profit =",
    formulaExprActual: "Pre-tax profit − return loss",
    formulaNameMargin: "Actual profit margin =",
    formulaExprMargin: "Actual profit ÷ selling price × 100%",
    formulaNameUnitCost: "Fixed unit cost =",
    formulaExprUnitCost: "Procurement cost + first-mile per unit",
    formulaNameTotalCost: "Container cash outlay =",
    formulaExprTotalCost: "(Procurement cost × units per container) + first-mile freight",
    formulaNameBreakEven: "Ad break-even ROI =",
    formulaExprBreakEven: "Selling price ÷ (selling price − fixed costs)",
    formulaNameTotalProfit: "Estimated period profit =",
    formulaExprTotalProfit: "Actual profit × estimated units",
    formulaNameBalance: "Decision volume ratio =",
    formulaExprBalance: "Product A unit profit ÷ Product B unit profit",
  },
  roiCalculator: {
    title: "ROI calculator",
    subtitle: "Cross-border ad ROAS and break-even quick calc",
    definition: "ROI (ROAS) = sales ÷ ad spend",
    calculate: "Calculate",
    resetAll: "Reset",
    dirtyHint: "Inputs changed — click Calculate to refresh results",
    staleResults: "Needs recalculation",
    inputsTitle: "Inputs",
    resultsTitle: "Results",
    sectionBasics: "Basics",
    price: "Selling price",
    cost: "Cost",
    returnRate: "Return rate",
    shopFee: "Store commission",
    influencerFee: "Creator ad commission",
    targetRoi: "Target ROI (optional)",
    quickPresets: "Quick presets",
    breakEvenBaseline: "Break-even line",
    unitPerPiece: "CNY / unit",
    unitPercent: "%",
    unitRatio: "×",
    yuan: "CNY",
    yuanPerUnit: "CNY / unit",
    grossProfit: "Gross profit before ads",
    grossProfitDesc: "Margin after returns, commissions, and cost",
    grossMargin: "Gross margin before ads",
    grossMarginDesc: "Gross profit before ads ÷ selling price",
    breakEvenRoi: "Break-even ROI",
    breakEvenRoiDesc: "Ad ROI must exceed this to be profitable",
    breakEvenPrice: "Break-even selling price",
    breakEvenPriceDesc: "Price where profit is zero before ads",
    adCap: "Max ad spend at target ROI",
    adCapDesc: "Per-unit ad spend ceiling implied by the target ROI",
    profitAfterAdCap: "Unit profit at that ad cap ≈ {amount} CNY",
    footerFormulas:
      "Ad cap = price ÷ target ROI  |  Break-even ROI = price ÷ gross profit",
    insight: {
      none: "Enter a target ROI to see the ad spend ceiling and profit headroom.",
      unprofitable:
        "Gross profit before ads is zero or negative. Raise price or lower cost/fees before optimizing ad ROI.",
      invalid_fees:
        "Return rate or commissions are invalid (zero keep rate, or commissions ≥ 100%). Adjust inputs and retry.",
      target_profitable:
        "Target ROI is above break-even, so the ad cap is below gross profit and there is still margin.",
      target_breakeven:
        "Target ROI is near break-even; profit at the ad cap is roughly zero.",
      target_loss:
        "Target ROI is below break-even, so the ad cap exceeds gross profit and the plan loses money.",
    },
    insightLabel: {
      unprofitable: "Structurally unprofitable",
      invalid_fees: "Invalid inputs",
      target_profitable: "Profit headroom",
      target_breakeven: "Near break-even",
      target_loss: "Unprofitable ads",
    },
    tipsTitle: "Formula reference",
    coreFormulasTitle: "Margin formulas",
    roiFormulasTitle: "ROI formulas",
    formulaNameNetRevenue: "Net revenue =",
    formulaExprNetRevenue: "Price × (1 − return rate%)",
    formulaNameCommissions: "Commissions =",
    formulaExprCommissions: "Net revenue × (store commission% + creator ad commission%)",
    formulaNameGrossProfit: "Gross profit before ads =",
    formulaExprGrossProfit: "Net revenue − commissions − cost",
    formulaNameGrossMargin: "Gross margin before ads =",
    formulaExprGrossMargin: "Gross profit before ads ÷ price × 100%",
    formulaNameBreakEvenRoi: "Break-even ROI =",
    formulaExprBreakEvenRoi: "Price ÷ gross profit before ads",
    formulaNameBreakEvenPrice: "Break-even price =",
    formulaExprBreakEvenPrice: "Cost ÷ [(1 − return rate%) × (1 − total commission%)]",
    formulaNameAdCap: "Ad spend cap =",
    formulaExprAdCap: "Price ÷ target ROI",
  },
  tiktokCreativeAssets: {
    title: "Creative asset list",
    mediaRetry: "Refresh image/cover URLs",
    mediaProgress: "Image/cover progress",
    reportUpdated: "Latest report update: {time}",
    mediaScope: "Refresh only TikTok Shop official-account video covers and product-card images in this workspace and selected BC/account scope, regardless of report dates or authorization filters. Reports are not fetched again; affiliate and other video authorizations are not queried. Refresh expired links if images fail to load.",
    mediaCounts: "{total} unique media: {succeeded} succeeded, {queued} queued, {running} processing, {waiting} waiting to retry, {failed} incomplete",
    mediaResult: "Added {added}, already queued {queued}, no work needed {skipped}.",
    mediaFailedTitle: "Media operation or progress unavailable",
    mediaFailed: "Existing reports are unaffected. Refresh progress or retry missing images later.",
    mediaRefresh: "Refresh media progress",
    mediaStates: { queued: "Queued", running: "Processing images", waiting: "Waiting to retry", succeeded: "Images complete", failed: "Some images are still missing" },
    mediaErrors: {
      metadata_not_found: "Post metadata not found; type unconfirmed. Check again during the next sync or a manual retry",
      metadata_upstream_failed: "Metadata query or parsing failed; retry later",
      product_not_found: "Product image not found; check product access",
      oss_upload_failed: "Image could not be saved; retry later",
      source_download_failed: "Image download failed; retry later",
      source_download_timeout: "Image download timed out or its URL expired; retry",
      source_format_unsupported: "Unsupported image format; manual review required",
      source_too_large: "Image exceeds the size limit; manual review required",
      source_url_missing: "No image URL was returned; review the creative",
      source_url_rejected: "Image source failed safety checks; manual review required",
      tiktok_rate_limited: "Upstream rate limit reached; waiting to retry",
      tiktok_upstream_unavailable: "Upstream temporarily unavailable; retry later",
      tiktok_response_invalid: "Unexpected upstream response; review required",
      tiktok_token_invalid: "Authorization expired; reconnect the account",
      tiktok_sync_timeout: "Media task timed out; retry",
      tiktok_permission_missing: "The API reported insufficient permissions; review access",
    },
    description: "Images and videos returned by the latest complete sync for the selected advertiser account.",
    loading: "Loading creative assets",
    loadFailedTitle: "Creative assets could not be loaded",
    loadFailed: "Creative assets are temporarily unavailable. Try again later.",
    actionFailedTitle: "Creative asset sync not completed",
    actionFailed: "Creative assets could not be synchronized. Try again later.",
    previewFailedTitle: "Creative preview failed",
    previewFailed: "The temporary preview could not be loaded. Try again.",
    selectBusinessCenter: "Select Business Center",
    selectAdvertiserAccount: "Select advertiser account",
    sync: "Sync creative assets",
    syncing: "Syncing creative assets…",
    resumeReport: "Resume existing sync",
    syncRequestFailed: "This sync request was not accepted",
    reportRetryAt: "Earliest retry: {time}.",
    reportActivity: {
      queued: "Creative report queued. Use Resume existing sync to wake the task without creating another batch.",
      running: "Fetching the creative report. Images and video covers are filled separately.",
      waiting: "Creative report waiting to retry. Use Resume existing sync to wake the task without creating another batch.",
    },
    syncFailedTitle: "Creative asset sync failed",
    syncFailed: "The last successful snapshot for this advertiser account is still available. Try again later.",
    listTitle: "Creative asset list",
    listAria: "Creative asset list",
    count: "{count, plural, one {# asset} other {# assets}}",
    lastSync: "Last synced: {time}",
    notSynced: "No successful sync yet",
    columnType: "Type",
    columnName: "Name / ID",
    columnDimensions: "Dimensions / duration",
    columnFormat: "Format",
    columnSize: "Size",
    columnModified: "Updated",
    columnAvailability: "Availability",
    image: "Image",
    video: "Video",
    duration: "{seconds}s",
    available: "Available",
    unavailable: "Missing from latest sync",
    preview: "Preview",
    previewing: "Loading…",
    previewTitle: "Creative preview",
    closePreview: "Close creative preview",
    businessCenterUnavailableTitle: "This Business Center is unavailable",
    businessCenterUnavailableDescription: "Its previous snapshot remains visible. Sync Business Centers before continuing.",
    noBusinessCenterTitle: "No Business Center to select",
    noBusinessCenterDescription: "Connect TikTok and complete a Business Center sync first.",
    openBusinessCenters: "Open Business Centers",
    noAdvertiserTitle: "No advertiser account to select",
    noAdvertiserDescription: "Synchronize advertiser accounts for this Business Center first.",
    openAdvertisers: "Open advertiser accounts",
    advertiserUnavailableTitle: "This advertiser account is unavailable",
    advertiserUnavailableDescription: "Its previous snapshot remains visible. Sync advertiser accounts, then select an available one.",
    neverSyncedTitle: "Creative assets have not been synced",
    neverSyncedDescription: "The Workspace owner can synchronize images and videos for this advertiser account.",
    emptyTitle: "No creative assets",
    emptyDescription: "The latest complete sync succeeded, but TikTok returned no image or video assets.",
  },
  tiktokCallback: {
    processingTitle: "Connecting TikTok for Business",
    processingDescription:
      "Securely finishing authorization. Please keep this tab open.",
    processingStatus: "Verifying and saving your connection…",
    processingHint:
      "You will return to Integrations automatically. If nothing completes within 60 seconds, a timeout message will appear.",
    stepsAria: "Authorization progress",
    stepVerify: "Verifying TikTok authorization",
    stepSave: "Saving your connection",
    stepFinish: "Finishing up",
  },

  tiktokCampaigns: {
    title: "Campaigns",
    description: "Read-only configuration and selected-period metrics for regular, Smart+, and GMV Max campaigns.",
    loading: "Loading campaigns",
    loadFailedTitle: "Campaigns could not be loaded",
    loadFailed: "Campaigns are temporarily unavailable. Try again later.",
    actionFailedTitle: "Campaign refresh not completed",
    actionFailed: "Campaigns could not be refreshed. Try again later.",
    selectBusinessCenter: "Select Business Center",
    selectAdvertiserAccount: "Select advertiser account",
    openAssets: "Account assets",
    sync: "Sync campaigns",
    syncingCampaigns: "Syncing campaigns…",
    syncingReports: "Refreshing reports…",
    syncFailedTitle: "Latest refresh failed",
    syncFailed: "The last successful complete data remains available. Try again later.",
    disconnectedTitle: "Connect TikTok first",
    disconnectedDescription: "Authorize TikTok before synchronizing or viewing campaigns.",
    businessCenterUnavailableTitle: "This Business Center is unavailable",
    businessCenterUnavailableDescription: "A historical snapshot is shown. Sync the parent resources, then select an available item.",
    advertiserUnavailableTitle: "This advertiser account is unavailable",
    advertiserUnavailableDescription: "A historical snapshot is shown, and new campaign or report refreshes are disabled.",
    reportsNeverSyncedTitle: "Campaigns are synced, but reports are not",
    reportsNeverSyncedDescription: "Refresh reports to populate selected-period metrics and the data-through time.",
    noGmvStoresTitle: "No GMV Max stores are available",
    noGmvStoresDescription: "This advertiser account returned no GMV Max stores. Regular and Smart+ campaigns are unaffected.",
    summaryAria: "Campaign summary metrics",
    spend: "Spend",
    orders: "Orders",
    revenue: "Conversion revenue",
    roi: "Overall ROI",
    cpa: "CPA",
    impressions: "Impressions",
    clicks: "Clicks",
    search: "Search campaigns",
    searchPlaceholder: "Campaign name / ID",
    filtersAria: "Campaign filters",
    apply: "Apply filters",
    kindLabel: "Campaign source",
    allKinds: "All sources",
    kind: { regular: "Regular", smart_plus: "Smart+", gmv_max: "GMV Max" },
    storeLabel: "Select GMV Max stores",
    allStores: "All GMV Max stores",
    selectedStores: "{count, plural, one {# store selected} other {# stores selected}}",
    gmvTypeLabel: "GMV Max subtype",
    allGmvTypes: "All GMV Max types",
    gmvType: { product: "Product", live: "LIVE" },
    statusLabel: "Delivery status",
    allStatuses: "All statuses",
    status: { active: "Active", paused: "Paused", other: "Other" },
    datePreset: "Date range",
    today: "Today",
    yesterday: "Yesterday",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    custom: "Custom",
    startDate: "Start date",
    endDate: "End date",
    coveragePending: "Historical data is backfilling",
    coverageRange: "Backfilling · {start}–{end}",
    dataThrough: "Data through {time}",
    metricDefinitionAria: "View metric definitions",
    revenueDefinition: "Definition: regular and Smart+ use attributed purchase value; GMV Max uses gross revenue. ROI and cost per order are calculated from aggregated base metrics.",
    listTitle: "Campaign list",
    listAria: "TikTok campaign operations data",
    count: "{count, plural, one {# campaign} other {# campaigns}}",
    accountMetadataPending: "Account currency and timezone pending first sync",
    columnCampaign: "Campaign / ID",
    columnKind: "Source",
    columnObjective: "Objective / subtype",
    columnStore: "Store",
    columnBudget: "Budget / mode",
    columnTargetRoi: "Target ROI",
    columnStatus: "Status",
    columnModified: "Modified",
    unavailable: "Historical snapshot · unavailable",
    pageSize: "Rows per page",
    sortLabel: "Sort field",
    sort: {
      spend: "Spend", orders: "Orders", attributed_revenue: "Conversion revenue",
      cost_per_order: "Cost per order", roas: "ROAS", budget: "Budget", target_roi: "Target ROI",
      modified_at: "Modified", name: "Name",
    },
    desc: "Descending",
    asc: "Ascending",
    paginationAria: "Campaign pagination",
    paginationSummary: "Page {page} of {totalPages}",
    previousPage: "Previous page",
    nextPage: "Next page",
    noBusinessCenterTitle: "No Business Center to select",
    noBusinessCenterDescription: "Connect TikTok and complete a Business Center sync first.",
    noAdvertiserTitle: "No advertiser account to select",
    noAdvertiserDescription: "Synchronize advertiser accounts for this Business Center first.",
    neverSyncedTitle: "Campaigns have not been synced",
    neverSyncedDescription: "The Workspace owner can refresh campaign configuration, followed by reports.",
    emptyTitle: "No campaigns",
    emptyDescription: "The latest complete sync succeeded, but TikTok returned no campaigns.",
    noResultsTitle: "No campaigns match these filters",
    noResultsDescription: "Adjust the source, store, date, or search filters and try again.",
  },
  audit: {
    title: "Audit log",
    total: "{count, plural, one {# record} other {# records}}",
    filtersAria: "Audit log filters",
    query: "Person",
    queryPlaceholder: "Name, email, or UUID",
    actionAria: "Action",
    resultAria: "Result",
    allActions: "All actions",
    allResults: "All results",
    startTime: "Start time",
    endTime: "End time",
    dateRange: "Date range",
    clearDateRange: "Clear date range",
    today: "Today",
    yesterday: "Yesterday",
    days3: "Last 3 days",
    days7: "Last 7 days",
    days30: "Last 30 days",
    customDate: "Custom",
    apply: "Apply filters",
    columnTime: "Time",
    columnActor: "Actor",
    columnAction: "Action",
    columnTarget: "Target",
    columnResult: "Result",
    columnDetails: "Details",
    details: "View event details",
    tableAria: "Workspace audit log",
    loading: "Loading audit log",
    loadFailedTitle: "Unable to load audit log",
    loadFailed: "The audit log could not be loaded. Please try again later.",
    emptyTitle: "No matching audit events",
    emptyDescription: "Adjust the filters and try again.",
    paginationAria: "Audit log pagination",
    paginationSummary: "Page {page} of {totalPages}",
    previousPage: "Previous page",
    nextPage: "Next page",
    pageSize: "Rows per page",
    drawerTitle: "Audit event details",
    closeDetail: "Close details",
    eventId: "Event ID",
    actorId: "Actor UUID",
    targetType: "Target type",
    targetId: "Target UUID",
    requestId: "Request ID",
    reason: "Reason",
    permission: "Permission change",
  },
  advertiserAccounts: {
    title: "Advertiser Account Management",
    description: "Manage your TikTok advertiser accounts and toggle switches to enable data synchronization.",
    authorizeFirst: "Authorize Account First",
    syncAllAccounts: "Sync advertiser accounts",
    guide: {
      title: "Instructions & Guide",
      summary: "Enable accounts to auto-sync campaigns. Link stores to sync complete revenue reports.",
      expand: "Expand Details",
      collapse: "Collapse",
      syncTitle: "Sync Instructions: ",
      syncPrefix: "Enabling an advertiser account will automatically synchronize campaign lists and details. To sync comprehensive revenue reports (such as spend, orders, CPA, ROI, etc.), please go to ",
      storesManagement: "Stores Management",
      syncSuffix: " to link stores. Disabling an advertiser account stops synchronization immediately.",
      occupancyTitle: "Account Occupancy Notice: ",
      occupancyPrefix: "If an advertiser account displays a red warning ",
      occupiedBy: "Occupied by XXX",
      occupancySuffix: ", it indicates this account was registered first by another member or user. Click the badge to view occupancy details and registration time.",
    },
    metrics: {
      ariaLabel: "Key advertiser account metrics",
      total: "Total Accounts",
      enabled: "Sync Enabled",
      realtime: "Real-time Sync",
      active: "Active",
      paused: "Paused",
      autoTrigger: "Auto-trigger",
      authStatus: "Auth Status",
      authorized: "Authorized",
      unauthorized: "Unauthorized",
      activeConnection: "Valid Connection",
      actionNeeded: "Action Required",
    },
    filters: {
      ariaLabel: "Filter and search advertiser accounts",
      searchAria: "Search by account name or ID",
      searchPlaceholder: "Search account name or ID...",
      searchSubmit: "Search",
      businessCenter: "Business Center",
      allBusinessCenters: "All Business Centers",
      dateRange: "Date range",
      today: "Today",
      yesterday: "Yesterday",
      days3: "Last 3 days",
      days7: "Last 7 days",
      days15: "Last 15 days",
      days30: "Last 30 days",
      customDate: "Custom",
      clearDateRange: "Clear date range",
    },
    table: {
      title: "Advertiser Account Directory",
      description: "Manage your TikTok advertiser accounts and toggle switches to enable campaign data sync.",
      emptyTitle: "No advertiser account data",
      emptyDescSearch: "No advertiser accounts match the current search criteria.",
      ariaLabel: "Advertiser account list",
      colSyncStatus: "Sync Status",
      colAccountInfo: "Account Info",
      colAccountId: "Account ID",
      colRelatedCampaigns: "Related campaigns",
      viewRelatedCampaigns: "View campaigns ({count})",
      relatedCampaignsAria: "View related campaigns for {name} ({count})",
      colBalance: "Balance",
      colSpend: "Spend",
      colCurrency: "Currency",
      colTimezone: "Timezone",
      colLastSyncUtc: "Last Sync (UTC)",
      occupied: "Occupied",
      toggleSyncAria: "Toggle sync status for {name}",
      syncEnabled: "Enabled",
      syncDisabled: "Not enabled",
      copyId: "Copy ID",
      notSynced: "Never synced",
      syncAccountAria: "Sync {name}",
    },
    mobile: {
      occupied: "Occupied",
      enabled: "Enabled",
      disabled: "Disabled",
      accountId: "Account ID",
      relatedCampaigns: "Related campaigns",
      balanceCurrency: "Balance / Currency",
      spend: "Spend",
      timezone: "Timezone",
      lastSyncUtc: "Last Sync (UTC)",
      notSynced: "Never synced",
      syncNow: "Sync Now",
    },
    modals: {
      occupancy: {
        close: "Close",
        title: "Advertiser Account Occupied",
        idLabel: "ID: {id}",
        occupiedUser: "Occupied User",
        unknownUser: "Unknown account",
        boundTime: "Bound Time",
        unknownTime: "Unknown time",
        description: "This advertiser account is currently occupied by the earliest bound account. To manage this account, please sign in with that user's account or contact an administrator to release it.",
        acknowledge: "Got It",
        switchAccount: "Switch Account to Sign In",
      },
      confirmSync: {
        close: "Close",
        titleEnable: "Confirm Enable Sync",
        titleDisable: "Confirm Stop Sync",
        bodyEnable: "After enabling sync, the system will automatically synchronize all campaigns and delivery details under this account on schedule.",
        bodyDisable: "After disabling sync, campaigns under this account will stop pulling new data. Historical reports will remain intact.",
        cancel: "Cancel",
        confirmEnable: "Confirm Enable",
        confirmDisable: "Confirm Stop",
      },
      serviceExpired: {
        close: "Close",
        title: "Service Plan Expired",
        subtitle: "Cannot enable advertiser account sync",
        description: "Your platform membership period has ended, and advertiser account data synchronization is suspended. Please renew your plan to restore full access.",
        notNow: "Not Now",
        renewPackage: "Renew Plan",
      },
    },
  },
  advancedFilter: {
    trigger: "Advanced filter",
    panelTitle: "Set filter conditions",
    addCondition: "Add condition",
    clearAppliedView: "Clear view “{name}”",
    removeCondition: "Remove condition",
    timeRangeLabel: "Time range",
    fieldLabel: "Field",
    operatorLabel: "Operator",
    valueLabel: "Value",
    textPlaceholder: "Enter a value",
    numberPlaceholder: "Enter a number",
    incompleteHint: "{count, plural, other {# condition(s)}} incomplete and not applied yet",
    unknownField: "Unknown field. Remove this condition.",
    operators: {
      eq: "equals",
      neq: "does not equal",
      gt: "greater than",
      gte: "greater than or equal to",
      lt: "less than",
      lte: "less than or equal to",
    },
    timeRanges: {
      today: "Today",
      last3Days: "Last 3 days",
      last7Days: "Last 7 days",
      last15Days: "Last 15 days",
      last30Days: "Last 30 days",
    },
    saveAsNewView: "Save as new view",
    saveViewTitle: "Save view",
    renameViewTitle: "Rename view",
    viewNameLabel: "View name",
    viewNamePlaceholder: "Enter a view name",
    viewNameRequired: "Enter a view name",
    visibilityLabel: "Visibility",
    visibilityPrivate: "Only me",
    visibilityShared: "Shared with team",
    save: "Save",
    saveFailed: "Failed to save. Try again.",
    dirtyHint: "Filters adjusted",
    clear: "Clear",
    viewsMenuLabel: "Saved views",
    myViews: "My views",
    teamViews: "Team views",
    viewsEmpty: "No saved views yet",
    noSavedViews: "No saved views",
    moreViews: "More views",
    currentView: "Current",
    applyView: "Apply view",
    renameView: "Rename view",
    deleteView: "Delete view",
    confirmDelete: "Delete",
    activeViewLabel: "Current view: {name}",
    ownerSuffix: "by {name}",
    viewMoreMenu: "More actions for view “{name}”",
    appliedConditions: "{count, plural, other {#}} condition(s) applied",
  },
  campaigns: {
    header: {
      enableAccountsFirst: "Enable Advertiser Accounts First",
    },
    actionBar: {
      ariaLabel: "Bulk actions toolbar",
      selectedCount: "{count} selected",
      enable: "Enable",
      pause: "Pause",
      edit: "Edit",
      creatives: "Creatives",
      deliveryPlan: "Delivery Plans",
      copy: "Copy",
      bindRuleGroup: "Bind Rule Group",
      unbindRuleGroup: "Unbind Rule Group",
      clearSelection: "Clear selection",
    },
    filters: {
      ariaLabel: "Filter campaigns",
      searchAria: "Search campaigns",
      clearSearchAria: "Clear search",
      searchPlaceholder: "Campaign name/ID/store/product ID",
      searchSubmit: "Search",
      advAccount: "Advertiser Account",
      allAdvAccounts: "All Advertiser Accounts",
      businessCenter: "Business Center",
      allBusinessCenters: "All Business Centers",
      store: "Store",
      allStores: "All Stores",
      dateRange: "Date Range",
      reportPeriod: "Reporting period",
      today: "Today",
      todayWithDate: "Today ({date})",
      yesterday: "Yesterday",
      days3: "Last 3 days",
      days7: "Last 7 days",
      days15: "Last 15 days",
      days30: "Last 30 days",
      months3: "Last 3 months",
      months6: "Last 6 months",
      months12: "Last 12 months",
      customDate: "Custom Date",
      campaignType: "Campaign Type",
      allTypes: "All Types",
      productType: "Product Ads",
      liveType: "LIVE Shopping",
      statusLabel: "Status",
      allStatuses: "All Statuses",
      statusActive: "Active",
      statusPaused: "Paused",
      startDate: "Start Date",
      endDate: "End Date",
      clearDateRange: "Clear date range",
      reset: "Reset filters",
    },
    advancedFilterFields: {
      bc: "Business center",
      advertiser: "Ad account",
      store: "Store",
      date: "Report date",
      type: "Campaign type",
      status: "Delivery status",
      budget: "Budget",
      roiTarget: "Target ROI",
      spend: "Spend",
      orders: "Orders",
      revenue: "Revenue",
      roi: "ROI",
      cpa: "CPA",
      typeProduct: "Product",
      typeLive: "Live",
      statusEnable: "Active",
      statusDisable: "Paused",
    },
    table: {
      title: "TK-Master Campaign Directory",
      description: "View and manage linked TK-Master ad campaigns, budgets, and attributed performance metrics.",
      metaCount: "{count} total campaigns",
      metaAttribution: "USD · Real-time attribution",
      emptyTitle: "No campaign data",
      emptyDescription: "No GMVMAX campaigns match the current filter criteria.",
      selectAll: "Select all",
      selectRow: "Select {name}",
      colCampaign: "Campaign",
      colStore: "Store",
      colRuleGroup: "Rule Group",
      colStatus: "Status",
      colBudget: "Budget",
      colRoiTarget: "Target ROI",
      colSpend: "Spend",
      colOrders: "Orders",
      colCpa: "CPA",
      colRevenue: "Revenue",
      colRoi: "Real-time ROI",
      colImpressions: "Impressions",
      colClicks: "Clicks",
      badgeProduct: "Product",
      badgeLive: "LIVE",
      unbindRuleGroup: "Unbind Rule Group",
      toggleStatusAria: "Toggle status for {name}",
      statusActive: "Active",
      statusPaused: "Paused",
      toastStatusEnabled: "Campaign enabled",
      toastStatusPaused: "Campaign paused",
      rowMenuAria: "{name} action menu",
      menuEdit: "Edit Campaign",
      menuCreatives: "Creative Assets",
      menuPlan: "Delivery Plans",
      menuCopy: "Copy Campaign",
      menuUnbind: "Unbind Rule Group",
      totalsRowLabel: "Total",
      totalsRowAria: "Account totals for campaigns in the current filter range",
      refreshing: "Updating data…",
    },
    mobile: {
      emptyTitle: "No campaign data",
      badgeProduct: "Product",
      badgeLive: "LIVE",
      labelSpend: "Spend",
      labelOrders: "Orders",
      labelRevenue: "Revenue",
      labelRoi: "Real-time ROI",
      labelCpa: "CPA",
      labelRoiTarget: "Target ROI",
      labelBudget: "Daily Budget",
      labelImpressions: "Impressions",
      labelClicks: "Clicks",
      statusActive: "Active",
      statusPaused: "Paused",
      editCampaign: "Edit",
      creatives: "Creatives",
      plans: "Plans",
      copy: "Copy",
    },
    pauseConfirm: {
      title: "Pause this campaign?",
      body: "Are you sure you want to make this change? Pausing your campaign will make this campaign ineligible for ROI protection.",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
    },
    modals: {
      editCampaign: {
        close: "Close",
        title: "Edit Campaign",
        subtitle: "Campaign ID: {id} · Store: {store}",
        nameLabel: "Campaign Name",
        namePlaceholder: "Enter campaign name",
        budgetLabel: "Daily Budget (USD)",
        budgetAria: "Daily Budget",
        roiTargetLabel: "Target ROI",
        roiTargetAria: "Target ROI",
        associatedProducts: "Associated Products ({count})",
        batchRemove: "Batch Remove Selected ({count})",
        selectAllProducts: "Select All Products",
        emptyProductsTitle: "No Associated Products",
        emptyProductsDesc: "This campaign has no associated products yet.",
        selectProductAria: "Select product",
        priceLabel: "Price",
        salesLabel: "Sales",
        cancel: "Cancel",
        saveChanges: "Save Changes",
      },
      ruleGroup: {
        close: "Close",
        title: "Batch Bind Rule Group",
        subtitle: "{count} campaigns selected",
        selectLabel: "Select Rule Group",
        selectAria: "Select Rule Group",
        infoTitle: "Rule Information",
        infoDesc: "Once bound, the selected campaigns will automatically apply this rule group's monitoring and optimization logic.",
        cancel: "Cancel",
        confirmBind: "Confirm Bind",
      },
      creativeDetail: {
        close: "Close",
        title: "Creative Asset Performance",
        subtitle: "Campaign: {name} ({id})",
        metaCount: "{count} total creatives",
        emptyTitle: "No Creative Assets",
        emptyDesc: "This campaign does not have any creative assets configured yet.",
        colCreative: "Creative Info",
        colType: "Type",
        colStatus: "Status",
        colSpend: "Spend",
        colOrders: "Orders",
        colRevenue: "Revenue",
        colRoi: "Real-time ROI",
        colCpa: "CPA",
        typeVideo: "Video",
        typeAffiliate: "Creator",
        typeProductCard: "Product Card",
        statusBoosted: "Boosted",
        statusDelivering: "Delivering",
        statusInQueue: "In Queue",
        statusInactive: "Inactive",
        configBoost: "Configure Boost",
      },
      deliverySession: {
        close: "Close",
        title: "Delivery Plan Management",
        subtitle: "Campaign: {name} ({id})",
        description: "Configure product delivery periods and targeted budget plans:",
        emptyTitle: "No Product Delivery Plans",
        emptyDesc: "Please associate products with this campaign before configuring delivery plans.",
        dateRangeLabel: "Delivery Period",
        targetedBudgetLabel: "Targeted Budget (USD)",
        targetedBudgetAria: "Targeted Budget",
        enablePlanAria: "Enable plan",
        planActive: "Enabled",
        planPaused: "Paused",
        cancel: "Cancel",
        savePlan: "Save Plan",
      },
      boostConfig: {
        close: "Close",
        title: "Configure Creative Boost",
        subtitle: "Asset: {name} ({id})",
        budgetLabel: "Boost Budget (USD)",
        budgetAria: "Boost Budget",
        durationLabel: "Boost Duration",
        durationAria: "Boost Duration",
        hours6: "6 hours",
        hours12: "12 hours",
        hours24: "24 hours (Recommended)",
        hours48: "48 hours",
        warningTitle: "Boost Information",
        warningDesc: "Once boosted, TikTok algorithms will allocate more exploratory traffic to this asset within the configured duration.",
        cancel: "Cancel",
        startBoost: "Start Boost",
      },
      copyCampaign: {
        close: "Close",
        title: "Copy Campaign",
        subtitle: "Source campaign: {name}",
        copyCountLabel: "Number of Copies",
        copyCountAria: "Number of Copies",
        warningTitle: "Copy Notice",
        warningDesc: "Newly copied campaigns will default to 'Paused' status and inherit the source campaign's product and bid configurations.",
        cancel: "Cancel",
        confirmCopy: "Confirm Copy",
      },
    },
  },
  creativeAssets: {
    boostStatus: { unknown: "Boost status unknown", pending: "Boost status needs updating" },
    authorization: {
      all: "All authorization types", TTS_TT: "TikTok Shop official account", AFFILIATE: "Affiliate mass authorization",
      AUTH_CODE: "Video code authorization", TT_USER: "Business Account authorization", BC_AUTH_TT: "Business Center authorization",
      UNSET: "Unspecified", pending: "Awaiting sync", CONFLICT: "Needs verification", other: "Other authorization",
    },
    boost: {
      active: "Boosting",
      inactive: "Not boosting",
      unknown: "Unknown",
      stale: "Snapshot may be stale",
      syncedAt: "Synced {time}",
    },
    header: {
      title: "Creative Asset Analysis",
      subtitle: "Gain insights into the delivery performance of each creative asset",
      disclaimer: "· Data is for reference only",
      dateBadgeLabel: "Period:",
      howToAddAccount: "How to Add Accounts",
    },
    metrics: {
      ariaLabel: "Creative asset key metrics summary",
      totalSpend: "Total Spend",
      totalSpendDesc: "Creative spend within the selected period, aggregated only for a single known currency.",
      mixedCurrencies: "Currencies differ or are unknown. Spend, revenue, and ROI are not aggregated. Select an advertiser account to view them.",
      totalOrders: "Total Orders",
      totalOrdersDesc: "Total attributed orders generated through promoted creative assets.",
      totalRevenue: "Total Revenue",
      totalRevenueDesc: "Attributed creative GMV, aggregated only for a single known currency.",
      avgCpa: "Average CPA",
      avgCpaDesc: "Average Cost Per Acquisition (Total Spend ÷ Total Orders).",
      avgRoi: "Overall ROI",
      avgRoiDesc: "Comprehensive Return on Investment (Total Revenue ÷ Total Spend).",
      metricDescAria: "Definition for {label}",
    },
    datePresets: {
      today: "Today",
      yesterday: "Yesterday",
      "7days": "Last 7 Days",
      "30days": "Last 30 Days",
      custom: "Custom",
    },
    filterBar: {
      ariaLabel: "Creative assets filters",
      campaign: "Campaign",
      allCampaigns: "All Campaigns",
      campaignMetricsHint: "Filters materials by campaign association. Metrics combine all campaigns for each material in the selected date range.",
      dateLabel: "Date",
      statusLabel: "Status",
      businessCenter: "Business Center",
      allBusinessCenters: "All Business Centers",
      advAccount: "Advertiser Account",
      allAdvAccounts: "All Advertiser Accounts",
      allStatuses: "All Statuses",
      creativeTypeLabel: "Creative Type",
      typeAll: "All creative types",
      typeSelf: "Self-operated",
      typeAffiliate: "Affiliate",
      typeUnknown: "Other / unconfirmed",
      typeProductCard: "Product Card",
      statusActive: "Active",
      statusInactive: "Inactive",
      searchPlaceholder: "Search creator identity / Creative ID…",
      searchAria: "Search creator identity or Creative ID",
      searchSubmit: "Search",
      clearSearchAria: "Clear search",
      clearDateRange: "Clear date range",
      clear: "Clear",
      reset: "Reset filters",
    },
    advancedFilterFields: {
      spend: "Creative Spend",
      orders: "Creative Orders",
      revenue: "Creative Revenue",
      cpa: "Creative CPA",
      roi: "Creative ROI",
      status: "Creative Status",
      impressions: "Creative Impressions",
      clicks: "Creative Clicks",
      ctr: "Product Ad Click Rate (%)",
      adConversionRate: "Creative Conversion Rate",
      videoView2s: "Creative 2s View Rate",
      videoView6s: "Creative 6s View Rate",
      videoViewP25: "Creative 25% View Rate",
      videoViewP50: "Creative 50% View Rate",
      videoViewP75: "Creative 75% View Rate",
      videoViewP100: "Creative Completion Rate",
    },
    table: {
      title: "Material List",
      notice: "Please ensure self-operated TikTok accounts (including official accounts) are linked to Business Center",
      searchResult: "🔍 Searched \"{query}\" and found {count} results",
      colThumb: "Thumb",
      colId: "Material ID",
      colIdStatus: "Material ID",
      colCampaign: "Campaign",
      colStore: "Store",
      campaignNameWithExtra: "{name} +{count}",
      colTrend: "Trend",
      colDeliveryStatus: "Delivery status",
      colCreativeName: "Creative Name",
      colAuthorName: "Author Name",
      colAuthorUsername: "Author Username",
      colPostUrl: "Post URL",
      colPreviewUrl: "Video Preview",
      colVideoCdnUrl: "Video Source URL",
      colVideoId: "Video ID",
      colDuration: "Duration",
      colMetadataError: "Metadata Status",
      colCurrency: "Currency",
      colIdentity: "Identity",
      colType: "Type",
      colBoost: "Boost status",
      colAuthorizationType: "Authorization type",
      colProductImpressions: "Product Impressions",
      colProductClicks: "Product Clicks",
      colSpend: "Spend",
      colOrders: "Orders",
      colRevenue: "Revenue",
      colRoi: "ROI",
      colCpa: "CPA",
      colCtr: "Product Ad Click Rate",
      colConversionRate: "Ad Conversion Rate",
      colP2: "2s View Rate",
      colP6: "6s View Rate",
      colP25: "25% View Rate",
      colP50: "50% View Rate",
      colP75: "75% View Rate",
      colP100: "Completion Rate",
      columnsButton: "Configure Columns",
      columnsTitle: "Visible Fields",
      columnsDescription: "Choose the fields needed for this view",
      columnsReset: "Reset default columns",
      columnGroupBasic: "Basics",
      columnGroupProduct: "Product Engagement",
      columnGroupAdvertising: "Ad Conversion",
      columnGroupVideo: "Video Playback",
      openLink: "Open link",
      noCover: "Cover unavailable",
      copyFailed: "Copy failed. Please copy manually.",
      moreMetrics: "More metrics",
      lessMetrics: "Hide metrics",
      rowMenuAria: "Material actions: {name}",
      btnTrend: "Trend",
      btnPlay: "Play",
      statusDelivering: "Delivering",
      statusDeliveringCount: "Delivering · {count}",
      statusInactive: "Inactive",
      productCardNoVideo: "Product card has no video",
      activeCampaignsTitle: "Active campaigns",
      activeCampaignsCount: "{count}",
      activeCampaignsHint: "Campaigns delivering this creative today",
      inactiveCampaignsTitle: "Delivery status",
      noCampaignsToday: "No campaigns delivering today",
      copyId: "Copy campaign ID",
      copiedId: "Copied",
      copiedToast: "Copied campaign ID: {id}",
      emptyTitle: "No Data Available",
      emptyDescription: "No delivery data recorded yet",
      emptySearchDescription: "Try modifying your search criteria",
      loading: "Loading creatives…",
      refreshing: "Updating data…",
    },
    modals: {
      trend: {
        title: "Creative trend",
        subtitle: "{name} · {type} · {id}",
        close: "Close",
      },
      video: {
        title: "Video Preview",
        loading: "Loading video…",
        unsupported: "Your browser does not support video playback",
        noPreviewUrl: "No video playback URL available",
        loadFailed: "Failed to load video",
        close: "Close",
      },
      guide: {
        title: "How to Add TikTok Accounts to Business Center (BC)",
        subtitle: "Follow these three steps to authorize official and creator accounts under BC so creatives and performance can sync.",
        stepsAria: "Account setup steps",
        close: "Close",
        gotIt: "Got it",
        step1Title: "Log in to TikTok Business Center",
        step1Desc: "Open TikTok for Business, then go to Assets → TikTok Accounts in the left navigation.",
        step2Title: "Request official or creator account authorization",
        step2Desc: "Click Add TikTok Account, choose an authorization mode, and share the QR code or link so the creator or account admin can confirm in the TikTok app.",
        step3Title: "Assign asset permissions to this app",
        step3Desc: "On the TikTok Account asset details page, grant delivery and creative-read access to the workspace member or app connected here.",
        tipTitle: "Important notice",
        tipDesc: "Official accounts and self-operated creator accounts must sit under the same Business Center so GMVMAX campaigns and creative analysis can sync videos and performance in real time.",
      },
    },
  },
  admin: {
    common: { closeDetail: "Close details", query: "Apply", filter: "Filter", platformLevel: "Platform-wide", paginationAria: "Pagination", paginationSummary: "Page {page} of {totalPages}", previousPage: "Previous page", nextPage: "Next page" },
    workspaces: { allStatuses: "All statuses", columnWorkspace: "Workspace", columnOwner: "Owner", columnStatus: "Status", columnMembers: "Members", columnPending: "Pending invitations", title: "Workspaces", total: "{count, plural, one {# Workspace} other {# Workspaces}}", filtersAria: "Workspace filters", searchAria: "Name or Workspace ID", statusAria: "Workspace status", loadFailedTitle: "Unable to load Workspaces", loadFailed: "Workspaces could not be loaded. Please try again later.", updateFailedTitle: "Workspace status update failed", updateFailed: "Workspace status could not be updated. Please try again later.", loading: "Loading Workspaces", tableAria: "Workspace administration list", emptyTitle: "No matching Workspaces", emptyDescription: "Adjust the filters and try again.", detailFallback: "Workspace details", detailLoading: "Loading Workspace details", detailFailedTitle: "Unable to load Workspace details", detailFailed: "Workspace details could not be loaded. Please try again later.", acceptedInvitations: "Accepted invitations", expiredInvitations: "Expired invitations", revokedInvitations: "Revoked invitations", reason: "Reason (5–500 characters)", pause: "Pause Workspace", resume: "Resume Workspace", membersTitle: "Members", membersAria: "Workspace members", noMembers: "No members", historyTitle: "Status history", historyAria: "Workspace status history", noHistory: "No pause or resume history", historyItem: "{date} · {actor}" },
    users: { unnamed: "Unnamed user", allStatuses: "All account statuses", allPlatformRoles: "All platform access", noPlatformRole: "No platform access", allMemberships: "All membership states", joinedMembership: "Assigned to a Workspace", unassignedMembership: "Not assigned to a Workspace", columnUser: "User", columnAuthStatus: "Account status", columnPlatformRole: "Platform access", columnLastSignIn: "Last sign-in", never: "Never", title: "Users", total: "{count, plural, one {# user} other {# users}}", filtersAria: "User filters", searchAria: "Name, email, or UUID", statusAria: "Account status", platformRoleAria: "Platform access", membershipAria: "Workspace membership", loadFailedTitle: "Unable to load users", loadFailed: "Users could not be loaded. Please try again later.", loading: "Loading users", tableAria: "User administration list", emptyTitle: "No matching users", emptyDescription: "Adjust the filters and try again.", detailFallback: "User details", detailLoading: "Loading user details", detailFailedTitle: "Unable to load user details", detailFailed: "User details could not be loaded. Please try again later.", authStatus: "Account status: {status}", membershipsTitle: "Workspace membership", membershipsAria: "User Workspace membership", noMemberships: "No Workspace membership" },
    audit: { allActions: "All actions", allResults: "All results", columnTime: "Time", columnWorkspace: "Workspace", columnAction: "Action", columnResult: "Result", columnActor: "Actor / request ID", title: "Platform activity", total: "{count, plural, one {# record} other {# records}}", filtersAria: "Activity filters", workspaceId: "Workspace ID", workspacePlaceholder: "Enter Workspace ID", actionAria: "Action", resultAria: "Result", startTime: "Start time", endTime: "End time", loadFailedTitle: "Unable to load activity", loadFailed: "Activity records could not be loaded. Please try again later.", loading: "Loading activity", tableAria: "Platform activity log", emptyTitle: "No matching activity", emptyDescription: "Adjust the filters and try again." },
  },
  system: {
    storesFilterTeam: "Team",
    storesFilterAll: "All",
    storesFilterAllTeams: "All teams",
    storesFilterTeamUnassigned: "Unassigned",
    notificationGroupLabel: "Team / group",
    notificationGroupPlaceholder: "All teams",
  },
  assets: {
    filterAll: "All",
  },
  reports: {
    filterDate: "Date range",
    filterSelectedCount: "{count} selected",
    clearDate: "Clear dates",
    datePresetLast7Days: "Last 7 days",
    datePresetLast30Days: "Last 30 days",
    datePresetLastWeek: "Last week",
    datePresetLastMonth: "Last month",
    dashboardPresetToday: "Today",
    dashboardPresetYesterday: "Yesterday",
    siteStatusFilterAll: "All statuses",
    siteStatusFilterActive: "Active",
    siteStatusFilterInactive: "Inactive",
    siteStatusFilterError: "Error",
    siteStatusFilterPartial: "Partial error",
    siteMediaFilterAll: "All media",
    siteMediaFilterApplovin: "AppLovin",
    siteMediaFilterMeta: "Meta",
    siteMediaFilterGoogle: "Google",
    siteMediaFilterTiktok: "TikTok",
    channelFilterAll: "All channels",
    channelFilter: "Channel",
    siteStatusFilter: "Status",
    siteMediaFilter: "Media",
    siteFilterAll: "All sites",
    siteFilter: "Site",
    accountFilter: "Ad account",
    accountFilterAll: "All accounts",
    adAccountDataSearchAria: "Search ad accounts",
    adAccountDataSearchPlaceholder: "Search account name or ID",
    adAccountDataSearchSubmit: "Search",
    teamSummaryGrainByDay: "Daily",
    teamSummaryGrainByWeek: "Weekly",
    teamSummaryGrainByMonth: "Monthly",
    teamSummaryGrainByYear: "Yearly",
    teamSummaryGrainAria: "Time grain",
  },
  products: {
    categoryAll: "All categories",
    filterCategory: "Category",
    filterCreatedDate: "Created date",
    clearCreatedDate: "Clear created date",
    filterCollapse: "Collapse filters",
    filterExpand: "Expand filters",
    activeFiltersCount: "{count} active filter(s)",
    columns: "Columns",
    columnVisibility: "Customize table columns",
    imagePreviewAria: "Preview image: {title}",
    videoPreviewAria: "Play video: {title}",
  },
  media: {
    filterSearch: "Search materials",
    filterSize: "Size",
    filterType: "Type",
    filterTags: "Tags",
  },
  orders: {
    filterShop: "Store",
    filterTeam: "Team",
    filterStatus: "Status",
    allShops: "All stores",
    allTeams: "All teams",
    allStatuses: "All statuses",
  },
} satisfies MessageShape<typeof zhCN>;

export const messages = {
  "en-US": enUS,
  "zh-CN": zhCN,
} satisfies Record<AppLocale, MessageShape<typeof zhCN>>;

export type AppMessages = MessageShape<typeof zhCN>;
